var utils = require('./tripletrax.utils.js');
var initialize = require('./tripletrax.initialize.js');
var ajax = require('./tripletrax.ajax.js');
var access = require('./tripletrax.access.js');
var patients = require('./tripletrax.patients.js');
var validator = require('./tripletrax.validator.js');
var changes = require('./tripletrax.changes.js');

function registerViewEvents() {

    $('body').on('keypress', '.tt-view-input,.datepicker', function (e) {
        if(e.keyCode == 13){
            e.preventDefault();

            $(this).emulateTab();
        }
    });

    // Combo Multiselect - Bei Auswahl Unbekannt oder Nicht erhoben müssen die restlich ausgewählten wieder gelöscht werden
    $('body').on('select2:select', '.tt-combo-multiselect', function (e) {

		if (!utils.isUndefined(e.params.data) && (
            (!utils.isUndefined($(e.params.data.element).data().match) && ($(e.params.data.element).data().match === 'unknown' || $(e.params.data.element).data().match === 'not_collected' || $(e.params.data.element).data().match === 'is_global_facility')) ||
            (!utils.isUndefined($(e.params.data.element).data().data.match) && ($(e.params.data.element).data().data.match === 'unknown' || $(e.params.data.element).data().data.match === 'not_collected' || $(e.params.data.element).data().data.match === 'is_global_facility')))) {
			$(this).val([e.params.data.id]).trigger('change.select2');
		} else {
			var select_array = [];
			jQuery.each($(this).select2('data'), function (i, val) {
				if ($(val.element).data().match !== 'unknown' && $(val.element).data().match !== 'not_collected' && $(val.element).data().match !== 'is_global_facility' && $(val.element).data().data.match !== 'unknown' && $(val.element).data().data.match !== 'not_collected' && $(val.element).data().data.match !== 'is_global_facility') {
					select_array.push(val.id);
				}
			});
			$(this).val(select_array).trigger('change.select2');
		}
	});

	$('body').on('select2:select', '.tt-view-combo-multiselect', function (e) {
		var element = $(this);

		if (!utils.isUndefined(e.params.data) && (
			(!utils.isUndefined($(e.params.data.element).data().match) && ($(e.params.data.element).data().match === 'unknown' || $(e.params.data.element).data().match === 'not_collected')) ||
			(!utils.isUndefined($(e.params.data.element).data().data.match) && ($(e.params.data.element).data().data.match === 'unknown' || $(e.params.data.element).data().data.match === 'not_collected')))) {
			jQuery.each($(this).select2('data'), function (i, val) {
				if (((!utils.isUndefined($(val.element).data().activation) && $(val.element).data().activation === 1) || (!utils.isUndefined($(val.element).data().data.activation) && $(val.element).data().data.activation === 1)) && val.id !== e.params.data.id) {
					setSubControlsEnabled(element, false);
				}
			});
			$(this).val([e.params.data.id]).trigger('change.select2');
		} else {
			var select_array = [];
			jQuery.each($(this).select2('data'), function (i, val) {
				if ($(val.element).data().match !== 'unknown' && $(val.element).data().match !== 'not_collected' && $(val.element).data().data.match !== 'unknown' && $(val.element).data().data.match !== 'not_collected') {
					select_array.push(val.id);
				}
			});
			$(this).val(select_array).trigger('change.select2');
		}

		if (!utils.isUndefined(e.params.data) && (
			(!utils.isUndefined($(e.params.data.element).data().activation) && ($(e.params.data.element).data().activation === 1)) ||
			(!utils.isUndefined($(e.params.data.element).data().data.activation) && ($(e.params.data.element).data().data.activation === 1)))) {

			setSubControlsEnabled($(this), true);
		}

		setFormDataForAjaxCall($($(this).parents('.tab-pane')[0]), true, true);
		var formData = getFormDataForAjaxCall(true, true, false);
		equalizeControls($(this), true, formData);
		setMasterOverviewValues($(this));
		if (checkRights($(this)) && checkPrimaryKey($(this))) {
			addToIntegrityList([$(this)], true, false);
		}
		calculateValues([$(this)], true, formData);
		setCompleteness($(this), formData);
	});

	$('body').on('select2:unselect', '.tt-view-combo-multiselect', function (e) {
		var element = $(this);

		if (!utils.isUndefined(e.params.data) && (
			(!utils.isUndefined($(e.params.data.element).data().activation) && ($(e.params.data.element).data().activation === 1)) ||
			(!utils.isUndefined($(e.params.data.element).data().data.activation) && ($(e.params.data.element).data().data.activation === 1)))) {
			setSubControlsEnabled($(this), false);
		}

		setFormDataForAjaxCall($($(this).parents('.tab-pane')[0]), true, true);
		var formData = getFormDataForAjaxCall(true, true, false);
		equalizeControls($(this), true, formData);
		setMasterOverviewValues($(this));
		if (checkRights($(this)) && checkPrimaryKey($(this))) {
			addToIntegrityList([$(this)], true, false);
		}
		calculateValues([$(this)], true, formData);
		setCompleteness($(this), formData);
	});

	// Zusatzfelder en- oder disablen bei Combo
	$('body').on('select2:select', '.tt-view-combo:not(.tt-sub-control)', function (e) {

		if (!utils.isUndefined(e.params.data) && (
			(!utils.isUndefined($(e.params.data.element).data().activation) && ($(e.params.data.element).data().activation === 1)) ||
			(!utils.isUndefined($(e.params.data.element).data().data.activation) && ($(e.params.data.element).data().data.activation === 1)))) {
			setSubControlsEnabled($(this), true);
		} else if (!utils.isUndefined(e.params.data) && (
			(!utils.isUndefined($(e.params.data.element).data().activation) && ($(e.params.data.element).data().activation !== 1)) ||
			(!utils.isUndefined($(e.params.data.element).data().data.activation) && ($(e.params.data.element).data().data.activation !== 1)))) {
			utils.GLOBALS.subControlsList.length = 0;
			setSubControlsEnabledWithResetOption($(this), false, true, true);
			doIntegrityCheckCalculationAndCompletenessForSubControlList(false, $(this));
		}
	});

	// Zusatzfelder en- oder disablen bei Combo
	$('body').on('select2:unselect', '.tt-view-combo:not(.tt-sub-control)', function (e) {

		if (!utils.isUndefined(e.params.data) && (
			(!utils.isUndefined($(e.params.data.element).data().activation) && ($(e.params.data.element).data().activation === 1)) ||
			(!utils.isUndefined($(e.params.data.element).data().data.activation) && ($(e.params.data.element).data().data.activation === 1)))) {
			utils.GLOBALS.subControlsList.length = 0;
			setSubControlsEnabledWithResetOption($(this), false, true, true);
			doIntegrityCheckCalculationAndCompletenessForSubControlList(false, $(this));
		}
	});

    // Zusatzfelder en- oder disablen bei Checkbox
    $('body').on('change', '.tt-view-checkbox:not(.tt-sub-control)', function (e) {

        utils.GLOBALS.subControlsList.length = 0;
        setSubControlsEnabledForCheckBox($(this), true, true);
        doIntegrityCheckCalculationAndCompletenessForSubControlList(false, $(this));
    });

    // Zusatzfelder en- oder disablen bei RadioButtons
    $('body').on('change', '.tt-view-radio:not(.tt-sub-control)', function (e) {

        utils.GLOBALS.subControlsList.length = 0;
        setSubControlsEnabledForRadioButton($(this), true, true, true);
        doIntegrityCheckCalculationAndCompletenessForSubControlList(false, $(this));
    });

    // Wert vor Änderung speichern und Integritätsregel nur dann aufrufen, wenn sich der Wert geändert hat
    $('body').on('focusin', '.tt-view-input,.tt-view-textarea', function (e) {

        $(this).data().previousValue = $(this).val();
    });

    // Wert vor Änderung speichern und Integritätsregel nur dann aufrufen, wenn sich der Wert geändert hat
    $('body').on('focusin', '.tt-view-datepanel,.datepicker', function (e) {

        var element = $(this);
        if ($(this).hasClass('tt-view-datepanel')) {
            if ($(this).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') === '') {
                $(this).data().previousValue = null;
            } else {
                $(this).data().previousValue = $(this).data('picker').getDate();
            }
            $(this).data().previousFormatValue = utils.getValueFromInputWithDropDownField($(this));
        }
        setTimeout(function() {
            if ($(element).is(":focus")) {
                element.caret(0, element.val().length);
            }
        }, 100);
    });

    // Integritätsregeln beachten bei InputFeldern
    $('body').on('blur', '.tt-view-input,.tt-view-textarea', function (e) {
        if (utils.isUndefined($(this).data().previousValue) || $(this).val() !== $(this).data().previousValue) {
            setFormDataForAjaxCall($($(this).parents('.tab-pane')[0]), true, true);
            var formData = getFormDataForAjaxCall(true, true, false);
            equalizeControls($(this), true, formData);
            setMasterOverviewValues($(this));
            if (checkRights($(this)) && checkPrimaryKey($(this))) {
                addToIntegrityList([$(this)], true, false);
            }
            calculateValues([$(this)], true, formData);
            setCompleteness($(this), formData);
        }
    });

    // Integritätsregeln beachten bei DatePanels
    $('body').on('blur', '.tt-view-datepanel,.datepicker', function (e) {

		if (!utils.GLOBALS.programmaticClick) {
			blurDatepicker(this);
		}
    });

    // Integritätsregeln beachten bei Formatänderung
    $('body').on('changeFormat', '.tt-view-input-label .tt-select-value,.tt-view-input-label .tt-select-not-collected,.tt-view-input-label .tt-select-unknown,.tt-view-input-label .tt-select-not-measurable,.tt-view-input-label .tt-select-unknown,.tt-view-input-label .tt-select-continuing,.tt-view-input-label .tt-select-date-full,.tt-view-input-label .tt-select-date-month-year,.tt-view-input-label .tt-select-date-year', function (e) {

        if ($(this).parents('.tt-view-input-label').find('input').hasClass('tt-view-datepanel')) {
            validator.triggerValidation($(this).parents('.tt-view-input-label').find('input')[0], false, true);
        }
        setFormDataForAjaxCall($($(this).parents('.tab-pane')[0]), true, true);
        var formData = getFormDataForAjaxCall(true, true, false);
        $(this).parents('.tt-view-input-label').find('input').focus();
        equalizeControls($(this).parents('.tt-view-input-label').find('input'), true, formData);
        setMasterOverviewValues($(this).parents('.tt-view-input-label').find('input'));
        if (checkRights($(this).parents('.tt-view-input-label').find('input')) && checkPrimaryKey($(this).parents('.tt-view-input-label').find('input'))) {
            addToIntegrityList([$(this).parents('.tt-view-input-label').find('input')], true, false);
        }
        calculateValues([$(this).parents('.tt-view-input-label').find('input')], true, formData);
        setCompleteness($(this).parents('.tt-view-input-label').find('input'), formData);
    });

    // Integritätsregeln beachten bei RadioButtons, Checkboxen und ComboBoxen
    $('body').on('change', '.tt-view-radio,.tt-view-checkbox,.tt-view-combo', function (e) {

        if ($(this).hasClass('tt-view-radio') && $(this).is(':checked')) {
            setCaveLabel($(this), $(this).data());
        } else if ($(this).hasClass('tt-view-combo')) {
            if ($(this).select2('val') === '') {
                resetCaveLabel($(this));
            } else {
                var option = $(this).select2('data')[0];
                setCaveLabel($(this), $(option.element).data());
            }
        }

        setFormDataForAjaxCall($($(this).parents('.tab-pane,.tt-show-questionnaires')[0]), true, true);
        var formData = getFormDataForAjaxCall(true, true, false);
        equalizeControls($(this), true, formData);
        setMasterOverviewValues($(this));
        if (checkRights($(this)) && checkPrimaryKey($(this))) {
            addToIntegrityList([$(this)], true, false);
        }
        calculateValues([$(this)], true, formData);
        setCompleteness($(this), formData);
    });

    // Tooltip für Buttons aktivieren bei Anzeige Popover
    $('body').on('shown.bs.popover', '[rel="popover"]', function(e) {
        $(this).parent().find('.popover').find('.btn').tooltip();
    });

    // Combo / Combo Multiselect - Inaktive Werte können nicht gewählt werden.
    $('body').on('select2:selecting', '.tt-view-combo-multiselect,.tt-view-combo', function (e) {

        if ($(e.params.args.data.element).data().inactive) {
            e.preventDefault();
        }
    });

    // Akkordeon mit Wiederholungsgruppe - Gruppe hinzufügen
    $('body').on('click', '.tt-add-accordion-group', function (e) {
        e.preventDefault();

        addAccordionGroup($(this).parents('.tt-accordion'), 0, true, true, true, false);
    });

    // Akkordeon mit Wiederholungsgruppe - Gruppe löschen
    $('body').on('click', '.tt-delete-accordion-group', function (e) {
        e.preventDefault();

        var $openAccordionPanel = $(this).parents('.tt-accordion').find('.collapse.in');
        if ($openAccordionPanel.length) {
            $openAccordionPanel.parent().remove();
            $(this).addClass('disabled');
            $($(this).parents('form')[0]).addClass('dirty');

            setFormDataForAjaxCall($($(this).parents('.tab-pane')[0]), true, true);
            setCompleteness(null);
        }
    });

    // Akkordeon mit Wiederholungsgruppe - Löschen Button aktiv / inaktiv setzen
    $('body').on('shown.bs.collapse hidden.bs.collapse', '.tt-accordion-panel', function (e) {
        e.preventDefault();

        var $openAccordionPanel = $(this).parents('.tt-accordion').find('.collapse.in');
        if ($openAccordionPanel.length) {
            if (!$(this).parents('.tt-accordion').find('.tt-delete-accordion-group').hasClass('no-rights')) {
                $(this).parents('.tt-accordion').find('.tt-delete-accordion-group').removeClass('disabled');
            }
        } else {
            $(this).parents('.tt-accordion').find('.tt-delete-accordion-group').addClass('disabled');
        }
    });

    // Liste - Eintrag hinzufügen
    $('body').on('click', '.tt-add-list-item', function (e) {
        e.preventDefault();

        addListEntry($(this).parents('.tt-content-datatable').find('table'), 0, null, true, true, false);
    });

    // Liste - Eintrag löschen
    $('body').on('click', '.tt-delete-list-item', function (e) {
        e.preventDefault();

        var table = $(this).parents('.tt-content-datatable').find('table').dataTable();
        table.fnDeleteRow($(this).parents('.tt-content-datatable').find('.tt-selected-pos').val());

        $(this).addClass('disabled');
        $($(this).parents('form')[0]).addClass('dirty');

        setFormDataForAjaxCall($($(this).parents('.tab-pane')[0]), true, true);
        setCompleteness(null);
    });

    // Alle zugehörigen Werte auf 'Keine Komplikationen' setzen
    $('body').on('click', '.tt-no-complications', function (e) {
        e.preventDefault();

        utils.GLOBALS.subControlsList.length = 0;
        jQuery.each($($(this).parents('.row')[0]).parent().find('[data-no-complications]'), function (i, element) {

            if ($(element).data().noComplications !== '' || $(element).data().noComplicationsFormat !== '') {

                if (((access.getRight($(element), 'write') > 0 && !utils.isUndefined($(element)[0].dataset) && (utils.isUndefined($(element)[0].dataset.initValue) || $(element)[0].dataset.initValue === ''))
                        || (access.getRight($(element), 'update') > 0 && !utils.isUndefined($(element)[0].dataset) && !utils.isUndefined($(element)[0].dataset.initValue) && $(element)[0].dataset.initValue !== ''))
                    && hasParentControlActivationOptionChecked($(element))) {
                    setControlValue($(element), $(element).data().noComplications, $(element).data().noComplicationsFormat, '', false, true);
                }
            }
        });
        $($(this).parents('form')[0]).trigger('rescan.areYouSure');
        //console.log(utils.GLOBALS.subControlsList.length);
        doIntegrityCheckCalculationAndCompletenessForSubControlList(true);
    });

    // Alle zugehörigen Werte auf 'Keine Komplikationen' setzen, wenn mindestens ein Eintrag bereits mit 'positiv/pathologisch' dokumentiert ist
    $('body').on('click', '.tt-no-complications-one-active', function (e) {
        e.preventDefault();

        utils.GLOBALS.subControlsList.length = 0;

        // ermitteln, ob mindestens ein Wert mit positiv/pathologisch dokumentiert ist
        // => kann nur bei Comboboxen, Mehrfachauswahlen und Radiobuttons eingestellt werden
        var positiveValueExisting = false;
        jQuery.each($($(this).parents('.row')[0]).parent().find('[data-no-complications]'), function (i, element) {

            if ($(element).hasClass('tt-view-combo-multiselect')) {
                if (!utils.isUndefined($(element).select2('data'))) {
                    jQuery.each($(element).select2('data'), function (k, val) {
                        if (!utils.isUndefined($(val.element).data().match) && $(val.element).data().match === 'positive') {
                            positiveValueExisting = true;
                            return false;
                        }
                    });
                    if (positiveValueExisting) {
                        return false;
                    }
                }
            } else if ($(element).hasClass('tt-view-combo')) {
                if (!utils.isUndefined($(element).select2('data'))) {
                    if (!utils.isUndefined($($(element).select2('data')[0].element).data().match) && $($(element).select2('data')[0].element).data().match === 'positive') {
                        positiveValueExisting = true;
                        return false;
                    }
                }
            } else if ($(element).is(':radio') && $(element).prop('checked') && $(element).data().match === 'positive') {
                positiveValueExisting = true;
                return false;
            }
        });

        // Werte für die fehlenden Felder auf 'Keine Komplikationen' setzen, wenn mindestens ein Eintrag mit positiv/pathologisch dokumentiert ist
        if (positiveValueExisting) {
            jQuery.each($($(this).parents('.row')[0]).parent().find('[data-no-complications]'), function (i, element) {

                if ($(element).data().noComplications !== '' || $(element).data().noComplicationsFormat !== '') {

                    var emptyValue = true;
                    if ($(element).hasClass('tt-view-combo-multiselect') || $(element).hasClass('tt-view-combo')) {
                        emptyValue = (getControlValue($(element)) === '');
                    } else if ($(element).is(':radio')) {
                        jQuery.each($(element).parents('.inline-group').find('.tt-view-radio'), function (j, radio) {
                            if (emptyValue) {
                                emptyValue = (getControlValue($(radio)) === '');
                            }
                        });
                    } else if ($(element).is(':checkbox')) {
                        emptyValue = (getControlValue($(element)) !== 'true');
                    } else {
                        emptyValue = (getControlValue($(element)).split('=')[0] === '');
                    }

                    if (emptyValue) {
                        if (((access.getRight($(element), 'write') > 0 && !utils.isUndefined($(element)[0].dataset) && (utils.isUndefined($(element)[0].dataset.initValue) || $(element)[0].dataset.initValue === ''))
                                || (access.getRight($(element), 'update') > 0 && !utils.isUndefined($(element)[0].dataset) && !utils.isUndefined($(element)[0].dataset.initValue) && $(element)[0].dataset.initValue !== ''))
                            && hasParentControlActivationOptionChecked($(element))) {
                            setControlValue($(element), $(element).data().noComplications, $(element).data().noComplicationsFormat, '', false, true);
                        }
                    }
                }
            });
            $($(this).parents('form')[0]).trigger('rescan.areYouSure');
            //console.log(utils.GLOBALS.subControlsList.length);
            doIntegrityCheckCalculationAndCompletenessForSubControlList(true);
        } else {
            $.SmartMessageBox({
                title: "<i class='fad fa-exclamation txt-color-orangeDark'></i>  <span class='txt-color-orangeDark'><strong>" + Lang.get('tripletrax.assume_no_complications_one_active_title') + "</strong></span>",
                content: Lang.get('tripletrax.assume_no_complications_one_active_desc'),
                buttons: '[' + Lang.get('tripletrax.ok') + ']'
            }, function (ButtonPressed) {
            });
        }
    });

    // Alle zugehörigen Werte auf 'Nicht Erhoben' setzen
    $('body').on('click', '.tt-not-collected', function (e) {
        e.preventDefault();

        utils.GLOBALS.subControlsList.length = 0;
        jQuery.each($($(this).parents('.row')[0]).parent().find('[data-not-collected]'), function (i, element) {

            if ($(element).data().notCollected !== '' || $(element).data().notCollectedFormat !== '') {

                if (((access.getRight($(element), 'write') > 0 && !utils.isUndefined($(element)[0].dataset) && (utils.isUndefined($(element)[0].dataset.initValue) || $(element)[0].dataset.initValue === ''))
                        || (access.getRight($(element), 'update') > 0 && !utils.isUndefined($(element)[0].dataset) && !utils.isUndefined($(element)[0].dataset.initValue) && $(element)[0].dataset.initValue !== ''))
                    && hasParentControlActivationOptionChecked($(element))) {
                    setControlValue($(element), $(element).data().notCollected, $(element).data().notCollectedFormat, '', false, true);
                }
            }
        });
        $($(this).parents('form')[0]).trigger('rescan.areYouSure');
        doIntegrityCheckCalculationAndCompletenessForSubControlList(true);
    });

    // Vordaten übernehmen
    $('body').on('click', '.tt-assume-previous-data', function (e) {
        e.preventDefault();

        var button = $(this);
        var previousExaminationData = $('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-examination-id').data('previous_examination_data');
        if (previousExaminationData === '') {

            $('.tt-assume-previous-data').popover('destroy');

            ajax.ajaxCall('doc/patient/patient/previousexamination/' + getExaminationDate() + '/facility/' + getFacilityId() + '/model/' + getModelId() + '/patient/' + getPatientId(), 'POST', getFormDataForAjaxCall(true, false, false), false, function (data) {

                if (data === '') {
                    data = 'not_existing';
                }
                $('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-examination-id').data('previous_examination_data', data);
                if (utils.isUndefined(button.data('bs.popover'))) {
                    button.attr('data-content', getPreviousExaminationDataForm(button, data, 1, 8, 1));
                    button.popover({
                        animation: false,
                        template: '<div class="popover" role="tooltip" style="min-width: 450px;"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
                    });
                }
                button.popover('show');
            });
        } else {
            if (utils.isUndefined(button.data('bs.popover'))) {
                button.attr('data-content', getPreviousExaminationDataForm(button, previousExaminationData, 1, 8, 1));
                button.popover({
                    animation: false,
                    template: '<div class="popover" role="tooltip" style="min-width: 450px;"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
                });
            }
            button.popover('show');
        }
    });

    // Vordaten übernehmen - Einzelnes Feld an- oder abhaken
    $('body').on('change', '.tt-previous-examinationdata-field', function (e) {
        e.preventDefault();

        var previousExaminationData = $(this).parents('form').find('.tt-previous-examinationdata-items').data('previousExaminationdataItems');
        var value = previousExaminationData[$(this).data('name')];
        var splittedValue = value.split('#');
        splittedValue[2] = $(this).is('checked') ? '1' : '0';
        previousExaminationData[$(this).data('name')] = splittedValue.join('|');
        $(this).parents('form').find('.tt-previous-examinationdata-items').data('previousExaminationdataItems', previousExaminationData);
    });

    // Integritätsregel - Wert bestätigen
    $('body').on('click', '.tt-confirm-value', function (e) {
        e.preventDefault();

        // Alle Elemente mit gleichem Namen zurücksetzen
        jQuery.each($('[name="' + $(this).parents('.popover').parent().find('[name]').attr('name') + '"]'), function(i, element) {
            resetControl($(element), false);
            $(element).attr('data-confirmed', true);
            $(element).parents('form').addClass('dirty');
            setFormDataForAjaxCall($($(element).parents('.tab-pane')[0]), true, true);
        });
    });

    // Integritätsregel - Abbruch
    $('body').on('click', '.tt-cancel-confirm', function (e) {
        e.preventDefault();

        $(this).parents('.popover').prev().popover('hide');

        if ($(this).parents('.popover').next().hasClass('tt-view-combo-multiselect') || $(this).parents('.popover').next().hasClass('tt-view-combo')) {
            $(this).parents('.popover').parent().find('.tt-btn-warning').removeClass('hide');
        } else if ($($(this).parents('.popover').prev()[0]).hasClass('checkbox')) {
            $(this).parents('.popover').parent().find('.tt-btn-warning').removeClass('hide');
        } else if ($(this).parents('.popover').prev().hasClass('tt-radio'))  {
            if ($(this).parents('.popover').parent().hasClass('col')) {
                $(this).parents('.popover').parent().parent().prev().find('.tt-btn-warning').removeClass('hide');
            } else if ($(this).parents('.popover').parent().parent().hasClass('tt-radio-column') || $(this).parents('.popover').parent().parent().hasClass('tt-radio-accordion') || $(this).parents('.popover').parent().parent().hasClass('tt-radio-list')) {
                $(this).parents('.popover').parent().parent().parent().find('.tt-btn-warning').removeClass('hide');
            } else {
                $(this).parents('.popover').parent().prev().find('.tt-btn-warning').removeClass('hide');
            }
        } else {
            if ($(this).parents('.popover').parent().find('input').hasClass('tt-additional-field')) {
                $(this).parents('.popover').parent().prev().prev().find('.tt-btn-warning').removeClass('hide');
            } else {
                $(this).parents('.popover').parent().prev().find('.tt-btn-warning').removeClass('hide');
            }
        }
    });

    // Hinweis Integrität wieder anzeigen
    $('body').on('click', '.tt-btn-warning', function (e) {
        e.preventDefault();

        $($(this).parent().parent().find('[data-integrity-popover]')[0]).popover('show');
    });

    // Zu fehlendem Feld springen
    $('body').on('click', '.tt-btn-completeness,.dd-btn-completeness', function (e) {

        var controlName = $(this).data().completenessFieldName;
        var tableType = $(this).data().completenessTableType;
        var tableName = $(this).data().completenessTableName;

        if ($(this).hasClass('dd-btn-completeness')) {
            // Untersuchung wechseln
            if ($(this).parents('.tt-completeness-course-list').length) {
				utils.updateGlobals('completenessToShow', controlName);
				utils.updateGlobals('completenessToShowTableType', tableType);
				utils.updateGlobals('completenessToShowTableName', tableName);
				$('[href="#content-detail-course"]').click();
				changes.setSelectedExamination(true, $(this).parents('.tt-completeness-course-list').data().examinationId);
            } else {
				$('#content-detail-master,#content-detail-course').find('.tt-btn-missing-field .fa-edit:not(.tt-pulsate),.tt-completeness-tab-icon .fa-edit:not(.tt-pulsate),.tt-completeness-tab-icon-missing-all .fa-minus:not(.tt-pulsate)').each(function () {
					$(this).pulsate({
						color: '#DB4A67',
						glow: true,
						speed: 1000,
						pause: 1000,
						reach: 5
					});
					$(this).addClass('tt-pulsate');
				});
				$('.tt-back-to-completeness-button').parent().removeClass('hide');
				validator.goToControl(controlName, tableType, tableName);
			}
        } else {
			$(this).parents('.popover').prev().popover('hide');
			validator.goToControl(controlName, tableType, tableName);
        }
    });

    // Focus setzen nachdem Tab geladen wurde
    $('body').on('shown.bs.tab', function (e) {

        if (!utils.isUndefined(utils.GLOBALS.controlNameForFocus)) {
            var controlName = utils.GLOBALS.controlNameForFocus;
            if (!utils.isUndefined(utils.GLOBALS.tableNameForFocus) && !utils.isUndefined(utils.GLOBALS.controlTabPaneId) && utils.GLOBALS.controlTabPaneId === $(e.target).attr('href').substr(1)) {
                var tableName = utils.GLOBALS.tableNameForFocus;
                var controlTabPaneId = utils.GLOBALS.controlTabPaneId;
                var parentControl = $('#' + utils.GLOBALS.parentControlForFocus);

                showTab($(e.target), controlName, parentControl, tableName);

                utils.updateGlobals('controlNameForFocus', null);
                utils.updateGlobals('tableNameForFocus', null);
                utils.updateGlobals('parentControlForFocus', null);
                utils.updateGlobals('controlTabPaneId', null);
            }
        }
    });

    // Wert löschen
    $('body').on('click', '.tt-btn-eraser', function (e) {

        var format = '';
        var control = $($(this).parents('section')[0]).find('[name="' + this.dataset.control + '"]');
        if ((control.hasClass('tt-view-input') || control.hasClass('tt-view-datepanel')) && !utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.defaultFormatValue)) {
            format = control[0].dataset.defaultFormatValue;
        } else if (control.is(':radio')) {
            control = $($(this).parents('section')[0]).find('[name="' + this.dataset.control + '"]:checked');
        }
        if (control.length) {
            utils.GLOBALS.subControlsList.length = 0;
            setControlValue(control, null, format, '', false, true);
            if (control.hasClass('tt-view-datepanel')) {
                validator.triggerValidation(control[0], false, true);
            }
            $($(control).parents('form')[0]).trigger('checkform.areYouSure');
            doIntegrityCheckCalculationAndCompletenessForSubControlList(true);
        }
    });

    // Untersuchungsdatum übernehmen
    $('body').on('click', '.tt-btn-assume-examination-date', function (e) {

        var format = '';
        var control = $($(this).parents('section')[0]).find('[name="' + this.dataset.control + '"]');
        if ((control.hasClass('tt-view-input') || control.hasClass('tt-view-datepanel')) && !utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.defaultFormatValue)) {
            format = control[0].dataset.defaultFormatValue;
        }
        if (control.length) {
            utils.GLOBALS.subControlsList.length = 0;
            setControlValue(control, getExaminationDate(), format, '', false, true);
            if (control.hasClass('tt-view-datepanel')) {
                validator.triggerValidation(control[0], false, true);
            }
            $($(control).parents('form')[0]).trigger('checkform.areYouSure');
            doIntegrityCheckCalculationAndCompletenessForSubControlList(true);
        }
    });

    // Bearbeitung aktivieren
    $('body').on('click', '.tt-btn-unlock-for-editing', function (e) {
        e.preventDefault();

        var control = $($(this).parents('section')[0]).find('[name="' + this.dataset.control + '"]');

        if ((access.getRight($(this), 'write') > 0 && !utils.isUndefined(control[0].dataset) && (utils.isUndefined(control[0].dataset.initValue) || control[0].dataset.initValue === ''))
            || (access.getRight($(this), 'update') > 0 && !utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== '')) {
            setControlEnabled(control, true, true, false, true, true);
            $(this).find('i').removeClass('fa-lock').addClass('fa-unlock');
            if (control.hasClass('tt-view-input') || control.hasClass('tt-view-datepanel')) {
                if (control.parents('.tt-view-input-label').find('button.tt-unlock-for-editing').length) {
                    setControlEnabled(control.parents('.tt-view-input-label').find('button.tt-unlock-for-editing'), true, true, false, true, false);
                }
            }
        }

        if (access.getRight($(this), 'delete') > 0) {
            var buttonControl = $(this).parent().find('.tt-btn-eraser');
            setControlEnabled(buttonControl, true, true, false, true, false);
            $(this).find('i').removeClass('fa-lock').addClass('fa-unlock');
        }

        if ((access.getRight($(this), 'write') > 0 && !utils.isUndefined(control[0].dataset) && (utils.isUndefined(control[0].dataset.initValue) || control[0].dataset.initValue === ''))
            || (access.getRight($(this), 'update') > 0 && !utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== '')) {
            var buttonAssumeExaminationDateControl = $(this).parent().find('.tt-btn-assume-examination-date');
            if (buttonAssumeExaminationDateControl.length) {
                setControlEnabled(buttonAssumeExaminationDateControl, true, true, false, true, false);
            }
            $(this).find('i').removeClass('fa-lock').addClass('fa-unlock');
        }
    });

    // Vollständigkeitsanzeige / Vordaten übernehmen - zur nächsten / vorigen Seite springen
    $('body').on('click', '.tt-completeness-pagination,.tt-previous-examination-pagination', function (e) {
        e.preventDefault();
        if ($(this).parent().hasClass('active')) {
            return;
        }

        var pageCount = 8;
        var newPage = 0;
        var countPages = 0;
        if ($(this).hasClass('tt-completeness-pagination')) {
            var completenessData = $(this).parents('form').data().completenessItems;
            var optionalData = completenessData.split('$');
            var completenessItems = optionalData[0].split('|').filter(function(e){return e});
            var completenessItemsOptional = [];
            if (optionalData.length > 1) {
                completenessItemsOptional = optionalData[1].split('|').filter(function (e) {return e});
            }
            countPages = (completenessItems.length - (completenessItems.length % pageCount)) / pageCount;
            if (completenessItems.length % pageCount > 0) {
                countPages++;
            }
        } else if ($(this).hasClass('tt-previous-examination-pagination')) {
            var previousExaminationData = $(this).parents('form').find('.tt-previous-examinationdata-items').data('previousExaminationdataItems');
            countPages = (Object.keys(previousExaminationData).length - (Object.keys(previousExaminationData).length % pageCount)) / pageCount;
            if (Object.keys(previousExaminationData).length % pageCount > 0) {
                countPages++;
            }
        }

        var currentPage = parseInt($(this).parents('.pagination').find('li.active').find('a')[0].dataset.pagination);
        $(this).parents('.pagination').find('li').removeClass('active');
        if ($(this)[0].dataset.pagination === 'previous') {
            newPage = currentPage - 1;
            if ($(this).parents('.pagination').find('[data-pagination="' + newPage + '"]').length === 0) {
                jQuery.each($(this).parents('.pagination').find('[data-pagination]'), function(i, element) {
                    if ($(element)[0].dataset.pagination !== 'previous' && $(element)[0].dataset.pagination !== 'next') {
                        var newPageCount = parseInt($(element)[0].dataset.pagination) - 1;
                        $(element).attr('data-pagination', newPageCount);
                        $(element)[0].dataset.pagination = newPageCount;
                        $(element).text(newPageCount);
                    }
                });
            }
        } else if ($(this)[0].dataset.pagination === 'next') {
            newPage = currentPage + 1;
            if ($(this).parents('.pagination').find('[data-pagination="' + newPage + '"]').length === 0) {
                jQuery.each($(this).parents('.pagination').find('[data-pagination]'), function(i, element) {
                    if ($(element)[0].dataset.pagination !== 'previous' && $(element)[0].dataset.pagination !== 'next') {
                        var newPageCount = parseInt($(element)[0].dataset.pagination) + 1;
                        $(element).attr('data-pagination', newPageCount);
                        $(element)[0].dataset.pagination = newPageCount;
                        $(element).text(newPageCount);
                    }
                });
            }
        } else {
            newPage = parseInt($(this)[0].dataset.pagination);
        }

        $(this).parents('.pagination').find('[data-pagination="' + newPage + '"]').parent().addClass('active');

        if (newPage === 1) {
            $(this).parents('.pagination').find('[data-pagination="previous"]').attr('disabled', 'disabled');
            $(this).parents('.pagination').find('[data-pagination="next"]').removeAttr('disabled');
        } else if (newPage === countPages) {
            $(this).parents('.pagination').find('[data-pagination="previous"]').removeAttr('disabled');
            $(this).parents('.pagination').find('[data-pagination="next"]').attr('disabled', 'disabled');
        } else {
            $(this).parents('.pagination').find('[data-pagination="previous"]').removeAttr('disabled');
            $(this).parents('.pagination').find('[data-pagination="next"]').removeAttr('disabled');
        }

        if ($(this).hasClass('tt-completeness-pagination')) {
            $(this).parents('.popover').prev().attr('data-content', getCompletenessForm(completenessData, newPage, pageCount, parseInt($(this).parents('.pagination').find('[data-pagination]')[1].dataset.pagination)));
            utils.setHtmlData($(this).parents('form').find('.tt-completeness-items'), getCompletenessItems(completenessItems, completenessItemsOptional, newPage, pageCount), false);
        } else if ($(this).hasClass('tt-previous-examination-pagination')) {
            $(this).parents('.popover').prev().attr('data-content', getPreviousExaminationDataForm($(this).parents('.popover').prev(), previousExaminationData, newPage, pageCount, parseInt($(this).parents('.pagination').find('[data-pagination]')[1].dataset.pagination)));
            var allPreviousExaminationData = $('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-examination-id').data('previous_examination_data');
            utils.setHtmlData($(this).parents('form').find('.tt-previous-examinationdata-items'), getPreviousExaminationDataItems(previousExaminationData, allPreviousExaminationData, newPage, pageCount), false);
        }
    });

    // Vollständigkeitsanzeige / Vordaten übernehmen / Konflikte beim Import nicht mehr anzeigen bei Klick außerhalb
    $('body').on('click', function (e) {

        setTimeout(function() {
            if ($(e.target).data('toggle') !== 'tripletrax-popover' && $(e.target).parent().data('toggle') !== 'tripletrax-popover'
                && $(e.target).parents('.popover.in').length === 0) {
                jQuery.each($('[data-toggle="tripletrax-popover"]'), function(i, button) {
                    if (!utils.isUndefined($(button).data('bs.popover')) && !utils.isUndefined($(button).attr('aria-describedby'))) {
                        $(button).popover('hide');
                    }
                });
            }
        }, 300);
    });

    // Vordaten übernehmen / Konflikte beim Import - Abbrechen
    $('body').on('click', '.tt-cancel-previous-examination,.tt-cancel-import-conflicts', function (e) {
        e.preventDefault();

        $(this).parents('.popover').prev().popover('hide');

        e.stopPropagation();
    });

    // Vordaten übernehmen - Angehakte Werte übernehmen
    $('body').on('click', '.tt-save-previous-examination', function (e) {
        e.preventDefault();

        var previousExaminationDataItems = $(this).parents('form').find('.tt-previous-examinationdata-items').data('previousExaminationdataItems');
        var previousExaminationData = [];

        jQuery.each(previousExaminationDataItems, function (key, val) {

            var splittedValue = val.split('#');

            if (splittedValue[2] === '1') {
                previousExaminationData[key] = splittedValue[0];
            }
        });

        setPreviousExaminationData($(this).parents('.popover').prev(), previousExaminationData);

        $(this).parents('.popover').prev().popover('hide');
    });

    // AuditTrail anzeigen
    $('body').on('mouseenter', '.tt-history', function (e) {
        $(this)[0].dataset.mouseIsOver = true;
        if (((utils.isUndefined($(this)[0].dataset.content ) || $(this)[0].dataset.content === '') && getFacilityId() > 0)) {
            var element = $(this);
            element[0].dataset.content = '<span><i class="fad fa-cog fa-spin tt-revision-popover"></i>' + trans('tripletrax.loading') + '...</span>';
            if (utils.isUndefined(element.data('bs.popover'))) {
                $(element).popover({
                    template: '<div class="popover tt-revision-popover" role="tooltip" style="min-width: 375px;"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>',
                    //trigger: 'click',
                    trigger: 'hover focus',
                    placement: 'right'
                });
            } else {
                element.data('bs.popover').setContent();
            }
            if (element[0].dataset.mouseIsOver === "true" || element[0].dataset.mouseIsOver === true) {
                $(element).popover('show');
            }

            var examinationId = getExaminationId();
            if (element.parents('.tt-accordion-as-list').length) {
                examinationId = element.parents('.tt-accordion-panel').data('dataId');
            } else if (element.parents('.tt-list').length) {
                examinationId = element.parents('tr').data('dataId');
            } else if (element.hasClass('tt-history-patient-agreement') || element.hasClass('tt-history-examination')) {
                examinationId = element.parents('form').find('.tt-selected-id').val();
                if (examinationId === '') {
                    examinationId = '0';
                }
            }


            var data = null;
            var url = 'doc/patient/patient/revisions/facility/' + getFacilityId() + '/model/' + getModelId() + '/patient/' + getPatientId() + '/examination/' + examinationId + '/field/' + $(this)[0].dataset.control;
            if (element.hasClass('tt-history-patient-agreement')) {
                url += '/table/patient_agreements';
            } else if (element.hasClass('tt-history-examination')) {
                url += '/table/examinations';
            } else if (element.hasClass('tt-history-query')) {
                url += '/table/queries';

                var name = $(this).parents('.popover').find('#control_name').val();
                var queryCounter = $(this).parents('.popover-content').find('#query_counter_' + name).val();

                var historyObjectString = $(this).parents('.popover-content').find('#query_history_object_list_' + name).val();
                if(!utils.isUndefined(historyObjectString)) {
                    var queryHistoryObjectList = JSON.parse(historyObjectString);
                }

                if(queryCounter > 0) {
                    data = 'queryId='+queryHistoryObjectList[queryHistoryObjectList.length - queryCounter].queryId;
                } else {
                    data = 'queryId='+ $(this).parents('[class^="tt-rightclass-"]').find('[name="' + name + '"]')[0].dataset.queryId;
                    $test = $(this)[0].dataset.queryId
                }
            } else {
                url += '/table/none';
            }

            ajax.ajaxCall(url, 'GET', data, false, function (data) {
                element[0].dataset.content = getRevisionForm(data);
                element.data('bs.popover').setContent();
                if (element[0].dataset.mouseIsOver === "true" || element[0].dataset.mouseIsOver === true) {
                    $(element).popover('show');
                }
            });
        }
    });

    // AuditTrail anzeigen
    $('body').on('mouseleave', '.tt-history', function (e) {
        $(this)[0].dataset.mouseIsOver = false;
    });

    // Werte setzen für ausgewählten Tab, falls dies noch nicht geschehen ist
    $('body').on('click', '.tt-doc-tab', function(e) {
        e.preventDefault();

        showTab($(this), null, null, null);
    });

    // Spezielle Funktionen ausführen
    $('body').on('click', '.tt-specific-function', function (e) {
        e.preventDefault();

        if ($(this).data().specificFunction === 'lufu_import') {
            $('#hidden_specific_function_file_name_' + $(this).data().specificFunction).removeAttr('disabled');
            $('#hidden_specific_function_file_name_' + $(this).data().specificFunction)[0].click();
        } else if ($(this).data().specificFunction === 'open_quick_status') {
            utils.updateGlobals('openReport', 'doc/patient/reports/quick_status');
            $('[href="#content-detail-reports"]').click();
        } else if ($(this).data().specificFunction === 'open_lufu_chart') {
            utils.updateGlobals('openReport', 'doc/patient/reports/lufu_chart');
            $('[href="#content-detail-reports"]').click();
        } else if ($(this).data().specificFunction === 'open_height_weight_chart') {
            utils.updateGlobals('openReport', 'doc/patient/reports/height_weight_chart');
            $('[href="#content-detail-reports"]').click();
        } else if ($(this).data().specificFunction === 'open_bacteria_chart') {
            utils.updateGlobals('openReport', 'doc/patient/reports/bacteria_chart');
            $('[href="#content-detail-reports"]').click();
		} else if ($(this).data().specificFunction === 'open_antibiotic_therapy') {
			utils.updateGlobals('openReport', 'doc/patient/reports/antibiotic_therapy');
			$('[href="#content-detail-reports"]').click();
        }
    });

    // Spezielle Funktionen ausführen (Aufruf an PHP)
    $('body').on('change', '.tt-specific-function-hidden-field', function (e) {

        var element = $(this);

        if (element.val() === '') {
            return;
        }

        var data = new FormData();
        data.append(element[0].name, $('#hidden_specific_function_file_name_lufu_import')[0].files[0]);

        ajax.ajaxCallExtended('doc/patient/function/' + element.data().specificFunction + '/' + getPatientId() + '/facility/' + getFacilityId() + '/model/' + getModelId(), 'POST', data, false, false, false, null, null, function (data) {

            var currentFormData = [];

            // Array mit den aktuellen Daten laden
            if (isExaminationSelected()) {
                currentFormData = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data');
            } else {
                currentFormData = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data');
            }

            if (utils.isUndefined(currentFormData)) {
                return;
            }

            // prüfen, ob bereits Daten vorhanden sind
            var conflictArray = [];
            jQuery.each(data, function (key, value) {

                var splittedValue = value.split('§§');

                if (splittedValue.length === 3) {

                    if ((key in currentFormData && currentFormData[key] !== '') || (key + '_format' in currentFormData && utils.isFormatValue(currentFormData[key + '_format']))) {

                        var oldValue = '';
                        var oldFormat = '';
                        if (key in currentFormData) {
                            oldValue = currentFormData[key];
                            if (!isNaN(Number(oldValue))) {
                                oldValue = Number(oldValue);
                            }
                        }
                        if (key + '_format' in currentFormData) {
                            oldFormat = currentFormData[key + '_format'];
                        }

                        if (oldValue != splittedValue[1].substr(0, splittedValue[1].indexOf('#')) || oldFormat != splittedValue[2]) {
                            conflictArray[splittedValue[0]] = oldValue + '§§' + oldFormat + '||' + splittedValue[1] + '§§' + splittedValue[2];
                        }
                    }
                }
            });

            var assumeValues = true;
            if (Object.keys(conflictArray).length > 0) {

                assumeValues = false;
                var button = element.parent().find('.tt-specific-function');
                if (button.length) {
                    button.attr('data-content', getImportConflictForm(conflictArray, data));
                    button.popover({
                        template: '<div class="popover" role="tooltip" style="min-width: 450px;"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
                    });
                    button.popover('show');
                }
            }

            // neue Daten übernehmen
            if (assumeValues) {

                setImportData(data, currentFormData);
            }

            // Dateinamen wieder zurücksetzen
            element.val('');
        });
    });

    // Daten vom Import übernehmen
    $('body').on('click', '.tt-save-import-conflicts', function (e) {
        e.preventDefault();

        var currentFormData = [];

        // Array mit den aktuellen Daten laden
        if (isExaminationSelected()) {
            currentFormData = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data');
        } else {
            currentFormData = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data');
        }

        if (utils.isUndefined(currentFormData)) {
            return;
        }

        var data = $(this).parents('form').find('.tt-import-conflicts').data('importConflictItems');

        setImportData(data, currentFormData);

        $(this).parents('.popover').prev().popover('hide');

        e.stopPropagation();
    });

    // Akkordeon auf- zuklappen
    $('body').on('click', '.tt-accordion-header', function (e) {
        e.preventDefault();

        openOrCloseAccordionHeader($(this));
    });

    // Query - Abbruch
    $('body').on('click', '.tt-cancel-query', function (e) {
        e.preventDefault();

        $(this).parents('.popover').prev().click();
    });

    // Query - Speichern
    $('body').on('click', '.tt-save-query-value', function (e) {
        e.preventDefault();

        var form = $($(this).parents('form')[0]);
        var popover = $(this).parents('.popover').prev();
        var name = $(this).parents('.popover').find('#control_name').val();

        var historyObjectString = $(this).parents('.popover-content').find('#query_history_object_list_' + name).val();
        if(!utils.isUndefined(historyObjectString)) {
            var queryHistoryObjectList = JSON.parse(historyObjectString);
        }

        jQuery.each($('[name="' + name + '"]'), function(i, element) {
            setQueryValue($(element), $('#query_question_' + element.name).val(), $('#query_question_date_' + element.name).text(), $('#query_answer_' + element.name).val(), $('#query_answer_date_' + element.name).text(), '', false, false, false, queryHistoryObjectList);
        });

        setFormDataForAjaxCall($($('[name="' + name + '"]').parents('.tab-pane')[0]), true, true);
        form.addClass('dirty');
        popover.click();
    });

    // Query - Query schließen
    $('body').on('click', '.tt-close-query', function (e) {
        e.preventDefault();

        var form = $($(this).parents('form')[0]);
        var popover = $(this).parents('.popover').prev();
        var name = $(this).parents('.popover').find('#control_name').val();

        var historyObjectString = $(this).parents('.popover-content').find('#query_history_object_list_' + name).val();
        if(!utils.isUndefined(historyObjectString)) {
            var queryHistoryObjectList = JSON.parse(historyObjectString);
        }

        jQuery.each($('[name="' + name + '"]'), function(i, element) {
            element.dataset.queryClosed = 1;
            setQueryValue($(element), $('#query_question_' + element.name).val(), $('#query_question_date_' + element.name).text(), $('#query_answer_' + element.name).val(), $('#query_answer_date_' + element.name).text(), '', true, false, false, queryHistoryObjectList);
        });

        setFormDataForAjaxCall($($('[name="' + name + '"]').parents('.tab-pane')[0]), true, true);
        form.addClass('dirty');
        popover.click();
    });

    // Query - Query löschen
    $('body').on('click', '.tt-delete-query', function (e) {
        e.preventDefault();

        var form = $($(this).parents('form')[0]);
        var popover = $(this).parents('.popover').prev();
        var name = $(this).parents('.popover').find('#control_name').val();

        var historyObjectString = $(this).parents('.popover-content').find('#query_history_object_list_' + name).val();
        if(!utils.isUndefined(historyObjectString)) {
            var queryHistoryObjectList = JSON.parse(historyObjectString);
        }

        jQuery.each($('[name="' + name + '"]'), function(i, element) {
            setQueryValue($(element), '', null, '', null, '',false, true, true, queryHistoryObjectList);
        });

        setFormDataForAjaxCall($($('[name="' + name + '"]').parents('.tab-pane')[0]), true, true);
        form.addClass('dirty');
        popover.click();
    });

    // Query - nächstes Query anzeigen
    $('body').on('click', '.tt-next-query', function (e) {
        e.preventDefault();

        var form = $($(this).parents('form')[0]);
        var popover = $(this).parents('.popover').prev();
        var name = $(this).parents('.popover').find('#control_name').val();

        $(this).parents('.popover-content').find('.tt-history')[0].dataset.content = '';
        if($(this).parents('.popover-content').find('.tt-history').length > 1) {
            $(this).parents('.popover-content').find('.tt-history')[1].dataset.content = '';
        }

        var historyObjectString = $(this).parents('.popover-content').find('#query_history_object_list_' + name).val();
        if(!utils.isUndefined(historyObjectString)) {
            var queryHistoryObjectList = JSON.parse(historyObjectString);
        }

        if(!utils.isUndefined(queryHistoryObjectList) && queryHistoryObjectList.length > 0) {
            var queryCounter = $(this).parents('.popover-content').find('#query_counter_' + name).val();
            var isFirstQueryClosed = ($(this).parents('.popover-content').find('#query_is_closed_' + name).val() == 'true');

            queryCounter--;
            $(this).parents('.popover-content').find('#query_counter_' + name).val(queryCounter);

            if (queryCounter === 0) {
                // Offenes Query (falls vorhanden) anzeigen
                var queryQuestionDate = $(this).parents('.popover-content').find('#query_question_date_' + name).data('orig_query_question_date');
                var queryQuestion = $(this).parents('.popover-content').find('#query_question_' + name).data('orig_query_question');
                var queryAnswerDate = $(this).parents('.popover-content').find('#query_answer_date_' + name).data('orig_query_answer_date');
                var queryAnswer = $(this).parents('.popover-content').find('#query_answer_' + name).data('orig_query_answer');

                $(this).parents('.popover-content').find('#query_question_date_' + name).text(utils.isUndefined(queryQuestionDate) ? '' : queryQuestionDate);
                $(this).parents('.popover-content').find('#query_question_' + name).val(queryQuestion);
                $(this).parents('.popover-content').find('#query_answer_date_' + name).text(utils.isUndefined(queryAnswerDate) ? '' : queryAnswerDate);
                $(this).parents('.popover-content').find('#query_answer_' + name).val(queryAnswer);
            }

            if ((queryCounter === 1 && isFirstQueryClosed) || (queryCounter === 0)) {
                // Button Initialisierung bei Aufruf nächstes Query
                $(this).attr('disabled', 'disabled');

                if(!(isFirstQueryClosed)) {
                    $(this).parents('.popover-content').find('.tt-save-query-value').removeAttr('disabled', 'disabled');
                    if ((access.getRight($(this), 'answer_query') > 0 )) {
                        $(this).parents('.popover-content').find('#query_answer_' + name).removeAttr('disabled', 'disabled');
                    }
                    if ((access.getRight($(this), 'create_query') > 0 )) {
                        $(this).parents('.popover-content').find('#query_question_' + name).removeAttr('disabled', 'disabled');
                    }
                }

                if (queryQuestion !== "") {
                    $(this).parents('.popover-content').find('.tt-delete-query').removeAttr('disabled', 'disabled');
                    if(queryAnswer !== "" &&   !isFirstQueryClosed) {
                        $(this).parents('.popover-content').find('.tt-close-query').removeAttr('disabled', 'disabled');
                    }
                }
            }
            if (queryCounter >= 1) {
                // Nächstes Query aus Historie anzeigen
                var queryObject = queryHistoryObjectList[queryHistoryObjectList.length - queryCounter];
                $(this).parents('.popover-content').find('#query_question_date_' + name).text(utils.isUndefined(queryObject.queryQuestionDate) ? '' : utils.dateToLocaleLongTimeString(queryObject.queryQuestionDate));
                $(this).parents('.popover-content').find('#query_question_' + name).val(queryObject.queryQuestion);
                $(this).parents('.popover-content').find('#query_answer_date_' + name).text(utils.isUndefined(queryObject.queryAnswerDate) ? '' : utils.dateToLocaleLongTimeString(queryObject.queryAnswerDate));
                $(this).parents('.popover-content').find('#query_answer_' + name).val(queryObject.queryAnswer);
            }

            // Button Vorheriges Query aktivieren
            if(queryCounter === queryHistoryObjectList.length-1) {
                $(this).parents('.popover-content').find('.tt-previous-query').removeAttr('disabled', 'disabled');
            }
        }
    });

    // Query - vorheriges Query anzeigen
    $('body').on('click', '.tt-previous-query', function (e) {
        e.preventDefault();

        var form = $($(this).parents('form')[0]);
        var popover = $(this).parents('.popover').prev();
        var name = $(this).parents('.popover').find('#control_name').val();

        $(this).parents('.popover-content').find('.tt-history')[0].dataset.content = '';
        if($(this).parents('.popover-content').find('.tt-history').length > 1) {
            $(this).parents('.popover-content').find('.tt-history')[1].dataset.content = '';
        }

        var historyObjectString = $(this).parents('.popover-content').find('#query_history_object_list_' + name).val();
        if(!utils.isUndefined(historyObjectString)) {
            var queryHistoryObjectList = JSON.parse(historyObjectString);
        }

        if(!utils.isUndefined(queryHistoryObjectList) && queryHistoryObjectList.length > 0) {
            var queryCounter = $(this).parents('.popover-content').find('#query_counter_' + name).val();

            var isFirstQueryClosed = ($(this).parents('.popover-content').find('#query_is_closed_' + name).val() == 'true');

            queryCounter++;
            $(this).parents('.popover-content').find('#query_counter_' + name).val(queryCounter);

            if(queryCounter === 1) {
                // Offenes Query (falls vorhanden) sichern
                var queryQuestionDate = $(this).parents('.popover-content').find('#query_question_date_' + name).text();
                var queryQuestion = $(this).parents('.popover-content').find('#query_question_' + name).val();
                var queryAnswerDate = $(this).parents('.popover-content').find('#query_answer_date_' + name).text();
                var queryAnswer = $(this).parents('.popover-content').find('#query_answer_' + name).val();
                $(this).parents('.popover-content').find('#query_question_date_' + name).data('orig_query_question_date', queryQuestionDate);
                $(this).parents('.popover-content').find('#query_question_' + name).data('orig_query_question', queryQuestion);
                $(this).parents('.popover-content').find('#query_answer_date_' + name).data('orig_query_answer_date', queryAnswerDate);
                $(this).parents('.popover-content').find('#query_answer_' + name).data('orig_query_answer', queryAnswer);
            }

            // Vorheriges Query anzeigen
            var queryObject = queryHistoryObjectList[queryHistoryObjectList.length - queryCounter];
            $(this).parents('.popover-content').find('#query_question_date_' + name).text(utils.isUndefined(queryObject.queryQuestionDate) ? '' : utils.dateToLocaleLongTimeString(queryObject.queryQuestionDate));
            $(this).parents('.popover-content').find('#query_question_' + name).val(queryObject.queryQuestion);
            $(this).parents('.popover-content').find('#query_answer_date_' + name).text(utils.isUndefined(queryObject.queryAnswerDate) ? '' : utils.dateToLocaleLongTimeString(queryObject.queryAnswerDate));
            $(this).parents('.popover-content').find('#query_answer_' + name).val(queryObject.queryAnswer);
            $(this).parents('.popover-content').find('#query_change_' + name).val(1);

            // Button - Textboxen
            if((queryCounter === 1)||(queryCounter === 2 && isFirstQueryClosed)) {
                // Button Initialisierung bei Aufruf vorheriges Query
                $(this).parents('.popover-content').find('.tt-next-query').removeAttr('disabled', 'disabled');
                $(this).parents('.popover-content').find('.tt-save-query-value').attr('disabled', 'disabled');
                $(this).parents('.popover-content').find('.tt-delete-query').attr('disabled', 'disabled');
                $(this).parents('.popover-content').find('.tt-close-query').attr('disabled', 'disabled');
                $(this).parents('.popover-content').find('#query_question_' + name).attr('disabled', 'disabled');
                $(this).parents('.popover-content').find('#query_answer_' + name).attr('disabled', 'disabled');
            }

            if(queryHistoryObjectList.length <= queryCounter) {
                // Button Vorheriges Query deaktivieren
                $(this).attr('disabled', 'disabled');
            }
        }
    });

    $('body').on('shown.bs.collapse', '.tt-accordion', function() {

        showQuery();
    });

    // Neue Untersuchung - Uhrzeit anzeigen
    $('body').on('click', '.tt-show-examination-time', function(e) {
        e.preventDefault();

        $(this).parents('.tt-show-examination-time-group').addClass('hide');
        $(this).parents('.col').find('.tt-examination-time').removeClass('hide');

        var dt = new Date();
        var minutes = '0' + dt.getMinutes();
        if (minutes.length > 2) {
            minutes = minutes.substring(1);
        }
        var time = dt.getHours() + ":" + minutes;
        $(this).parents('.col').find('[name="exam_time"]').val(time);
    });

    $('body').on('click', '.tt-btn-query', function(e) {

        $(this).parent().find('.popover-draggable').draggable({
            handle: '.popover-draggable-handle'
        });
    });

	// Speichern Button - Übernahme Therapie (ohne Therapien) => Anlage Untersuchung
	$('body').on('click', '.tt-save-without-data', function (e) {
		e.preventDefault();

		if ($(this).parents('.tt-content-dialog').find('.tt-create-transfer-examination').val() == '1') {
			var tabArray = [];
			$.each($(this).parents('.tt-content-dialog').find('.tt-transfer-tab'), function (i, input) {
				tabArray.push($(input).val())
			});
			$('#table_patient_examination_transfer_dialog').find('.content-dialog').empty();
			$(this).parents('.tt-content-dialog').find('.tt-dialog-cancel').click();
			validator.saveExamination($('#table_patient_examination_create_form'), $('#table_patient_examination_create_form')[0], null, tabArray);
		} else {
			$('#table_patient_examination_transfer_dialog').find('.content-dialog').empty();
			$(this).parents('.tt-content-dialog').modal('hide');
        }
	});

    // Offene Therapien übernehmen
    $('body').on('click', '.tt-transfer-data-button', function(e) {
        e.preventDefault();

		var url = 'doc/patient/patient/examination/facility/' + getFacilityId() + '/model/' + getModelId() + '/patient/' + getPatientId() + '/checktransferdata/' + getExaminationDate() + '/tab/' + $(this).parents('.tt-doc-pane')[0].id;
		validator.checkForTransferDataViewFields(url).done(function (doSave) {
			if (doSave) {
				// keine Daten
			} else {
				$('#table_patient_examination_transfer_dialog').modal('show');
			}
		});
    });

	// Fragebogen hinzufügen
	$('body').on('click', '.tt-add-questionnaire', function(e) {
		e.preventDefault();

		var selectedQuestionnaireProject = $('.tt-questionnaire-project').val();
		var questionnaires = getQuestionnaires();
		var defaultQuestionnaires = $('#doc_navigation_tab_questionnaires').data().defaultQuestionnaires;
		var languages = JSON.parse($('#questionnaires_content').parents('form').find('[name="languages"]').val());

		var html = '';
		for (var id in questionnaires) {
			if (id == selectedQuestionnaireProject || selectedQuestionnaireProject == 0) {
				html +=
					'<div class="row">' +
					'   <div class="col col-12">' +
					'      <label class="label label-tripletrax tt-bold">' + questionnaires[id]['model'] + '</label>' +
					'   </div>' +
					'</div>' +
					'<div class="row">';

				var data_views = questionnaires[id]['data_views'];
				for (var data_view_id in data_views) {
					html +=
						'<section class="col col-3">' +
						'   <label class="checkbox">' +
						'      <input type="checkbox" class="tt-select-questionnaire tt-validation-checkbox tt-select-' + id + '" name="' + id + '|' + data_view_id + '" ' + (('questionnaire_' + id + '|' + data_view_id in defaultQuestionnaires) ? ' checked' : '') + '>' +
						'      <i></i>' + data_views[data_view_id] +
						'   </label>' +
						'</section>';
				}
				html +=
					'</div>' +
					'<div class="row">' +
					'   <section class="col col-6">' +
					'      <label class="input input-sm">' +
					'         <select style="width:100%" class="tt-select2 tt-no-reset-select2 tt-select-language tt-select-' + id + '" name="language_' + id + '" id="'+ id + '" data-select2-placeholder="select_language">' +

					'         <option></option>';

				$.each(questionnaires[id]['languages'], function(i, language) {
					$.each(languages, function(k, language_object) {
						if (language_object.language === language) {
							html += '         <option' + (('language_' + id in defaultQuestionnaires) && defaultQuestionnaires['language_' + id] === language ? ' selected' : '') + ' value="' + language + '" data-flag="' + language_object['flag'] + '">' + trans('tripletrax.language_' + language) + '</option>';
						}
					});
				});

				html +=
					'         </select>' +
					'      </label>' +
					'   </section>' +
					'</div>';
			}
		}

		utils.setHtmlData($('#questionnaires_content'), html, true);
		validator.addDynamicRules($('#table_patient_questionnaires_create_form'));

		$('#table_patient_questionnaires_create_dialog').modal('show');
	});

	$('body').on('change', '.tt-tab-button-group input:radio', function(e) {
		e.preventDefault();

		var column = $(this).val();
		var columnPanel = $($(this).parents('.tt-column')[0]).find('.tt-column-panel,.tt-panel');
		showColumn(columnPanel, column, true);
	})
}

function blurDatepicker(element) {
    var picker = $(element).data('picker');
    picker.hide();
    var selectedDate = $(element).val().replace(/_/g, '');
    if (selectedDate.indexOf('.') >= 0) {
        selectedDate = selectedDate.replace(/\.*$/g, '');
    } else if (selectedDate.indexOf('/') >= 0) {
        selectedDate = selectedDate.replace(/\/*$/g, '');
    }
    utils.setDatePickerValue(picker, selectedDate);

    if ($(element).hasClass('tt-view-datepanel') && ((utils.isUndefined($(element).data().previousValue) && $(element).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') !== '') || (!utils.isUndefined($(element).data().previousValue) && $(element).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') === '') || $(element).data().previousFormatValue != utils.getValueFromInputWithDropDownField($(element)) || (!utils.isUndefined($(element).data().previousValue) && !moment($(element).data('picker').getDate()).isSame(moment($(element).data().previousValue))))) {
        setFormDataForAjaxCall($($(element).parents('.tab-pane')[0]), true, true);
        var formData = getFormDataForAjaxCall(true, true, false);
        equalizeControls($(element), true, formData);
        setMasterOverviewValues($(element));
        if (checkRights($(element)) && checkPrimaryKey($(element))) {
            addToIntegrityList([$(element)], true, false);
        } else {
            removeFromIntegrityList($(element), true, false);
        }
        calculateValues([$(element)], true, formData);
        setCompleteness($(element), formData);

        if ($(element).val().replace(/\./g, '').replace(/_/g, '').replace(/\//g, '') === '') {
            $(element).data().previousValue = null;
        } else {
            $(element).data().previousValue = $(element).data('picker').getDate();
        }
        $(element).data().previousFormatValue = utils.getValueFromInputWithDropDownField($(element));
    } else if ($(element).parents('.tt-create-patient').length) {
		addToIntegrityList([$(element)], true, false);
    } else if ($(element).parents('.tt-examination-date-integrity').length) {
		addToIntegrityList([$(element)], true, false, false);
	}

	setRepetitionCaption(element);
}

function setRepetitionCaption(element) {
	if ($(element).hasClass('tt-repetition-caption') && parseInt($(element).data().columnRepetition) > 1) {

		if ($(element).hasClass('tt-view-datepanel')) {
			var caption = '';
			if ($(element).hasClass('tt-view-from-daterange') || $(element).hasClass('tt-view-till-daterange')) {
				caption = $($(element).parents('.row')[0]).find('.tt-view-from-daterange').val() + ' - ' + $($(element).parents('.row')[0]).find('.tt-view-till-daterange').val();
			} else {
				caption = $(element).val();
			}
			$(element).parents('.tt-column').find('.tt-tab-button.active span').text(caption);
		}
		// TODO: für andere Element Typen auch programmieren
	}
}

function setSubControlsEnabledForCheckBox(element, doIntegrityCheckAndCalculation, doReset) {

    setSubControlsEnabledWithResetOption(element, element.prop('checked'), doIntegrityCheckAndCalculation, doReset);
}

function setSubControlsEnabledForRadioButton(element, doIntegrityCheckAndCalculation, doReset, addFirstGroup) {

    var state = null;
    if (element.prop('checked')) {
        state = element.data().activation === 1;
    } else if ($(element.parents('.row')[0]).find('[name="' + element.attr('name') + '"]:checked').length === 0) {
        state = false;
    }
    if (state !== null) {
        if (element.parents('.tt-radio-accordion').length) {
            if ($('#accordions_always_expanded').val() !== '1') {
                if (!element.parents('.tt-radio-accordion').hasClass('tt-radio-accordion-activation')) {
                    if (state && !element.parents('.tt-accordion-panel').find('.tt-accordion-panel-body').hasClass('in')) {
                        if (element.parents('form').hasClass('tt-set-data')) {
                            if (!element.parents('form').hasClass('tt-do-not-open-accordion-panel') && element.parents('.tt-accordion').find('.tt-accordion-panel-body.tt-in').length <= 0) {
                                element.parents('.tt-accordion-panel').find('.tt-accordion-panel-body').addClass('tt-in');
                                if (!element.parents('.tt-accordion-panel').find('.tt-accordion-panel-body').hasClass('in')) {
                                    element.parents('.tt-accordion-panel').find('.tt-accordion-panel-body').collapse('toggle');
                                    element.parents('.tt-accordion-panel').find('.tt-accordion-panel-body').data('bs.collapse', null);
                                }
                            }
                        } else {
                            element.parents('.tt-accordion').find('.tt-accordion-panel-body.in').collapse('toggle');
                            element.parents('.tt-accordion').find('.tt-accordion-header').addClass('collapsed');
                            if (!element.parents('.tt-accordion-panel').find('.tt-accordion-panel-body').hasClass('in')) {
                                element.parents('.tt-accordion-panel').find('.tt-accordion-panel-body').collapse('toggle');
                                element.parents('.tt-accordion-panel').find('.tt-accordion-header').removeClass('collapsed');
                            }
                        }
                    } else if (!state && element.parents('.tt-accordion-panel').find('.tt-accordion-panel-body').hasClass('in')) {
                        element.parents('.tt-accordion-panel').find('.tt-accordion-panel-body').collapse('toggle');
                        element.parents('.tt-accordion-panel').find('.tt-accordion-header').addClass('collapsed');
                    }
                }
            }
            setAccordionControlsEnabled(element, state, doIntegrityCheckAndCalculation, doReset, addFirstGroup);
        } else if (element.parents('.tt-radio-list').length) {
            setListControlsEnabled(element, state, doIntegrityCheckAndCalculation, addFirstGroup);
        } else if (element.parents('.tt-radio-column').length) {
            setColumnControlsEnabled(element, state, doIntegrityCheckAndCalculation, doReset);
        } else {
            setSubControlsEnabledWithResetOption(element, state, doIntegrityCheckAndCalculation, doReset);
        }
    }
}

function setSubControlsEnabled(element, state) {
    setSubControlsEnabledWithResetOption(element, state, false, true);
}

function setSubControlsEnabledWithResetOption(element, state, doIntegrityCheckAndCalculation, doReset) {

    if (!element.hasClass('tt-sub-control') && $(element.parents('section,td')[0]).find('.tt-sub-control').length) {
        jQuery.each($(element.parents('section,td')[0]).find('.tt-sub-control,.btn:not(.tt-tab-button)'), function (i, val) {

            if (!$(val).hasClass('tt-hide') && !$(val).parents('.tt-hide').length) {
				setControlEnabled($(val), state && !$(val).hasClass('tt-unlock-for-editing') && (!$(val).hasClass('tt-is-calculated') || ($(val).hasClass('tt-is-editable-calculation') && (utils.isUndefined(val.dataset.calculatedValue) || val.dataset.calculatedValue === ''))), !state && doReset, doIntegrityCheckAndCalculation, doReset, true);
				if (!state && doReset) {
					resetControl($(val), true);
				}
			}
        });
        if (doReset) {
            if (state) {
                $(element.parents('section,td')[0]).find('ul.fa-ul').fadeIn(50);
            } else {
                $(element.parents('section,td')[0]).find('ul.fa-ul').fadeOut(700);
            }
        }
    }
}

function setAccordionControlsEnabled(element, state, doIntegrityCheckAndCalculation, doReset, addFirstGroup) {

    if (element.parents('.tt-radio-accordion').hasClass('tt-radio-accordion-activation')) {
        if (element.parents('.tt-accordion').hasClass('tt-accordion-with-radio')) {
            jQuery.each(element.parents('.tt-accordion').find('.panel-heading'), function(i, val) {
                var accordionPanel = null;
                if ($(val).find('.tt-radio-accordion').length) {
					accordionPanel = $(val).find('.tt-radio-accordion');
                } else {
					accordionPanel = $($(val).parents('.tt-accordion-panel').find('.tt-accordion-panel-body')[0]);
                }
                jQuery.each(accordionPanel.find('[name]:not(.tt-sub-control,.tt-tab-button-control),.btn:not(.tt-tab-button),.tt-btn-eraser,.tt-btn-unlock-for-editing,.tt-btn-assume-examination-date'), function (i, val) {

                    var setSubControls = true;
                    if ($(val).is(':radio')) {
						if (state) {
							setSubControls = $(val).is($('[name="' + $(val).attr('name') + '"]:last'));
						} else {
							setSubControls = $(val).is($('[name="' + $(val).attr('name') + '"]:checked'));
						}
                    }
                    setControlEnabled($(val), state && !$(val).hasClass('tt-unlock-for-editing') && (!$(val).hasClass('tt-is-calculated') || ($(val).hasClass('tt-is-editable-calculation') && (utils.isUndefined(val.dataset.calculatedValue) || val.dataset.calculatedValue === ''))), !state && doReset, doIntegrityCheckAndCalculation, true, false, setSubControls);
                });
            });
        } else {
            if (state) {
                if (access.getRight(element, 'write') > 0) {
                    element.parents('.tt-accordion').find('.tt-add-accordion-group').removeClass('disabled');
					element.parents('.tt-accordion').find('.tt-add-accordion-group').removeAttr('disabled');
                    if (addFirstGroup) {
                        element.parents('.tt-accordion').find('.tt-add-accordion-group').click();
                    }
                }
            } else {
                element.parents('.tt-accordion').find('.tt-add-accordion-group').addClass('disabled');
				element.parents('.tt-accordion').find('.tt-add-accordion-group').prop('disabled', 'disabled');
                element.parents('.tt-accordion').find('.tt-delete-accordion-group').addClass('disabled');
                element.parents('.tt-accordion').find('.panel-group').empty();
            }
        }
    }
	var accordionPanel = $(element.parents('.tt-accordion-panel').find('.tt-accordion-panel-body')[0]);

	var repetitionPanel = null;
	if (element.parents('.tt-accordion-panel').find('.tt-repetition-panel').length) {
		repetitionPanel = $(element.parents('.tt-accordion-panel').find('.tt-repetition-panel')[0]);
	}
	if (repetitionPanel !== null) {
		// Die Buttons der Tabs müssen separat in-/aktiv gesetzt werden, da diese keine Rechte besitzen
		jQuery.each($(repetitionPanel).find('.tt-tab-button-group').find('a'), function (k, val) {
			if (state) {
				$(val).removeAttr('disabled');
				$(val).removeClass('disabled');
			} else {
				$(val).attr('disabled', 'disabled');
				$(val).addClass('disabled');
			}
		});

		if (!state) {
			resetRepetitionPanel(repetitionPanel, state, doIntegrityCheckAndCalculation, doReset);
		}
	}

	// console.time('setControlsEnabled');
    jQuery.each(accordionPanel.find('[name]:not(.tt-sub-control,.tt-tab-button-control),.btn:not(.tt-tab-button),.tt-btn-eraser,.tt-btn-unlock-for-editing,.tt-btn-assume-examination-date'), function (i, val) {

        var setSubControls = true;
        if ($(val).is(':radio')) {
        	if (state) {
				setSubControls = $(val).is($('[name="' + $(val).attr('name') + '"]:last'));
			} else {
				setSubControls = $(val).is($('[name="' + $(val).attr('name') + '"]:checked'));
			}
        }
        setControlEnabled($(val), state && !$(val).hasClass('tt-unlock-for-editing') && (!$(val).hasClass('tt-is-calculated') || ($(val).hasClass('tt-is-editable-calculation') && (utils.isUndefined(val.dataset.calculatedValue) || val.dataset.calculatedValue === ''))), !state && doReset, doIntegrityCheckAndCalculation, true, false, setSubControls);
    });

	// console.timeEnd('setControlsEnabled');
}

function setListControlsEnabled(element, state, doIntegrityCheckAndCalculation, addFirstGroup) {

    if (state) {
        if (access.getRight(element, 'write') > 0) {
            element.parents('.tt-content-datatable').find('.tt-add-list-item').removeClass('disabled');
			element.parents('.tt-content-datatable').find('.tt-add-list-item').removeAttr('disabled');
            if (addFirstGroup) {
                element.parents('.tt-content-datatable').find('.tt-add-list-item').click();
            }
        }
    } else {
        element.parents('.tt-content-datatable').find('.tt-add-list-item').addClass('disabled');
		element.parents('.tt-content-datatable').find('.tt-add-list-item').prop('disabled', 'disabled');
        element.parents('.tt-content-datatable').find('.tt-delete-list-item').addClass('disabled');
        var table = element.parents('.tt-content-datatable').find('table');
        table.dataTable().fnClearTable();
    }
    jQuery.each($(element.parents('.tt-content-datatable').find('.tt-list')[0]).find('[name]:not(.tt-sub-control,.tt-tab-button-control)'), function (i, val) {

        setControlEnabled($(val), state && !$(val).hasClass('tt-unlock-for-editing') && (!$(val).hasClass('tt-is-calculated') || ($(val).hasClass('tt-is-editable-calculation') && (utils.isUndefined(val.dataset.calculatedValue) || val.dataset.calculatedValue === ''))), false, doIntegrityCheckAndCalculation, true, false);
    });
}

function setColumnControlsEnabled(element, state, doIntegrityCheckAndCalculation, doReset) {

	// console.time('setColumnControlsEnabled');
    var columnPanel = $(element.parents('.tt-column').find('.tt-column-panel')[0]);
    var repetitionPanel = null;
    if (element.parents('.tt-column').find('.tt-repetition-panel').length) {
    	repetitionPanel = $(element.parents('.tt-column').find('.tt-repetition-panel')[0]);
	}
	if (repetitionPanel !== null && !state) {
		// console.time('setRepetitionPanelEnabled');
		resetRepetitionPanel(repetitionPanel, state, doIntegrityCheckAndCalculation, doReset);
		// console.timeEnd('setRepetitionPanelEnabled');
	}
    jQuery.each(columnPanel.find('[name]:not(.tt-sub-control,.tt-tab-button-control),.btn:not(.tt-tab-button),.tt-btn-eraser,.tt-btn-unlock-for-editing,.tt-btn-assume-examination-date'), function (i, val) {

        var setSubControls = true;
        if ($(val).is(':radio')) {
			if (state) {
				setSubControls = $(val).is($('[name="' + $(val).attr('name') + '"]:last'));
			} else {
				setSubControls = $(val).is($('[name="' + $(val).attr('name') + '"]:checked'));
			}
        }
        setControlEnabled($(val), state && !$(val).hasClass('tt-unlock-for-editing') && (!$(val).hasClass('tt-is-calculated') || ($(val).hasClass('tt-is-editable-calculation') && (utils.isUndefined(val.dataset.calculatedValue) || val.dataset.calculatedValue === ''))), !state && doReset, doIntegrityCheckAndCalculation, true, false, setSubControls);
    });

    if (doReset) {
        if (state) {
			columnPanel.fadeIn(100);
			if (repetitionPanel !== null) {
				repetitionPanel.fadeIn(100);
			}
        } else {
			columnPanel.fadeOut(200);
			if (repetitionPanel !== null) {
				repetitionPanel.fadeOut(200);
			}
        }
    }
	// console.timeEnd('setColumnControlsEnabled');
}

function resetRepetitionPanel(repetitionPanel, state, doIntegrityCheckAndCalculation, doReset) {
	$(repetitionPanel).find('.tt-tab-button span').text('');
	var countRepetition = $(repetitionPanel).find('.tt-tab-button').length;
	jQuery.each($(repetitionPanel).find('.tt-tab-button-group'), function (k, val) {
		$(val).find('input:checked').prop('checked', false);
		$(val).find('input[value="1"]').prop('checked', true);
		$(val).find('.tt-tab-button').removeClass('active');
		$(val).find('input[value="1"]').parent().addClass('active');

		var columnPanel = $($(val).parents('.tt-column')[0]).find('.tt-column-panel');
		showColumn(columnPanel, 1, false);
		setRepetitionControlsEnabled(columnPanel, state, doIntegrityCheckAndCalculation, doReset);
		setFormDataForAjaxCall(columnPanel, true, true);

		var formData = [];
		if (isDevice()) {
			formData = $('#is_device').data('questionnaireFormData');
		} else if (isExaminationSelected()) {
			formData = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data');
		} else {
			formData = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data');
		}

		$.each(columnPanel.find('[name]'), function(i, control) {
			var currentName = control.name;
			var currentValue = formData[currentName];

			for (var r = countRepetition; r > 1; r--) {
				formData[currentName + '_spalte_' + r] = currentValue;
				if (currentName + '_spalte_' + r + '_confirmed' in formData) {
					delete formData[currentName + '_spalte_' + r + '_confirmed'];
				}
			}
		});

		if (isDevice()) {
			$('#is_device').data('questionnaireFormData', formData);
		} else if (isExaminationSelected()) {
			$('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', formData);
		} else {
			$('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data', formData);
		}
	});
}

function setRepetitionControlsEnabled(element, state, doIntegrityCheckAndCalculation, doReset) {

	jQuery.each($(element).find('[name]:not(.tt-sub-control,.tt-tab-button-control),.btn:not(.tt-tab-button),.tt-btn-eraser,.tt-btn-unlock-for-editing,.tt-btn-assume-examination-date'), function (i, val) {

		var setSubControls = true;
		if ($(val).is(':radio')) {
			if (state) {
				setSubControls = $(val).is($('[name="' + $(val).attr('name') + '"]:last'));
			} else {
				setSubControls = $(val).is($('[name="' + $(val).attr('name') + '"]:checked'));
			}
		}
		setControlEnabled($(val), state && !$(val).hasClass('tt-unlock-for-editing') && (!$(val).hasClass('tt-is-calculated') || ($(val).hasClass('tt-is-editable-calculation') && (utils.isUndefined(val.dataset.calculatedValue) || val.dataset.calculatedValue === ''))), !state && doReset, doIntegrityCheckAndCalculation, true, false, setSubControls);
	});
}

function setControlEnabled(control, state, triggerChangeEvent, doIntegrityCheckAndCalculation, doReset, checkInitValue, subControls) {

    //return;
    //console.time('setControlEnabled');
    subControls = !utils.isUndefined(subControls) ? subControls : true;

    var isIDATField = false;
    if (!utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.matchField) && utils.isIDATField(control[0].dataset.matchField)) {
        isIDATField = true;
    }

    if (control.hasClass('tt-view-combo-multiselect')) {
        if (state) {
            if (((access.getRight(control, 'update') > 0 && control.hasClass('tt-right-select-update') && (!checkInitValue || (!utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== '')))
                    || (access.getRight(control, 'write') > 0 && control.hasClass('tt-right-select-write') && (!checkInitValue || (!utils.isUndefined(control[0].dataset) && (utils.isUndefined(control[0].dataset.initValue) || control[0].dataset.initValue === ''))))
                    || (access.getRight(control, 'delete') > 0 && control.hasClass('tt-right-select-delete')))
                && !((access.showPatientsAnonymized() === 1 || utils.GLOBALS.idatPatients === null) && $('#locale').data().pseudonymization !== 'none' && isIDATField)) {
                control.prop("disabled", false);
            }
        } else {
            if (doReset && !utils.isUndefined(control.select2('val')) && control.select2('val').length) {
                control.val(null).trigger('change.select2');
            }
            if (triggerChangeEvent) {
                if (!control.hasClass('tt-sub-control')) {
                    setSubControlsEnabledWithResetOption(control, false, doIntegrityCheckAndCalculation, doReset);
                }
            }

            control.prop("disabled", true);
        }
        if (triggerChangeEvent && doIntegrityCheckAndCalculation) {
            equalizeControls(control, true);
            setMasterOverviewValues(control);
            utils.GLOBALS.subControlsList.push(control);
        }
    } else if (control.hasClass('tt-view-combo')) {
        if (state) {
            //console.time('setControlEnabled1 ' + control.name);
            if (((access.getRight(control, 'update') > 0 && control.hasClass('tt-right-select-update') && (!checkInitValue || (!utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== '')))
                    || (access.getRight(control, 'write') > 0 && control.hasClass('tt-right-select-write') && (!checkInitValue || (!utils.isUndefined(control[0].dataset) && (utils.isUndefined(control[0].dataset.initValue) || control[0].dataset.initValue === ''))))
                    || (access.getRight(control, 'delete') > 0 && control.hasClass('tt-right-select-delete')))
                && !((access.showPatientsAnonymized() === 1 || utils.GLOBALS.idatPatients === null) && $('#locale').data().pseudonymization !== 'none' && isIDATField)) {
                control.prop("disabled", false);
            }
            //console.timeEnd('setControlEnabled1 ' + control.name);
        } else {
            //console.time('setControlEnabled2 ' + control.name);
            if (doReset && !utils.isUndefined(control.select2('val')) && control.select2('val').length) {
                control.val(null).trigger('change.select2');
            }
            //console.timeEnd('setControlEnabled2 ' + control.name);
            //console.time('setControlEnabled3 ' + control.name);
            if (triggerChangeEvent) {
                if (!control.hasClass('tt-sub-control')) {
                    setSubControlsEnabledWithResetOption(control, false, doIntegrityCheckAndCalculation, doReset);
                }
            }
            //console.timeEnd('setControlEnabled3 ' + control.name);
            //console.time('setControlEnabled4 ' + control.name);

            control.prop("disabled", true);
            //console.timeEnd('setControlEnabled4 ' + control.name);
        }
        //console.time('setControlEnabled5 ' + control.name);
        if (triggerChangeEvent && doIntegrityCheckAndCalculation) {
            equalizeControls(control, true);
            setMasterOverviewValues(control);
            utils.GLOBALS.subControlsList.push(control);
        }
        //console.timeEnd('setControlEnabled5 ' + control.name);
    } else if (control.is(':checkbox')) {
        if (state) {
            if (((access.getRight(control, 'update') > 0 && control.hasClass('tt-right-checkbox-update') && (!checkInitValue || (!utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== '')))
                    || (access.getRight(control, 'write') > 0 && control.hasClass('tt-right-checkbox-write') && (!checkInitValue || (!utils.isUndefined(control[0].dataset) && (utils.isUndefined(control[0].dataset.initValue) || control[0].dataset.initValue === ''))))
                    || (access.getRight(control, 'delete') > 0 && control.hasClass('tt-right-checkbox-delete')))
                && !((access.showPatientsAnonymized() === 1 || utils.GLOBALS.idatPatients === null) && $('#locale').data().pseudonymization !== 'none' && isIDATField)) {
                control.removeAttr('disabled');
            }
        } else {
            if (doReset) {
                control.removeAttr('checked');
            }
            control.prop('disabled', 'disabled');
        }
        if (triggerChangeEvent) {
            if (!control.hasClass('tt-sub-control')) {
                setSubControlsEnabledForCheckBox(control, doIntegrityCheckAndCalculation, doReset);
            }
            if (doIntegrityCheckAndCalculation) {
                equalizeControls(control, true);
                setMasterOverviewValues(control);
                utils.GLOBALS.subControlsList.push(control);
            }
        }
    } else if (control.is(':radio')) {
        var setSubControlsEnabled = true;
    	if (state && control.data().inactive !== 'true') {
            if (((access.getRight(control, 'update') > 0 && control.hasClass('tt-right-radio-update') && (!checkInitValue || (!utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== '')))
                    || (access.getRight(control, 'write') > 0 && control.hasClass('tt-right-radio-write') && (!checkInitValue || (!utils.isUndefined(control[0].dataset) && (utils.isUndefined(control[0].dataset.initValue) || control[0].dataset.initValue === ''))))
                    || (access.getRight(control, 'delete') > 0 && control.hasClass('tt-right-radio-delete')))
                && !((access.showPatientsAnonymized() === 1 || utils.GLOBALS.idatPatients === null) && $('#locale').data().pseudonymization !== 'none' && isIDATField)) {
                control.removeAttr('disabled');
                control.parent().removeClass('tt-label-disabled');
            }
        } else {
			setSubControlsEnabled = false;
            if (doReset && control.prop('checked')) {
                control.prop('checked', false);
				if (!utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.activation) && (control[0].dataset.activation === 1 || control[0].dataset.activation === '1')) {
					setSubControlsEnabled = true;
				}
            }
            control.prop('disabled', 'disabled');
            control.parent().addClass('tt-label-disabled');
        }
        if (triggerChangeEvent) {
            if (!control.hasClass('tt-sub-control') && subControls && setSubControlsEnabled) {
                setSubControlsEnabledForRadioButton(control, doIntegrityCheckAndCalculation, doReset, false);
            }
            if (doIntegrityCheckAndCalculation) {
                equalizeControls(control, true);
                setMasterOverviewValues(control);
                utils.GLOBALS.subControlsList.push(control);
            }
        }
    } else if (control.hasClass('btn') || control.hasClass('tt-btn-control')) {
        if (state) {
            if ((access.getRight(control, 'update') > 0 && (control.hasClass('tt-right-button-update') || control.hasClass('tt-right-button-change')))
                || (access.getRight(control, 'write') > 0 && (control.hasClass('tt-right-button-write') || control.hasClass('tt-right-button-change')))
                || (access.getRight(control, 'delete') > 0 && control.hasClass('tt-right-button-delete'))) {
            	var dataControl = null;
            	if (!utils.isUndefined($(control).data().control) && $(control).data().control !== '') {
					dataControl = control.parents('section').find('[name="' + $(control).data().control + '"]')[0];
				}
            	if (utils.isUndefined(dataControl) || (!$(dataControl).hasClass('tt-is-calculated') || ($(dataControl).hasClass('tt-is-editable-calculation') && (utils.isUndefined(dataControl.dataset.calculatedValue) || dataControl.dataset.calculatedValue === '')))) {
					control.removeAttr('disabled');
					control.removeClass('disabled');
					control.removeClass('no-rights');
				}
            }
        } else {
            control.attr('disabled', 'disabled');
            control.addClass('disabled');
            if (control.hasClass('tt-btn-unlock-for-editing')) {
                control.find('i').removeClass('fa-unlock').addClass('fa-lock');
            }
        }
    } else {
        if (state) {
            if (((access.getRight(control, 'update') > 0 && control.hasClass('tt-right-input-update') && (!checkInitValue || (!utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== '')))
                    || (access.getRight(control, 'write') > 0 && control.hasClass('tt-right-input-write') && (!checkInitValue || (!utils.isUndefined(control[0].dataset) && (utils.isUndefined(control[0].dataset.initValue) || control[0].dataset.initValue === ''))))
                    || (access.getRight(control, 'delete') > 0 && control.hasClass('tt-right-input-delete')))
                && !((access.showPatientsAnonymized() === 1 || utils.GLOBALS.idatPatients === null) && $('#locale').data().pseudonymization !== 'none' && isIDATField)) {
                if (!utils.isFormatValue(utils.getValueFromInputWithDropDownField(control))) {
                    control.removeAttr('disabled');
                }
            }
        } else {
            if (doReset) {
                var format = control[0].dataset.defaultFormatValue;
                if (!utils.isUndefined(format)) {
                    utils.setValueForInputWithDropDownField(control.parent(), format, false);
                }
                control.val('');
            }
            control.attr('disabled', 'disabled');
        }
        if (triggerChangeEvent) {
            if (!control.hasClass('tt-sub-control')) {
                setSubControlsEnabledWithResetOption(control, state, doIntegrityCheckAndCalculation, doReset);
            }
            if (doIntegrityCheckAndCalculation) {
                equalizeControls(control, true);
                setMasterOverviewValues(control);
                utils.GLOBALS.subControlsList.push(control);
            }
        }
    }
    //console.timeEnd('setControlEnabled');
}

function setControlValue(control, value, format, implausibleIntegrity, setInactiveValues, doIntegrityCheckAndCalculation, setSubControls) {

	setSubControls = !utils.isUndefined(setSubControls) ? setSubControls : true;

    //console.time('setControlValue');
    var implausibleIntegrityArray = implausibleIntegrity.split('§');
    if (implausibleIntegrity !== '') {
        control.attr('data-integrity-rule', implausibleIntegrityArray[0] + '#' + implausibleIntegrityArray[2]);
        control.attr('data-integrity-origin-flag', implausibleIntegrityArray[3]);
        if (implausibleIntegrityArray[1] === '1') {
            control.attr('data-confirmed', true);
        } else {
            if (!control.is(':radio') || (control.is(':radio') && control.attr('value') === value.toString())) {
                setControlImplausible(control, implausibleIntegrityArray[4], implausibleIntegrityArray[0] + '#' + implausibleIntegrityArray[2], false, true);
            }
        }
    } else {
        control.removeAttr('data-integrity-rule');
        control.removeAttr('data-confirmed');
        control.removeAttr('data-integrity-origin-flag');
    }

    if (control.hasClass('tt-view-combo-multiselect')) {
        var oldValue = control.select2('val');
        if (value === null) {
            control.val(null).trigger('change.select2');
        } else {
            control.val(value.toString().split('|')).trigger('change.select2');
        }

        var setValue = true;
        if (!setInactiveValues && value !== null) {
            var newValues = [];
            jQuery.each(control.select2('data'), function (i, val) {
                if (utils.isUndefined($(val.element).data().inactive) || !$(val.element).data().inactive) {
                    newValues.push(val.id);
                }
            });
            if (newValues.length === 0) {
                control.val(oldValue).trigger('change.select2');
                setValue = false;
            } else {
                control.val(newValues).trigger('change.select2');
            }
        }
        if (setValue) {

            if (!utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== '') {
                if (access.getRight(control, 'update') === 0) {
                    setControlEnabled(control, false, false, false, false, true);
                    if (access.getRight(control, 'delete') === 0) {
                        $.each(control.parents('[class^="tt-rightclass-"]').find('.tt-btn-unlock-for-editing'), function (i, button_control) {
                            $(button_control).addClass('hide');
                        });
                    }
                }
            } else {
                if (access.getRight(control, 'write') === 0) {
                    setControlEnabled(control, false, false, false, false, true);
                    if (access.getRight(control, 'delete') === 0) {
                        $.each(control.parents('[class^="tt-rightclass-"]').find('.tt-btn-unlock-for-editing'), function (i, button_control) {
                            $(button_control).addClass('hide');
                        });
                    }
                }
            }

            var foundActivationValue = false;
            if (!control.hasClass('tt-sub-control')) {
                jQuery.each(control.select2('data'), function (i, val) {
                    if ($(val.element).data().activation === 1) {
                        setSubControlsEnabled(control, true);
                        foundActivationValue = true;
                    }
                });
                if (!foundActivationValue) {
                    setSubControlsEnabled(control, false);
                }
            }
            if (doIntegrityCheckAndCalculation) {
                equalizeControls(control, false);
                //setMasterOverviewValues(control);
                utils.GLOBALS.subControlsList.push(control);
            }
        }
    } else if (control.hasClass('tt-view-combo')) {
        var oldValue = control.select2('val');
        if (value === null) {
            control.val(null).trigger('change.select2');
            resetCaveLabel(control);
        } else {
            control.val(value).trigger('change.select2');
            var option = control.select2('data')[0];
            setCaveLabel(control, $(option.element).data());
        }
        var newValue = $(control.select2('data')[0].element);

        if (!utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== '') {
            if (access.getRight(control, 'update') === 0) {
                setControlEnabled(control, false, false, false, false, true);
                if (access.getRight(control, 'delete') === 0) {
                    $.each(control.parents('[class^="tt-rightclass-"]').find('.tt-btn-unlock-for-editing'), function (i, button_control) {
                        $(button_control).addClass('hide');
                    });
                }
            }
        } else {
            if (access.getRight(control, 'write') === 0) {
                setControlEnabled(control, false, false, false, false, true);
                if (access.getRight(control, 'delete') === 0) {
                    $.each(control.parents('[class^="tt-rightclass-"]').find('.tt-btn-unlock-for-editing'), function (i, button_control) {
                        $(button_control).addClass('hide');
                    });
                }
            }
        }

        if (setInactiveValues || utils.isUndefined(newValue.data().inactive) || !newValue.data().inactive) {
            if (!control.hasClass('tt-sub-control')) {
                if ($(control.select2('data')[0].element).data().activation === 1) {
                    setSubControlsEnabled(control, true);
                } else {
                    setSubControlsEnabled(control, false);
                }
            }
            if (doIntegrityCheckAndCalculation) {
                equalizeControls(control, false);
                //setMasterOverviewValues(control);
                utils.GLOBALS.subControlsList.push(control);
            }
        } else {
            control.val(oldValue).trigger('change.select2');
        }
    } else if (control.is(':checkbox')) {
        control.prop('checked', (value === 'on' || value === '1' || value === 1));

        if (!utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== '') {
            if (access.getRight(control, 'delete') === 0) {
                setControlEnabled(control, false, false, false, false, true);
            }
        }

        if (!control.hasClass('tt-sub-control')) {
            setSubControlsEnabledForCheckBox(control, doIntegrityCheckAndCalculation, true);
        }
        if (doIntegrityCheckAndCalculation) {
            equalizeControls(control, false);
            //setMasterOverviewValues(control);
            utils.GLOBALS.subControlsList.push(control);
        }
    } else if (control.is(':radio')) {
        if (value === null || control.attr('value') === value.toString()) {
            if (setInactiveValues || utils.isUndefined(control.data().inactive) || !control.data().inactive || utils.isUndefined(value)) {
                //console.time('setControlValue1');
                if (value === null) {
                    control.prop('checked', false);
                    resetCaveLabel(control);
                    if (utils.isUndefined(control.data().inactive) && control.data().inactive) {
                        control.parent().addClass('hide');
                    }
                } else {
                    control.prop('checked', true);
                    control.parent().removeClass('hide');
                    setCaveLabel(control, control.data());
                }
                //console.timeEnd('setControlValue1');
                //console.time('setControlValue2');

                if (!utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== '') {
                    if (access.getRight(control, 'update') === 0) {
                        $.each($(control.parents('.row')[0]).find('[name="' + control.attr('name') + '"]'), function (i, radiobutton) {
                            setControlEnabled($(radiobutton), false, false, false, false, true);
                        });
                        if (access.getRight(control, 'delete') === 0) {
                            $.each(control.parents('[class^="tt-rightclass-"]').find('.tt-btn-unlock-for-editing'), function (i, button_control) {
                                $(button_control).addClass('hide');
                            });
                        }
                    }
                } else {
                    if (access.getRight(control, 'write') === 0) {
                        $.each($(control.parents('.row')[0]).find('[name="' + control.attr('name') + '"]'), function (i, radiobutton) {
                            setControlEnabled($(radiobutton), false, false, false, false, true);
                        });
                        if (access.getRight(control, 'delete') === 0) {
                            $.each(control.parents('[class^="tt-rightclass-"]').find('.tt-btn-unlock-for-editing'), function (i, button_control) {
                                $(button_control).addClass('hide');
                            });
                        }
                    }
                }
                //console.timeEnd('setControlValue2');
                //console.time('setControlValue3');

                if (!control.hasClass('tt-sub-control') && !control.parents('.tt-sub-control').length && setSubControls) {
                    setSubControlsEnabledForRadioButton(control, doIntegrityCheckAndCalculation, true, false);
                }
                //console.timeEnd('setControlValue3');
                //console.time('setControlValue4');
                if (doIntegrityCheckAndCalculation) {
                    equalizeControls(control, false);
                    //setMasterOverviewValues(control);
                    utils.GLOBALS.subControlsList.push(control);
                }
                //console.timeEnd('setControlValue4');
            }
        }
    } else {
    	if (!utils.isUndefined(format) && format !== '') {
            var changeDisabledState = ((access.getRight(control, 'write') > 0 && !utils.isUndefined(control[0].dataset) && (utils.isUndefined(control[0].dataset.initValue) || control[0].dataset.initValue === ''))
                || (access.getRight(control, 'update') > 0 && !utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== ''))
                && (!control.hasClass('tt-unlock-for-editing') || (control.hasClass('tt-unlock-for-editing') && value === null)) && (!control.hasClass('tt-is-calculated') || (control.hasClass('tt-is-editable-calculation') && (utils.isUndefined(control[0].dataset.calculatedValue) || control[0].dataset.calculatedValue === '')));

			if (utils.isFormatValue(format) && control.hasClass('datepicker')) {
				control.data('picker').setDate(null);
			}
            utils.setValueForInputWithDropDownField(control.parent(), format, changeDisabledState);
        }
		if (utils.isUndefined(value) || value === '') {
			if (utils.isUndefined(format) || !utils.isFormatValue(format)) {
				if (control.hasClass('datepicker')) {
					control.data('picker').setDate(null);
				} else {
					control.val('');
				}
			}
		} else {
            if (value !== '') {
                if (control.hasClass('datepicker')) {
                    control.data('picker').setDate(utils.stringToDate(value));
                } else if (control.hasClass('tt-input-decimal')) {
                    var displayDecimals = null;
                    if (!utils.isUndefined(control.data().displayDecimals) && control.data().displayDecimals !== '') {
                        displayDecimals = control.data().displayDecimals;
                    }
                    control.val(utils.numberToString(parseFloat(value), parseFloat(displayDecimals)));
                } else {
                    control.val(value);
                }
            }
        }

        if (!utils.isUndefined(control[0].dataset.initValue) && control[0].dataset.initValue !== '') {
            if (access.getRight(control, 'update') === 0) {
                setControlEnabled(control, false, false, false, false, true);
                if (control.parents('.tt-view-input-label').find('button.btn-dropdown').length) {
                    setControlEnabled(control.parents('.tt-view-input-label').find('button.btn-dropdown'), false, false, false, false, true);
                }
                if (access.getRight(control, 'delete') === 0) {
                    $.each(control.parents('[class^="tt-rightclass-"]').find('.tt-btn-unlock-for-editing'), function (i, button_control) {
                        $(button_control).addClass('hide');
                    });
                }
                $.each(control.parents('[class^="tt-rightclass-"]').find('.tt-btn-assume-examination-date'), function (i, button_control) {
                    $(button_control).addClass('hide');
                });
            }
        } else {
            if (access.getRight(control, 'write') === 0) {
                setControlEnabled(control, false, false, false, false, true);
                if (control.parents('.tt-view-input-label').find('button.btn-dropdown').length) {
                    setControlEnabled(control.parents('.tt-view-input-label').find('button.btn-dropdown'), false, false, false, false, true);
                }
                if (access.getRight(control, 'delete') === 0) {
                    $.each(control.parents('[class^="tt-rightclass-"]').find('.tt-btn-unlock-for-editing'), function (i, button_control) {
                        $(button_control).addClass('hide');
                    });
                }
                $.each(control.parents('[class^="tt-rightclass-"]').find('.tt-btn-assume-examination-date'), function (i, button_control) {
                    $(button_control).addClass('hide');
                });
            }
        }

        if (doIntegrityCheckAndCalculation) {
            equalizeControls(control, false);
            //setMasterOverviewValues(control);
            utils.GLOBALS.subControlsList.push(control);
        }
    }

    setMasterOverviewValues(control);
    //console.timeEnd('setControlValue');
}

function setQueryValue(control, queryQuestion, queryQuestionDate, queryAnswer, queryAnswerDate, queryId, queryClosed, setQueryDate, setQueryId, queryHistoryObjectList) {

    var queryHistoryExist = ( !utils.isUndefined(queryHistoryObjectList) && queryHistoryObjectList.length > 0);
    setQueryDate = utils.isUndefined(setQueryDate) ? false : true;

    control[0].dataset.queryQuestion = queryQuestion;
    control[0].dataset.queryAnswer = queryAnswer;

    if (setQueryDate) {
        control[0].dataset.queryQuestionDate = queryQuestionDate;
        control[0].dataset.queryAnswerDate = queryAnswerDate;
    } else {
        queryQuestionDate = control[0].dataset.queryQuestionDate;
        if (control[0].dataset.queryQuestionDate === 'null') {
            queryQuestionDate = null;
        }
        queryAnswerDate = control[0].dataset.queryAnswerDate;
        if (control[0].dataset.queryAnswerDate === 'null') {
            queryAnswerDate = null;
        }
    }

    if (setQueryId) {
        control[0].dataset.queryId = queryId;
    }

    var isFirstQueryClosed = false;
    if(queryQuestion === "" && queryAnswer === "" && queryClosed === "" && queryHistoryExist) {
        isFirstQueryClosed = true;
        control[0].dataset.queryClosed = 0;
    }

    $.each(control.parents('[class^="tt-rightclass-"]').find('.tt-btn-query[data-control="' + $(control).attr('name') + '"]'), function (i, button_control) {
        if (access.getRight(control, 'create_query') > 0
            || (access.getRight(control, 'answer_query') > 0 && (queryQuestion.length || queryHistoryExist))
            || (access.getRight(control, 'close_query') > 0 && (queryAnswer.length || queryHistoryExist))) {
            $(button_control).removeClass('hide');

            if (isFirstQueryClosed && queryHistoryExist) {
                if(access.getRight(control, 'create_query') > 0) {
                    $(button_control).removeClass('tt-btn-query-closed');
                } else {
                    $(button_control).addClass('tt-btn-query-closed');
                }
            } else {
                $(button_control).removeClass('tt-btn-query-closed');
            }

            if (queryAnswer.length && access.getRight(control, 'close_query') > 0) {
                $(button_control).attr('data-original-title', trans('tripletrax.close_query'));
            } else if (queryQuestion.length && access.getRight(control, 'answer_query') > 0) {
                $(button_control).attr('data-original-title', trans('tripletrax.answer_query'));
            } else {
                $(button_control).attr('data-original-title', trans('tripletrax.create_query'));
            }

            var form = getQueryForm(button_control, queryQuestion, queryQuestionDate, queryAnswer, queryAnswerDate, queryClosed, queryHistoryObjectList);
            if (form !== null) {
                $(button_control).attr('data-content', form);
                if (utils.isUndefined($(button_control).data('bs.popover'))) {
                    $(button_control).popover({
                        placement: function (context, source) {
                            var offset = $(source).offset();

                            if (offset.left > $(window).width() - 400) {
                                return "left";
                            }

                            return "right";
                        },
                        template: '<div class="popover popover-draggable" style="min-width: 370px;min-height: 420px"><div class="arrow"></div><h3 class="popover-title popover-draggable-handle"></h3><div class="popover-content"></div></div>'
                    });
                } else {
                    $(button_control).data('bs.popover').setContent();
                }
            }
        } else {
            $(button_control).addClass('hide');
        }
    });
}

function getControlValue(controls) {
    var returnValue = '';

    jQuery.each(controls, function(i, contr) {
        var control = $(contr);
        if (control.hasClass('tt-view-combo-multiselect')) {
            var currentValue = control.select2('data');
            jQuery.each(currentValue, function(k, val) {
                if (returnValue !== '') {
                    returnValue += '|';
                }
                if (!utils.isUndefined($(val.element).data().match)) {
                    returnValue += val.id + "=" + $(val.element).data().match;
                } else {
                    returnValue += val.id;
                }
            });
        } else if (control.hasClass('tt-view-combo')) {
            var currentValue = control.select2('data');
            if (!utils.isUndefined(currentValue)) {
                if (!utils.isUndefined($(currentValue[0].element).data().match)) {
                    returnValue = currentValue[0].id + "=" + $(currentValue[0].element).data().match;
                } else {
                    returnValue = currentValue[0].id;
                }
            }
        } else if (control.is(':checkbox')) {
            returnValue = control.is(':checked');
        } else if (control.is(':radio')) {
            if (control.is(':checked')) {
                if (!utils.isUndefined(control.data().match)) {
                    returnValue = control.attr('value') + "=" + control.data().match;
                } else {
                    returnValue = control.attr('value');
                }
            }
        } else if (control.hasClass('datepicker')) {
            var value = control.data('picker').getDate();
            if (!utils.isUndefined(value) && value !== '') {
                if (utils.getValueFromInputWithDropDownField(control) === 'yy') {
                    returnValue = utils.dateToString(value).split('-')[0] + "-07-01=yy";
                } else if (utils.getValueFromInputWithDropDownField(control) === 'mm/yy') {
                    returnValue = utils.dateToString(value).split('-')[0] + "-" + utils.dateToString(value).split('-')[1] + "-15=mm/yy";
                } else {
                    returnValue = utils.dateToString(value) + "=" + utils.getValueFromInputWithDropDownField(control);
                }
            } else {
                returnValue = control.val() + "=" + utils.getValueFromInputWithDropDownField(control);
            }
        } else {
            returnValue = control.val() + "=" + utils.getValueFromInputWithDropDownField(control);
        }
    });

    return returnValue.toString();
}

function calculateValues(controls, calculateSubElements, formData, checkFieldsInOtherExaminations) {

    if (isDevice() || ($('.tab-content').data().isPreview !== 'true' && !$('.tab-content').data().isPreview)) {
        var controlNameArray = [];
        jQuery.each(controls, function (i, control) {

            if (control.hasClass('tt-check-calculation') && !utils.isUndefined(control.attr('name')) && !(control.attr('name') in controlNameArray)) {
                controlNameArray.push(control.attr('name'));
            }
        });

        if (controlNameArray.length) {

            utils.GLOBALS.runningAjaxRequests.push($.Deferred(function (defer) {
                if (utils.isUndefined(formData)) {
                    formData = getFormDataForAjaxCall(false, true, false);
                }
                if (utils.isUndefined(checkFieldsInOtherExaminations)) {
                    checkFieldsInOtherExaminations = true;
                }
                var preTag = 'doc/patient/patient';
                if (isDevice()) {
                	preTag = 'device/questionnaires/questionnaire';
				}
                ajax.ajaxCall(preTag + '/calculation/' + controlNameArray.join('|') + '/facility/' + getFacilityId() + '/model/' + getModelId() + '/patient/' + getPatientId() + '/examination/' + getExaminationDate(), 'POST', formData, false, function (data) {
                    var currentFormData = [];

					if (isDevice()) {
						currentFormData = $('#is_device').data('questionnaireFormData');
					} else if (isExaminationSelected()) {
                        currentFormData = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data');
                    } else {
                        currentFormData = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data');
                    }

                    if (utils.isUndefined(currentFormData) || utils.isUndefined(data) || data.length <= 0) {
                        defer.resolve();
                        return;
                    }

                    if (data.length === 2) {
                        // Felder, welche in anderen Untersuchungen neu berechnet werden müssen, setzen
                        if (checkFieldsInOtherExaminations) {
                            for (var key in data[1]) {
                                $('[name="' + key + '"]').attr('calculate-other-examinations', data[1][key]);
                            }
                        }

                        // Ergebnisse der Berechnungen setzen
                        jQuery.each(data[0], function (i, controlData) {
                            var elementsWithCompleteness = [];
                            var elementsWithIntegrity = [];
                            jQuery.each(controlData.split('|'), function (i, val) {
                                var splitted_field = val.split('=');
                                if (val === '' || splitted_field[1] === '') {
                                    currentFormData[splitted_field[0]] = '';
                                } else {
                                    var splitted_value = splitted_field[1].split('#');
                                    currentFormData[splitted_field[0]] = parseFloat(splitted_value[0]);
                                    if (splitted_value.length > 2) {
                                        currentFormData[splitted_field[0] + '_format'] = splitted_value[2];
                                    }
                                }

                                jQuery.each($('[name="' + splitted_field[0] + '"]'), function (k, element) {
									if ($($(element).parents('.tt-doc-pane')[0]).hasClass('data-loaded') || isDevice()) {
                                        if (val === '' || splitted_field[1] === '') {
                                            $(element).val('');
                                            element.dataset.calculatedValue = '';
                                        } else {
                                            var splitted_value = splitted_field[1].split('#');
                                            var displayDecimals = null;
                                            if (!utils.isUndefined($(element).data().displayDecimals) && $(element).data().displayDecimals !== '') {
                                                displayDecimals = $(element).data().displayDecimals;
                                            }
											var value = splitted_value[0];
                                            if (!utils.isUndefined(displayDecimals)) {
												value = utils.getLocaleNumberString(utils.numberToString(parseFloat(splitted_value[0])), displayDecimals);
											}
                                            element.dataset.calculatedValue = value;
                                            if (splitted_field[2] !== '') {
                                                if (splitted_field[2] === 'percentile') {
                                                    var zScore = splitted_value[1];
                                                    var zScoreSign = '';
                                                    if (/^-/.test(zScore)) {
                                                        zScoreSign = '-';
                                                        zScore = zScore.substr(1);
                                                    }
                                                    value = 'P' + value + ' / z' + zScoreSign + utils.numberToString(parseFloat(zScore));
                                                } else if (splitted_field[2] === 'norm') {
                                                    value = trans('tripletrax.norm') + ': ' + value + ' ' + splitted_field[3];
                                                    if (splitted_value.length > 1) {
                                                        value += ' (' + utils.numberToString(parseFloat(splitted_value[1])) + '%)';
                                                    }
                                                }
                                            }
                                            $(element).val(value);
                                        }
                                        if ($(element).hasClass('tt-is-editable-calculation')) {
											var state = element.dataset.calculatedValue === '';
											setControlEnabled($(element), state, !state, false, false, false, true);
											setControlEnabled($('.tt-btn-eraser[data-control="' + splitted_field[0] + '"]'), state, !state, false, false, false, true);
										}

                                        if ($(element).hasClass('tt-check-completeness')) {
                                            // Für berechnete Felder welcher in einer Abhängigkeit (Vollständigkeit) vorkommen muss die Vollständigkeitsprüfung aufgerufen werden
											elementsWithCompleteness.push($(element));
                                        }

										if ($(element).hasClass('tt-check-integrity')) {
											// Für berechnete Felder welcher in einer Abhängigkeit (Integrität) vorkommen muss die Integritätsprüfung aufgerufen werden
											elementsWithIntegrity.push($(element));
										}
                                    }
                                });
                                if (calculateSubElements && $('[name="' + splitted_field[0] + '"]').hasClass('tt-check-calculation')) {
                                    if (isExaminationSelected()) {
                                        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', currentFormData);
                                    } else {
                                        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data', currentFormData);
                                    }
                                    calculateValues([$('[name="' + splitted_field[0] + '"]')], true, null, checkFieldsInOtherExaminations);
                                }
                            });
                            if (i + 1 === data[0].length) {
								if (isDevice()) {
									$('#is_device').data('questionnaireFormData', currentFormData);
								} else if (isExaminationSelected()) {
                                    $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', currentFormData);
                                } else {
                                    $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data', currentFormData);
                                }

								if (elementsWithCompleteness.length) {
									setCompleteness(null, currentFormData);
								}
								if (elementsWithIntegrity.length) {
									addToIntegrityList(elementsWithIntegrity, true, false);
								}
                                defer.resolve();
                            }
                        });
                    }
                });
            }));
        }
    }
}

function checkRights(control) {

    if (!utils.isUndefined(control[0].dataset) && !utils.isUndefined(control[0].dataset.initValue)
        && control[0].dataset.initValue !== '' && (getControlValue(control).split('=')[0] === '' || (getControlValue(control).split('=')[0] === 'false' && control.is(':checkbox')))
        && access.getRight(control, 'delete') === 0) {
        if ((control.is(':radio') && !control.parent().parent().hasClass('state-error')) || !control.is(':radio')) {
            setControlImplausible(control, 'S|' + Lang.get('tripletrax.no_right_to_delete'), 'no_rights', true, false);
        }
        return false;
    } else {
        resetControl(control, true);
    }

    return true;
}

function checkPrimaryKey(control) {

    if ((control.parents('.tt-list').length || control.parents('.tt-accordion-as-list').length) && control.hasClass('tt-primary-key')) {
        if (control.parents('.tt-list').length) {

            // Primärschlüssel der aktuellen Zeile vor Änderung
            var oldPrimaryKeyValue = control.parents('tr').data().primaryKeyValue;

            // Primärschlüssel der aktuellen Zeile nach Änderung
            var currentPrimaryKeyValue = '';
            jQuery.each(control.parents('tr').find('.tt-primary-key'), function(k, element) {
                currentPrimaryKeyValue += getControlValue($(element));
            });

            var primaryKeyValues = [];
            var rowIndexOldPrimaryKeyValues = [];
            var dataTable = $(control.parents('table')).DataTable();
            var currentRowIndex = $(control.parents('table')).dataTable().fnGetData(control.parents('tr')[0])[0];
            for (var i = 0; i < dataTable.data().length; i++) {

                // alle Zeilen (außer der aktuellen Zeile) durchgehen
                if (dataTable.data()[i][0] !== currentRowIndex) {
                    var row = $(dataTable.row(i).node());

                    // Primärschlüssel der Zeile ermitteln
                    var primaryKeyValue = '';
                    jQuery.each(row.find('.tt-primary-key'), function (k, element) {
                        primaryKeyValue += getControlValue($(element));
                    });
                    if (primaryKeyValue !== '') {
                        primaryKeyValues.push(primaryKeyValue);
                    }

                    // ist der Primärschlüssel gleich dem Primärschlüssel der aktuellen Zeile vor Änderung, dann die Zeile merken (um diese eventuell zurückzusetzen)
                    if (primaryKeyValue === oldPrimaryKeyValue) {
                        rowIndexOldPrimaryKeyValues.push(dataTable.data()[i][0]);
                    }

                    // Primärschlüssel der Zeile setzen
                    row.data('primaryKeyValue', primaryKeyValue);
                }
            }

            // Primärschlüssel der aktuellen Zeile setzen
            control.parents('tr').data('primaryKeyValue', currentPrimaryKeyValue);

            // kommt der Primärschlüssel der aktuellen Zeile vor Änderung nur noch einmal vor, dann diese Zeile auch zurücksetzen
            if (rowIndexOldPrimaryKeyValues.length === 1) {
                for (var i = 0; i < dataTable.data().length; i++) {
                    if (dataTable.data()[i][0] === rowIndexOldPrimaryKeyValues[0]) {
                        var row = $(dataTable.row(i).node());
                        jQuery.each(row.find('.tt-primary-key'), function (k, element) {
                            resetControl($(element), true);
                            addToIntegrityList([$(element)], true, false);
                        });
                    }
                }
            }

            // wurde der Primärschlüssel nochmals gefunden, dann das aktuelle Element markieren
            var foundPrimaryKey = false;
            if (jQuery.inArray(currentPrimaryKeyValue, primaryKeyValues) > -1) {
                setTimeout(function() {
                    setControlImplausible(control, 'S|' + Lang.get('tripletrax.duplicate_primary_key'), 'primary_key', true, false);
                }, 100);
                foundPrimaryKey = true;
                return false;
            }

            // wurde der Primärschlüssel nicht gefunden, dann die aktuelle Zeile zurücksetzen
            if (!foundPrimaryKey) {
                jQuery.each(control.parents('tr').find('.tt-primary-key'), function (k, element) {
                    resetControl($(element), true);
                    addToIntegrityList([$(element)], true, false);
                });
            }

        } else {

            // Primärschlüssel der aktuellen Zeile vor Änderung
            var oldPrimaryKeyValue = control.parents('.tt-accordion-panel').data().primaryKeyValue;

            // Primärschlüssel der aktuellen Zeile nach Änderung
            var currentPrimaryKeyValue = '';
            jQuery.each(control.parents('.tt-accordion-panel').find('.tt-primary-key'), function(k, element) {
                currentPrimaryKeyValue += getControlValue($(element));
            });

            var rowIndexOldPrimaryKeyValues = [];
            var primaryKeyValues = [];
            var currentRowIndex = control.parents('.tt-accordion-panel').data().rowId;
            jQuery.each(control.parents('.tt-accordion-as-list').find('.tt-accordion-panel'), function (i, panel) {

                // alle Zeilen (außer der aktuellen Zeile) durchgehen
                if ($(panel).data().rowId !== currentRowIndex) {

                    // Primärschlüssel der Zeile ermitteln
                    var primaryKeyValue = '';
                    jQuery.each($(panel).find('.tt-primary-key'), function (k, element) {
                        primaryKeyValue += getControlValue($(element));
                    });
                    if (primaryKeyValue !== '') {
                        primaryKeyValues.push(primaryKeyValue);
                    }

                    // ist der Primärschlüssel gleich dem Primärschlüssel der aktuellen Zeile vor Änderung, dann die Zeile merken (um diese eventuell zurückzusetzen)
                    if (primaryKeyValue === oldPrimaryKeyValue) {
                        rowIndexOldPrimaryKeyValues.push($(panel).data().rowId);
                    }

                    // Primärschlüssel der Zeile setzen
                    $(panel).data('primaryKeyValue', primaryKeyValue);
                }
            });

            // Primärschlüssel der aktuellen Zeile setzen
            control.parents('.tt-accordion-panel').data('primaryKeyValue', currentPrimaryKeyValue);

            // kommt der Primärschlüssel der aktuellen Zeile vor Änderung nur noch einmal vor, dann diese Zeile auch zurücksetzen
            if (rowIndexOldPrimaryKeyValues.length === 1) {
                jQuery.each(control.parents('.tt-accordion-as-list').find('.tt-accordion-panel'), function (i, panel) {
                    if ($(panel).data().rowId === rowIndexOldPrimaryKeyValues[0]) {
                        jQuery.each($(panel).find('.tt-primary-key'), function (k, element) {
                            resetControl($(element), true);
                            addToIntegrityList([$(element)], true, false);
                        });
                    }
                });
            }

            // wurde der Primärschlüssel nochmals gefunden, dann das aktuelle Element markieren
            var foundPrimaryKey = false;
            if (jQuery.inArray(currentPrimaryKeyValue, primaryKeyValues) > -1) {
                setTimeout(function() {
                    setControlImplausible(control, 'S|' + Lang.get('tripletrax.duplicate_primary_key'), 'primary_key', true, false);
                }, 100);
                foundPrimaryKey = true;
                return false;
            }

            // wurde der Primärschlüssel nicht gefunden, dann die aktuelle Zeile zurücksetzen
            if (!foundPrimaryKey) {
                jQuery.each(control.parents('.tt-accordion-panel').find('.tt-primary-key'), function(k, element) {
                    resetControl($(element), true);
                    addToIntegrityList([$(element)], true, false);
                });
            }

        }
    }
    return true;
}

function addToIntegrityList(controls, showPopup, checkOnlyMandatoryFields, doIntegrityCheck) {

    if (!isDevice() && $('.tab-content').data().isPreview !== 'true' && !$('.tab-content').data().isPreview) {
        if (utils.GLOBALS.timerIntegrity) {
            clearTimeout(utils.GLOBALS.timerIntegrity); //cancel the previous timer.
            utils.GLOBALS.timerIntegrity = null;
        }
        $.merge(utils.GLOBALS.integrityControlList, controls);
        utils.GLOBALS.timerIntegrity = setTimeout(function () {
			if (utils.isUndefined(doIntegrityCheck) || doIntegrityCheck) {
				checkIntegrity($.merge([], utils.GLOBALS.integrityControlList), showPopup, checkOnlyMandatoryFields, null, true)
			}
        }, 1000);
    }
}

function removeFromIntegrityList(control, showPopup, checkOnlyMandatoryFields) {

    if (utils.GLOBALS.timerIntegrity) {
        clearTimeout(utils.GLOBALS.timerIntegrity); //cancel the previous timer.
        utils.GLOBALS.timerIntegrity = null;
    }
    var index = utils.GLOBALS.integrityControlList.indexOf(control);
    if (index >= 0) {
        utils.GLOBALS.integrityControlList.splice(index, 1);
    }

    if (utils.GLOBALS.integrityControlList.length) {
        utils.GLOBALS.timerIntegrity = setTimeout(function () {
            checkIntegrity($.merge([], utils.GLOBALS.integrityControlList), showPopup, checkOnlyMandatoryFields, null, true)
        }, 1000);
    }
}

function checkIntegrity(controls, showPopup, checkOnlyMandatoryFields, formData, clearIntegrityControlList, checkOtherExaminations) {

    if (!isDevice() && $('.tab-content').data().isPreview !== 'true' && !$('.tab-content').data().isPreview) {

        if (!utils.isUndefined(clearIntegrityControlList) && clearIntegrityControlList) {
            utils.GLOBALS.integrityControlList.length = 0;
        }
		checkOtherExaminations = utils.isUndefined(checkOtherExaminations) || (!utils.isUndefined(checkOtherExaminations) && checkOtherExaminations);

        var isCreatePatientForm = false;
        var isCreateExaminationForm = false;
        var controlNameArray = [];
        jQuery.each(controls, function (i, control) {

            if (control.hasClass('tt-check-integrity') && !control.hasClass('tt-hide') && !utils.isUndefined(control.attr('name')) && !(control.attr('name') in controlNameArray)) {
                if (jQuery.inArray(control.attr('name'), controlNameArray) < 0) {
                    controlNameArray.push(control.attr('name'));
                    if (control.parents('.tt-create-patient').length) {
						isCreatePatientForm = true;
                    } else if (control.parents('.tt-examination-date-integrity').length) {
						isCreateExaminationForm = true;
					}
                }
            }
        });

        if (controlNameArray.length) {
            utils.GLOBALS.runningAjaxRequests.push($.Deferred(function (defer) {
                if (utils.isUndefined(formData)) {
                    if (isCreatePatientForm) {
						formData = utils.getSerializedFormData($('#table_patientlist_create_form'));
					} else if (isCreateExaminationForm) {
						formData = utils.getSerializedFormData($('#table_patient_examination_create_form'));
                    } else {
						formData = getFormDataForAjaxCall(true, false, false);
                    }
                }
                if (checkOnlyMandatoryFields) {
                    formData += '&onlyMandatoryFields=true';
                }
                if (!checkOtherExaminations) {
					formData += '&checkOtherExaminations=false';
				}

                // console.time('checkIntegrity');
                ajax.ajaxCall('doc/patient/patient/integrity/' + controlNameArray.join('|') + '/facility/' + getFacilityId() + '/model/' + getModelId() + '/patient/' + getPatientId() + '/examination/' + getExaminationDate() + '/examination_facility/' + getExaminationFacilityId(), 'POST', formData, false, function (data) {

					// console.timeEnd('checkIntegrity');
					// console.time('setIntegrity');
                    if (utils.isUndefined(data) || data.length <= 0) {
                        defer.resolve();
                        return;
                    }
                    var deferredArray = [];

                    var i = 0;
                    for (var key in data) {
                        var splitted_data = data[key][0].split('$');
                        if (splitted_data[0] !== '') {
                            jQuery.each(controls, function (k, control) {
                                if (control.attr('name') === splitted_data[0]) {

                                    if (splitted_data.length === 4) {
                                        if (splitted_data[1] !== '' || (data[key][1].length && (Object.keys(data[key][1][0]).length || Object.keys(data[key][1][1]).length))) {
                                            // Entweder die aktuelle Prüfung ist fehlgeschlagen oder die Prüfung anderer Untersuchungen
                                            var integrityText = splitted_data[1];
                                            if (splitted_data[1] === '') {
                                                integrityText = 'P|';
                                            }
                                            var integrityRule = splitted_data[3];
                                            if (splitted_data[3] === '') {
                                                integrityRule = 'other_examinations';
                                            }
                                            deferredArray.push(setControlImplausible(control, integrityText, integrityRule, showPopup, false, data[key][1][0], data[key][1][1]));
                                        } else {
                                            if (!checkOnlyMandatoryFields) {
                                                resetControl(control, true);
                                                if ($(control.parents('.tt-doc-pane')[0]).hasClass('data-loaded')) {
                                                    setFormDataForAjaxCall($(control.parents('.tab-pane')[0]), true, true);
                                                }
                                            }
                                        }

                                        if (splitted_data[2] !== '') {
                                            var splitted_fields = splitted_data[2].split('|');
                                            jQuery.each(splitted_fields, function (i, val) {
                                                if ($($('[name="' + val + '"]').parents('.row')[0]).find('[data-integrity-popover]').length) {
                                                    if (!((!utils.isUndefined($('[name="' + val + '"]')[0].dataset.confirmed) && ($('[name="' + val + '"]')[0].dataset.confirmed === true || $('[name="' + val + '"]')[0].dataset.confirmed === "true")) ||
                                                            (!utils.isUndefined($('[name="' + val + '"]')[0].dataset.integrityOriginFlag) && utils.isIgnoreFlagForIntegrityCheck($('[name="' + val + '"]')[0].dataset.integrityOriginFlag)))) {
                                                        addToIntegrityList([$('[name="' + val + '"]')], showPopup, false);
                                                    }
                                                }
                                            });
                                        }
                                    } else {
                                        if (!checkOnlyMandatoryFields) {
                                            resetControl(control, true);
                                            if ($(control.parents('.tt-doc-pane')[0]).hasClass('data-loaded')) {
                                                setFormDataForAjaxCall($(control.parents('.tab-pane')[0]), true, true);
                                            }
                                        }
                                    }
                                }
                                if (k + 1 === controls.length && i + 1 === Object.keys(data).length) {
                                    $.when.apply($, deferredArray).done(function () {
                                        defer.resolve();
                                    });
                                }
                            });
                        } else {
                            defer.resolve();
                        }

                        i++;
                    }
					// console.timeEnd('setIntegrity');
                });
            }));
        }
    }
}

function setCompleteness(control, formData, addToRunningAjaxRequests, time, setCompletenessBeforeSave) {

    if (utils.isUndefined(time)) {
        time = 1000;
    }
    if (utils.isUndefined(setCompletenessBeforeSave)) {
		setCompletenessBeforeSave = false;
	}
    if (!isDevice() && $('.tab-content').data().isPreview !== 'true' && !$('.tab-content').data().isPreview) {
		var course = utils.getCourse();
		var master = utils.getMaster();
        if (master.find('.tt-check-completeness:not(.tt-hide)').length <= 0 && course.find('.tt-check-completeness:not(.tt-hide)').length <= 0) {

			master.find('.tt-completeness-section').addClass(('hide'));
			course.find('.tt-completeness-section').addClass(('hide'));
            $('.tt-completeness-tab-icon,.tt-completeness-tab-icon-missing-all,.tt-completeness-tab-icon-complete').addClass('hide');

        } else {

            if (control !== null && $(control).parents('.tt-content-master').length) {
                $(control).attr('check-completeness-all-patient', true);
            }
            if (control !== null && control.hasClass('tt-check-completeness-other-examination') && !control.hasClass('tt-hide')) {
                $(control).attr('check-completeness-all-examination', true);
            }
            if (control !== null && ($(control).parents('.tt-content-master').length || (control.hasClass('tt-check-completeness-other-examination') && !control.hasClass('tt-hide')))) {
                setFormDataForAjaxCall($($(control).parents('.tab-pane')[0]), true, true);
            }

            if (control === null || (control.hasClass('tt-check-completeness') && !control.hasClass('tt-hide'))) {

                if (!utils.isUndefined(utils.GLOBALS.runningCompletenessRequest) && utils.GLOBALS.runningCompletenessRequest.state() === 'pending') {
                    utils.GLOBALS.startNewCompletenessRequest = true;
                } else {
					if (!utils.isUndefined(addToRunningAjaxRequests) && addToRunningAjaxRequests) {
						if (utils.isUndefined(formData)) {
							formData = getFormDataForAjaxCall(true, true, false);
						}
						utils.GLOBALS.runningAjaxRequests.push(setCompletenessAjaxCall(formData, setCompletenessBeforeSave));
					} else {
						if (utils.GLOBALS.timerCompleteness) {
							clearTimeout(utils.GLOBALS.timerCompleteness); //cancel the previous timer.
							utils.GLOBALS.timerCompleteness = null;
						}
						utils.GLOBALS.timerCompleteness = setTimeout(function () {
							if (utils.isUndefined(formData)) {
								formData = getFormDataForAjaxCall(true, true, false);
							}
							if (!utils.isUndefined(formData)) {
								utils.GLOBALS.runningCompletenessRequest = setCompletenessAjaxCall(formData, setCompletenessBeforeSave);
							} else {
								setCompleteness(control, null, false);
                            }

						}, time);
					}
                }
            }
        }
    }
}

function setCompletenessAjaxCall(formData, setCompletenessBeforeSave) {

    return $.Deferred(function (defer) {

		if ($('#live_completeness_check').val() !== '1' && !setCompletenessBeforeSave) {
			defer.resolve();
			return;
		}
		if ($('#live_completeness_check').val() !== '1' && $('.tt-completeness-live').hasClass('hide')) {
			utils.getMaster().find('.tt-completeness-progress').attr('data-transitiongoal', 0).attr('aria-valuenow', 0);
			utils.getCourse().find('.tt-completeness-progress').attr('data-transitiongoal', 0).attr('aria-valuenow', 0);
			utils.getMaster().find('.tt-completeness-progress').progressbar({
				display_text: 'fill'
			});
			utils.getCourse().find('.tt-completeness-progress').progressbar({
				display_text: 'fill'
			});
			utils.getMaster().find('.tt-completeness-progress').text("0%");
			utils.getCourse().find('.tt-completeness-progress').text("0%");
			$('.tt-completeness-on-save').addClass('hide');
			$('.tt-completeness-live').removeClass('hide');
		}

		// console.time('setCompletenessAjaxCall');
        ajax.ajaxCall('doc/patient/patient/completeness/facility/' + getFacilityId() + '/model/' + getModelId() + '/patient/' + getPatientId() + '/examination/' + getExaminationDate() + '/examination_facility/' + getExaminationFacilityId(), 'POST', formData, false, function (data) {
            //var examinationDate = getExaminationDate();
			// console.timeEnd('setCompletenessAjaxCall');
			// console.time('setCompleteness');
            var completenessFieldCount = data[1];
            var completenessTabFieldCount = data[2];
            var missing_fields_tab_list = data[3];
            var splitted_optional = data[0].split('$');
            var splitted_data = splitted_optional[0].split('|');
            var missing_fields = 0;
            if (splitted_optional[0] !== '') {
                missing_fields = splitted_data.length;
            }

            var completeness = 100;
            if (completenessFieldCount > 0) {
                completeness = Math.floor(((completenessFieldCount - missing_fields) / completenessFieldCount) * 100);
            }

            if (completeness <= 25) {
                utils.getMaster().find('.tt-completeness-progress').removeClass('tt-bg-color-yellow tt-bg-color-green').addClass('tt-bg-color-red');
                utils.getCourse().find('.tt-completeness-progress').removeClass('tt-bg-color-yellow tt-bg-color-green').addClass('tt-bg-color-red');
            } else if (completeness > 25 && completeness <= 75) {
				utils.getMaster().find('.tt-completeness-progress').removeClass('tt-bg-color-green tt-bg-color-red').addClass('tt-bg-color-yellow');
				utils.getCourse().find('.tt-completeness-progress').removeClass('tt-bg-color-green tt-bg-color-red').addClass('tt-bg-color-yellow');
            } else {
				utils.getMaster().find('.tt-completeness-progress').removeClass('tt-bg-color-yellow tt-bg-color-red').addClass('tt-bg-color-green');
				utils.getCourse().find('.tt-completeness-progress').removeClass('tt-bg-color-yellow tt-bg-color-red').addClass('tt-bg-color-green');
            }

			utils.getMaster().find('.tt-completeness-tab-icon,.tt-completeness-tab-icon-missing-all,.tt-completeness-tab-icon-complete').addClass('hide');
			utils.getCourse().find('.tt-completeness-tab-icon,.tt-completeness-tab-icon-missing-all,.tt-completeness-tab-icon-complete').addClass('hide');
			utils.getMaster().find('.tt-btn-missing-field:not(.hide)').addClass('hide');
			utils.getCourse().find('.tt-btn-missing-field:not(.hide)').addClass('hide');
			if (!utils.isUndefined(utils.getQuestionnaire())) {
				utils.getQuestionnaire().find('.tt-btn-missing-field:not(.hide)').addClass('hide');
			}
            var selector = '';
            for (var i = 0; i < missing_fields; i++) {
                // Fehlende Vollständigkeit auf Tab-Reiter anzeigen
                if (selector !== '')
                {
                    selector += ',';
                }
                selector += '[data-control="' + splitted_data[i].split('=')[0] + '"].tt-btn-missing-field';
            }
			$(selector).removeClass('hide');

            if (Object.keys(completenessTabFieldCount).length > 0) {
                var percentageTabList = [];
                jQuery.each(missing_fields_tab_list, function (tab, value) {
                    if (completenessTabFieldCount[tab] === 0) {
                        // Tabs ohne Vollständigkeit
						percentageTabList[tab] = 100;
                    } else if (completenessTabFieldCount[tab] === -1) {
                        // Tabs, bei welchen die Vollständigkeit nicht berechnet werden kann
						percentageTabList[tab] = -1;
                    } else {
						percentageTabList[tab] = Math.floor(((completenessTabFieldCount[tab] - missing_fields_tab_list[tab]) / completenessTabFieldCount[tab]) * 100);
                        if (percentageTabList[tab] < 0) {
							percentageTabList[tab] = 0;
                        }
                    }

                    var tabElement = utils.getMaster().find('[href="#' + tab + '"]');
                    if (tabElement.length <= 0)
                    {
						tabElement = utils.getCourse().find('[href="#' + tab + '"]');
                    }

                    if (tabElement.length) {
						tabElement.data().coloredCompleteness = percentageTabList[tab];
						if (completenessTabFieldCount[tab] === 0 || completenessTabFieldCount[tab] === -1) {
							tabElement.data().coloredCompletenessCount = 0;
							tabElement.data().coloredCompletenessMissing = 0;
						} else {
							tabElement.data().coloredCompletenessCount = completenessTabFieldCount[tab];
							tabElement.data().coloredCompletenessMissing = missing_fields_tab_list[tab];
						}
						if (percentageTabList[tab] == 100) {
							tabElement.find('.tt-completeness-tab-icon').addClass('hide');
							tabElement.find('.tt-completeness-tab-icon-missing-all').addClass('hide');
							tabElement.find('.tt-completeness-tab-icon-complete').removeClass('hide');
                        } else if (percentageTabList[tab] <= 0) {
							tabElement.find('.tt-completeness-tab-icon').addClass('hide');
							tabElement.find('.tt-completeness-tab-icon-missing-all').removeClass('hide');
							tabElement.find('.tt-completeness-tab-icon-complete').addClass('hide');
                        } else {
							tabElement.find('.tt-completeness-tab-icon').removeClass('hide');
							tabElement.find('.tt-completeness-tab-icon-missing-all').addClass('hide');
							tabElement.find('.tt-completeness-tab-icon-complete').addClass('hide');
                        }
                    }
                });

				setColoredCompletenessDataForAjaxCall();
            }

            setCompletenessList(data[0]);
            var completenessForm = getCompletenessForm(data[0], 1, 8, 1);
            jQuery.each($.merge(utils.getMaster().find('.tt-info-completeness'), utils.getCourse().find('.tt-info-completeness')), function (i, element) {

                $(element).attr('data-content', completenessForm);
                if (utils.isUndefined($(element).data('bs.popover'))) {
                    $(element).popover({
                        template: '<div class="popover" role="tooltip" style="min-width: 450px;"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
                    });
                } else {
                    $(element).data('bs.popover').setContent();
                }
            });

			utils.getMaster().find('.tt-completeness-progress').attr('data-transitiongoal', completeness).attr('aria-valuenow', completeness);
			utils.getCourse().find('.tt-completeness-progress').attr('data-transitiongoal', completeness).attr('aria-valuenow', completeness);

			utils.getMaster().find('.tt-completeness-progress').progressbar({
                display_text: 'fill'
            });
			utils.getCourse().find('.tt-completeness-progress').progressbar({
				display_text: 'fill'
			});
			utils.getMaster().find('.tt-completeness-progress').text(completeness.toString() + "%");
			utils.getCourse().find('.tt-completeness-progress').text(completeness.toString() + "%");

            if (utils.GLOBALS.startNewCompletenessRequest) {
                utils.GLOBALS.startNewCompletenessRequest = false;
                defer.resolve();
                setCompleteness(null);
            } else {
                defer.resolve();
            }
			// console.timeEnd('setCompleteness');
        });
    }).promise();
}

function resetControl(control, resetIntegrityRule) {

    if (control.hasClass('tt-view-combo-multiselect') || control.hasClass('tt-view-combo')) {
        control.parent().find('.tt-view-combo,.tt-view-combo-multiselect').parent().removeClass('state-error');
        control.parent().find('.tt-btn-warning').addClass('hide');
    } else if (control.is(':checkbox')) {
        control.parent().parent().removeClass('state-error');
        control.parent().removeClass('state-error');
        control.parent().parent().find('.tt-btn-warning').addClass('hide');
    } else if (control.is(':radio')) {
        control.parent().parent().removeClass('state-error');
        control.parent().parent().find('.tt-radio').removeClass('state-error');
        if (control.parent().parent().hasClass('col')) {
            control.parent().parent().parent().prev().find('.tt-btn-warning').addClass('hide');
        } else if (control.parent().parent().parent().hasClass('tt-radio-column') || control.parent().parent().parent().hasClass('tt-radio-accordion') || control.parent().parent().parent().hasClass('tt-radio-list')) {
            control.parent().parent().parent().parent().find('.tt-btn-warning').addClass('hide');
        } else {
            control.parent().parent().prev().find('.tt-btn-warning').addClass('hide');
        }
    } else {
        control.parent().removeClass('state-error');
        if (!utils.isUndefined(control[0].form) && control.valid()) {
            control.parent().parent().removeClass('state-error');
        }
        if (control.hasClass('tt-additional-field')) {
            control.parent().parent().prev().prev().find('.tt-btn-warning').addClass('hide');
        } else {
            control.parent().parent().prev().find('.tt-btn-warning').addClass('hide');
        }
    }
    control.parent().parent().find('[data-integrity-popover]').popover('hide');
    control.parent().parent().find('[data-integrity-popover]').removeAttr('data-integrity-popover');
    if (resetIntegrityRule) {
        if (control.is(':radio')) {
            control.parent().parent().find('.tt-view-radio').removeAttr('data-integrity-rule');
        } else {
            control.removeAttr('data-integrity-rule');
        }
    }
    control.removeAttr('data-confirmed');
    control.removeAttr('data-integrity-origin-flag');
}

function setControlImplausible(control, integrityResult, integrityRule, showPopup, isImportIntegrity, strictValuesOtherExaminations, plausibleValuesOtherExaminations) {

    return $.Deferred(function(defer) {
        window.setTimeout(function () {
            var minWidth = '';
            if ((!utils.isUndefined(strictValuesOtherExaminations) && Object.keys(strictValuesOtherExaminations).length) || (!utils.isUndefined(plausibleValuesOtherExaminations) && Object.keys(plausibleValuesOtherExaminations).length)) {
                minWidth = 'tt-confirm-maxi-popover';
            }

            if (control.hasClass('tt-view-combo-multiselect') || control.hasClass('tt-view-combo')) {
                control.parent().find('.tt-view-combo:first,.tt-view-combo-multiselect:first').parent().addClass('state-error');
                control.parent().find('label:first').attr('data-integrity-popover', 'true');
                control.parent().find('label:first').attr('data-content', getConfirmForm(integrityResult, strictValuesOtherExaminations, plausibleValuesOtherExaminations));
                if (utils.isUndefined(control.parent().find('label:first').data('bs.popover'))) {
                    control.parent().find('label:first').attr('data-placement', 'top');
                    control.parent().find('label:first').attr('data-html', 'true');
                    control.parent().find('label:first').popover({
                        trigger: "manual",
                        template: '<div class="popover ' + minWidth + '" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
                    });
                } else {
                    control.parent().find('label:first').data('bs.popover').tip().removeClass('tt-confirm-maxi-popover').addClass(minWidth);
                    control.parent().find('label:first').data('bs.popover').setContent();
                }
                if (showPopup) {
                    control.parent().find('label:first').popover('show');
                } else {
                    control.parent().find('.tt-btn-warning:first').removeClass('hide');
                }
            } else if (control.is(':checkbox')) {
                control.parent().parent().addClass('state-error');
                control.parent().addClass('state-error');
                control.parent().attr('data-integrity-popover', 'true');
                control.parent().attr('data-content', getConfirmForm(integrityResult, strictValuesOtherExaminations, plausibleValuesOtherExaminations));
                if (utils.isUndefined(control.parent().data('bs.popover'))) {
                    control.parent().attr('data-placement', 'top');
                    control.parent().attr('data-html', 'true');
                    control.parent().popover({
                        trigger: "manual",
                        template: '<div class="popover ' + minWidth + '" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
                    });
                } else {
                    control.parent().data('bs.popover').tip().removeClass('tt-confirm-maxi-popover').addClass(minWidth);
                    control.parent().data('bs.popover').setContent();
                }
                if (showPopup) {
                    control.parent().popover('show');
                } else {
                    control.parent().parent().find('.tt-btn-warning').removeClass('hide');
                }
            } else if (control.is(':radio')) {
                control.parent().parent().addClass('state-error');
                control.parent().parent().find('.tt-radio').addClass('state-error');
                control.parent().attr('data-integrity-popover', 'true');
                control.parent().attr('data-content', getConfirmForm(integrityResult, strictValuesOtherExaminations, plausibleValuesOtherExaminations));
                if (utils.isUndefined(control.parent().data('bs.popover'))) {
                    control.parent().attr('data-placement', 'top');
                    control.parent().attr('data-html', 'true');
                    control.parent().popover({
                        trigger: "manual",
                        template: '<div class="popover ' + minWidth + '" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
                    });
                } else {
                    control.parent().data('bs.popover').tip().removeClass('tt-confirm-maxi-popover').addClass(minWidth);
                    control.parent().data('bs.popover').setContent();
                }
                if (showPopup) {
                    control.parent().popover('show');
                } else {
                    if (control.parent().parent().hasClass('col')) {
                        control.parent().parent().parent().prev().find('.tt-btn-warning').removeClass('hide');
                    } else if (control.parent().parent().parent().hasClass('tt-radio-column') || control.parent().parent().parent().hasClass('tt-radio-accordion') || control.parent().parent().parent().hasClass('tt-radio-list')) {
                        control.parent().parent().parent().parent().find('.tt-btn-warning').removeClass('hide');
                    } else {
                        control.parent().parent().prev().find('.tt-btn-warning').removeClass('hide');
                    }
                }
            } else {
                control.parent().addClass('state-error');
                control.parent().attr('data-integrity-popover', 'true');
                control.parent().attr('data-content', getConfirmForm(integrityResult, strictValuesOtherExaminations, plausibleValuesOtherExaminations));
                if (utils.isUndefined(control.parent().data('bs.popover'))) {
                    control.parent().attr('data-placement', 'top');
                    control.parent().attr('data-html', 'true');
                    control.parent().popover({
                        trigger: "manual",
                        template: '<div class="popover ' + minWidth + '" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
                    });
                } else {
                    control.parent().data('bs.popover').tip().removeClass('tt-confirm-maxi-popover').addClass(minWidth);
                    control.parent().data('bs.popover').setContent();
                }
                if (showPopup) {
                    control.parent().popover('show');
                } else {
                    if (control.hasClass('tt-additional-field')) {
                        control.parent().parent().prev().prev().find('.tt-btn-warning').removeClass('hide');
                    } else {
                        control.parent().parent().prev().find('.tt-btn-warning').removeClass('hide');
                    }
                }
            }
            control.attr('data-integrity-rule', integrityRule);
            if (!isImportIntegrity) {
                control.removeAttr('data-confirmed');
                control.removeAttr('data-integrity-origin-flag');
            }

			setFormDataForAjaxCall($(control.parents('.tab-pane')[0]), true, true);

            defer.resolve();

        }, 100); // darauf warten, dass popover hide von resetControl fertig ist.
    }).promise();
}

function getConfirmForm(text, strictValuesOtherExaminations, plausibleValuesOtherExaminations) {

    var result = getIntegrityText(text.split('|'), strictValuesOtherExaminations, plausibleValuesOtherExaminations);

    if (result[0] === 'P') {
        if ((utils.isUndefined(strictValuesOtherExaminations) || !Object.keys(strictValuesOtherExaminations).length)
            && (utils.isUndefined(plausibleValuesOtherExaminations) || !Object.keys(plausibleValuesOtherExaminations).length)) {
            result[1] += '<br>';
        }
        result[1] += '<br>' + trans('tripletrax.confirm_text');
    }

    var returnValue = '<form action="" class="tt-confirm-popover">' +
        '<label class="tt-label-confirm-value">' + result[1] + '</label>' +
        '<div class="form-actions tt-confirm-form"><div class="row"><div class="col-md-12">' +
        '<div class="btn-toolbar btn-toolbar-tripletrax pull-right">' +
        '<div class="btn-group">';

    if (result[0] === 'P') {
        returnValue += '<button class="btn btn-success tt-confirm-value" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.confirm') + '">' +
            '<i class="fad fa-check"></i>' +
            '</button>' +
            '<button class="btn btn-danger tt-cancel-confirm" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.cancel') + '">' +
            '<i class="fad fa-times"></i>' +
            '</button>';
    } else {
        returnValue += '<button class="btn btn-info tt-cancel-confirm" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.close') + '">' +
            '<i class="fad fa-times"></i>' +
            '</button>';
    }

    returnValue += '</div>' +
        '</div>' +
        '</div></div></div></form>';

    return returnValue;
}

function getQueryForm(control, queryQuestion, queryQuestionDate, queryAnswer, queryAnswerDate, queryClosed, queryHistoryObjectList) {
    var returnValue = null;
    var element = $($(control).parents('[class^="tt-rightclass-"]')[0]).find('[name="' + control.dataset.control + '"]');
    if (element.is(':radio')) {
        element = $($(control).parents('[class^="tt-rightclass-"]')[0]).find('[name="' + control.dataset.control + '"]:checked');
        if (!element.length) {
            element = $($(control).parents('[class^="tt-rightclass-"]')[0]).find('[name="' + control.dataset.control + '"]:first');
        }
    }

    var queryHistoryExist = ( !utils.isUndefined(queryHistoryObjectList) && queryHistoryObjectList.length > 0);

    var isFirstQueryClosed = false;
    // Wenn Query geschlossen wird
    if(queryQuestion !== "" && queryAnswer !== "" && queryClosed === true) {
        isFirstQueryClosed = true;
    }

    // Wenn es kein offenes Query gibt
    if(queryQuestion === "" && queryAnswer === "" && queryClosed === "" && queryHistoryExist) {
        isFirstQueryClosed = true;
    }

    var lastQueryHistoryValue = 0;

    var queryQuestionValue = queryQuestion;
    var queryAnswerValue = queryAnswer;
    var queryQuestionDateValue = queryQuestionDate;
    var queryAnswerDateValue = queryAnswerDate;

    if (isFirstQueryClosed && queryHistoryExist) {
        var lastQueryHistoryObject = queryHistoryObjectList[queryHistoryObjectList.length -1];
        var lastQueryHistoryQuestion =lastQueryHistoryObject.queryQuestion;
        var lastQueryHistoryAnswer =lastQueryHistoryObject.queryAnswer;
        var lastQueryHistoryQuestionDate =lastQueryHistoryObject.queryQuestionDate;
        var lastQueryHistoryAnswerDate =lastQueryHistoryObject.queryAnswerDate;

        // Gibt es kein offenes Query, sondern nur geschlossene, so wird die Anzeige zwischen den
        // Rechten create query und answer query/close query unterschieden.
        // Die Texte werden hier korrekt zugeordnet.
        if (access.getRight(element, 'create_query') > 0) {

            if(isFirstQueryClosed && queryQuestionValue === "" && queryAnswerValue === "") {
                lastQueryHistoryValue = 0;
                isFirstQueryClosed = false;
            }
        }
        else {
            if (queryQuestionValue === "" && lastQueryHistoryQuestion !== "") {
                queryQuestionValue = lastQueryHistoryQuestion;
            }
            if (queryAnswerValue === "" && lastQueryHistoryAnswer !== "") {
                queryAnswerValue = lastQueryHistoryAnswer;
            }
            if (queryQuestionDateValue === null && lastQueryHistoryQuestionDate !== '') {
                queryQuestionDateValue = lastQueryHistoryQuestionDate;
            }
            if (queryAnswerDateValue === null && lastQueryHistoryAnswerDate !== '') {
                queryAnswerDateValue = lastQueryHistoryAnswerDate;
            }

            lastQueryHistoryValue = 1;
            isFirstQueryClosed = true;
        }
    }

    if (element.length) {
        returnValue =
            '<div class="tt-query-popover">'+
            '<input type="hidden" id="control_name" value="' + element[0].name + '">';
        if (!utils.isUndefined(queryHistoryObjectList) && queryHistoryObjectList.length > 0) {
            returnValue +=
                '<input type="hidden" id="query_history_object_list_' + element[0].name + '" value="' + utils.htmlSpecialChars(JSON.stringify(queryHistoryObjectList)) + '">' +
                '<input type="hidden" id="query_counter_' + element[0].name + '" value="'+ lastQueryHistoryValue+'">'+
                '<input type="hidden" id="query_is_closed_' + element[0].name + '" value="'+ isFirstQueryClosed+'">';
        }

        returnValue +=
            '<div class="row">' +
            '<section class="col col-12">' +
            '<label class="label label-tripletrax"><a class="tt-btn-control tt-history tt-history-query" data-html="true" data-original-title="" data-control="query_question_' + element[0].name + '"><i class="fad fa-history"></i></a><span id="query_question_date_' + element[0].name + '" class="tt-label-query">' + (utils.isUndefined(queryQuestionDateValue) ? '' : utils.dateToLocaleLongTimeString(queryQuestionDateValue)) + '</span></label>' +
            '<label class="input">' +
            '<textarea class="tt-query" type="text" id="query_question_' + element[0].name + '" ' + (access.getRight(element, 'create_query') && !(isFirstQueryClosed) ? '' : 'disabled="disabled"') + '>' + queryQuestionValue + '</textarea>' +
            '</label>' +
            '</section>' +
            '</div>' +
            '<div class="row">' +
            '<section class="col col-12">' +
            '<label class="label label-tripletrax"><a class="tt-btn-control tt-history tt-history-query" data-html="true" data-original-title="" data-control="query_answer_' + element[0].name + '"><i class="fad fa-history"></i></a><span id="query_answer_date_' + element[0].name + '" class="tt-label-query">' + (utils.isUndefined(queryAnswerDateValue) ? '' : utils.dateToLocaleLongTimeString(queryAnswerDateValue)) + '</span></label>' +
            '<label class="input">' +
            '<textarea class="tt-query" type="text" id="query_answer_' + element[0].name + '" ' + (access.getRight(element, 'answer_query') && !(isFirstQueryClosed) ? '' : 'disabled="disabled"') + '>' + queryAnswerValue + '</textarea>' +
            '</label>' +
            '</section>' +
            '</div>' +
            '<div class="form-actions"><div class="row"><div class="col-md-12">';

        if (!utils.isUndefined(queryHistoryObjectList) && queryHistoryObjectList.length > 0) {
            var showNextPreviousButton = true;
            var disableNext = 'disabled="disabled"';
            var disablePrevious = '';//'disabled="disabled"';

            if(!access.getRight(element, 'create_query') && queryHistoryObjectList.length === 1 && isFirstQueryClosed) {
                showNextPreviousButton = false;
            }

            if(showNextPreviousButton) {
                returnValue +=
                    '<div class="btn-toolbar btn-toolbar-tripletrax pull-left margin-left-10">' +

                    '<div class="btn-group">' +
                    '<button class="btn btn-info tt-previous-query" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.previous_query') + '" ' + disablePrevious + '>' +
                    '<i class="fad fa-chevron-left"></i>' +
                    '</button>' +
                    '</div>' +

                    '<div class="btn-group">' +
                    '<button class="btn btn-info tt-next-query" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.next_query') + '" ' + disableNext + '>' +
                    '<i class="fad fa-chevron-right"></i>' +
                    '</button>' +
                    '</div>' +

                    '</div>';
            }
        }

        returnValue +=
            '<div class="btn-toolbar btn-toolbar-tripletrax pull-right">' +
            '<div class="btn-group">' +
            '<button class="btn btn-success tt-save-query-value" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.save') + '" ' + (isFirstQueryClosed ? 'disabled="disabled"' : '') + '>' +
            '<i class="fad fa-check"></i>' +
            '</button>' +
            '<button class="btn btn-danger tt-cancel-query" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.cancel') + '">' +
            '<i class="fad fa-times"></i>' +
            '</button>' +
            '</div>';

        if (access.getRight(element, 'delete_query')) {
            returnValue +=
                '<div class="btn-group">' +
                '<button class="btn btn-danger tt-delete-query" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.delete_query') + '" ' + (queryAnswer.length > 0 || queryQuestion.length > 0 ? '' : 'disabled="disabled"') + '>' +
                '<i class="fad fa-trash-alt"></i>' +
                '</button>' +
                '</div>';
        }

        if (access.getRight(element, 'close_query')) {
            returnValue +=
                '<div class="btn-group">' +
                '<button class="btn btn-info tt-close-query" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.close_query') + '" ' + (queryAnswer.length > 0 && !isFirstQueryClosed ? '' : 'disabled="disabled"') + '>' +
                '<i class="fad fa-thumbs-up"></i>' +
                '</button>' +
                '</div>';
        }

        returnValue += '</div>' +
            '</div></div></div></div>';
    }

    return returnValue;
}

function getIntegrityText(result, strictValuesOtherExaminations, plausibleValuesOtherExaminations) {

    if (result.length > 2) {
        // Zahlenformat und Datumsformat anpassen
        if (/^n&/.test(result[2])) {
            var number = utils.numberToString(parseFloat(result[2].substr(2)));
            result[1] = result[1].replace('#', number);
        } else if (/^d&/.test(result[2])) {
            var date = utils.dateToLocaleString(result[2].substr(2));
            result[1] = result[1].replace('#', date);
        } else {
            result[1] = result[1].replace('#', result[2]);
        }

        if (result.length > 3) {
            if (/^n&/.test(result[3])) {
                var number = utils.numberToString(parseFloat(result[3].substr(2)));
                result[1] = result[1].replace('#', number);
            } else if (/^d&/.test(result[3])) {
                var date = utils.dateToLocaleString(result[3].substr(2));
                result[1] = result[1].replace('#', date);
            } else {
                result[1] = result[1].replace('#', result[3]);
            }
        }

        if (result.length > 4) {
            if (/^n&/.test(result[4])) {
                var number = utils.numberToString(parseFloat(result[4].substr(2)));
                result[1] = result[1].replace('#', number);
            } else if (/^d&/.test(result[4])) {
                var date = utils.dateToLocaleString(result[4].substr(2));
                result[1] = result[1].replace('#', date);
            } else {
                result[1] = result[1].replace('#', result[4]);
            }
        }

        if (result.length > 5) {
            if (/^n&/.test(result[5])) {
                var number = utils.numberToString(parseFloat(result[5].substr(2)));
                result[1] = result[1].replace('#', number);
            } else if (/^d&/.test(result[5])) {
                var date = utils.dateToLocaleString(result[5].substr(2));
                result[1] = result[1].replace('#', date);
            } else {
                result[1] = result[1].replace('#', result[5]);
            }
        }
    }

    if ((!utils.isUndefined(strictValuesOtherExaminations) && Object.keys(strictValuesOtherExaminations).length) || (!utils.isUndefined(plausibleValuesOtherExaminations) && Object.keys(plausibleValuesOtherExaminations).length)) {
        var margin = '';
        if (result[1] !== '') {
            margin = 'margin-top-20';
        }

        result[1] += '<fieldset class="tripletrax-scroll-panel-confirm-form ' + margin + '">';
    }

    // Werte, welche bei anderen Untersuchungen gelöscht werden
    if (!utils.isUndefined(strictValuesOtherExaminations) && Object.keys(strictValuesOtherExaminations).length) {
        var resultStrictValuesOtherExaminations = Lang.get('tripletrax.check_integrity_fields_other_examinations_strict') + '<ul class="margin-left-15">';
        for (var key in strictValuesOtherExaminations) {
            jQuery.each(strictValuesOtherExaminations[key], function (i, val) {

                var value = '';
                if (val[1] === '') {
                    value = Lang.get('tripletrax.' + val[2]);
                } else {
                    if (/^d&/.test(val[1])) {
                        value = utils.dateToLocaleString(val[1].substr(2));
                        if (val[2] !== '') {
                            value = utils.dateToLocaleFormatString(val[1].substr(2), val[2].replace('yy', 'yyyy').toUpperCase());
                        }
                    } else if (/^n&/.test(val[1])) {
                        value = utils.numberToString(parseFloat(val[1].substr(2))) + ' ' + val[2];
                    } else {
                        value = val[1];
                    }
                }

                resultStrictValuesOtherExaminations += '<li>' + utils.dateToLocaleString(key) + ': ' + val[0] + ' - ' + value + ' (' + val[3] + ')</li>';
            });
        }

        resultStrictValuesOtherExaminations += '</ul>';

        result[1] += resultStrictValuesOtherExaminations;
    }

    // Werte, welche bei anderen Untersuchungen bestätigt werden
    if (!utils.isUndefined(plausibleValuesOtherExaminations) && Object.keys(plausibleValuesOtherExaminations).length) {
        var resultPlausibleValuesOtherExaminations = Lang.get('tripletrax.check_integrity_fields_other_examination_plausible') + '<ul class="margin-left-15">';
        for (var key in plausibleValuesOtherExaminations) {
            jQuery.each(plausibleValuesOtherExaminations[key], function (i, val) {

                var value = '';
                if (val[1] === '') {
                    value = Lang.get('tripletrax.' + val[2]);
                } else {
                    if (/^d&/.test(val[1])) {
                        value = utils.dateToLocaleString(val[1].substr(2));
                        if (val[2] !== '') {
                            value = utils.dateToLocaleFormatString(val[1].substr(2), val[2].replace('yy', 'yyyy').toUpperCase());
                        }
                    } else if (/^n&/.test(val[1])) {
                        value = utils.numberToString(parseFloat(val[1].substr(2))) + ' ' + val[2];
                    } else {
                        value = val[1];
                    }
                }

                resultPlausibleValuesOtherExaminations += '<li>' + utils.dateToLocaleString(key) + ': ' + val[0] + ' - ' + value + ' (' + val[3] + ')</li>';
            });
        }

        resultPlausibleValuesOtherExaminations += '</ul>';

        if (!utils.isUndefined(strictValuesOtherExaminations) && Object.keys(strictValuesOtherExaminations).length) {
            result[1] += '<br>';
        }
        result[1] += resultPlausibleValuesOtherExaminations;
    }

    if ((!utils.isUndefined(strictValuesOtherExaminations) && Object.keys(strictValuesOtherExaminations).length) || (!utils.isUndefined(plausibleValuesOtherExaminations) && Object.keys(plausibleValuesOtherExaminations).length)) {
        result[1] += '</fieldset>';
    }

    return result;
}

function getRevisionForm(revisions) {

    var returnValue =
        '<form style="min-width:350px">';

    if (revisions.length) {
        returnValue += '<ul>';

        jQuery.each(revisions, function (i, revision) {
            var facility = '';
            var originFlag = '';
            if (!utils.isUndefined(revision.facilityname) && revision.facilityname !== '') {
                facility = ' (' + revision.facilityname + ' [' + revision.facilityid + '])';
            }
            if (!utils.isUndefined(revision.origin_flag) && revision.origin_flag !== '') {
                facility += ' - ';
                originFlag = '(' + revision.origin_flag + ')';
            }

            var quoteClass = ' tt-blockquote-info';
            var value = ' - ' + revision.new_value_string;
            if (!utils.isUndefined(revision.new_value) && revision.new_value !== '') {
                if (revision.value_format === 'date') {
                    if (revision.format === 'yy' || revision.format === 'mm/yy') {
                        value = ' - ' + utils.dateToLocaleFormatString(revision.new_value_string, revision.format.replace('yy', 'yyyy').toUpperCase());
                    } else {
                        value = ' - ' + utils.dateToLocaleString(revision.new_value_string);
                    }
                } else if (revision.value_format === 'date_time') {
                    value = ' - ' + utils.dateToLocaleTimeString(revision.new_value_string);
                } else if (revision.value_format === 'decimal' || revision.value_format === 'integer') {
                    value = ' - ' + utils.numberToString(parseFloat(revision.new_value_string));
                } else if (revision.value_format === 'checkbox') {
                    value = ' - ' + trans('tripletrax.yes');
                }
                if (!utils.isUndefined(revision.format) && revision.format !== '' && !utils.isFormatValue(revision.format) && revision.format !== 'mm/yy' && revision.format !== 'yy' && revision.format !== 'value' && revision.format !== 'full') {
                    value += ' ' + revision.format;
                }
            } else if (utils.isFormatValue(revision.format)) {
                value = ' - ' + trans('tripletrax.' + revision.format);
            }

            if (utils.isUndefined(revision.old_value) || revision.old_value === '') {
                quoteClass = ' tt-blockquote-success';
            } else if ((utils.isUndefined(revision.new_value) || revision.new_value === '') && (utils.isUndefined(revision.format) || revision.format === '' || !utils.isFormatValue(revision.format))) {
                quoteClass = ' tt-blockquote-danger';
                value = '';
            }

            returnValue +=
                '<blockquote class="tt-blockquote' + quoteClass + '">' +
                '<p>' + utils.dateToLocaleTimeString(revision.created_at) + value + '</p>' +
                '<small><i class="fad fa-angle-right"></i>' + revision.username + facility + '<cite>' + originFlag + '</cite></small>' +
                '</blockquote>';

        });

        returnValue += '</ul>';
    } else {
        returnValue +=
            '<div class="row">' +
            '<section class="col col-12 no-margin">' +
            '<label class="label label-tripletrax">' + trans('tripletrax.no_audit_trail') +
            '</label>' +
            '</section>' +
            '</div>';
    }

    returnValue += '</form>';

    return returnValue;
}

function getCompletenessForm(data, currentPage, pageCount, paginationStart) {

    var returnValue = '';

    if (data === '') {

        returnValue +=
            '<form action="" class="tt-completeness-popover" style="min-width:220px">' +
            '<div class="row">' +
            '<section class="col col-12">' +
            '<label class="label label-tripletrax">' + trans('tripletrax.completeness_complete') +
            '</label>' +
            '</section>' +
            '</div>';
    } else {
        returnValue = '<form action="" class="tt-completeness-popover" style="min-width:420px" data-completeness-items="' + data +'">' +
            '<div class="tt-completeness-items">';
        var optionalItems = data.split('$');
        var completenessItems = optionalItems[0].split('|').filter(function(e){return e});
        var completenessItemsOptional = [];
        if (optionalItems.length > 1) {
            completenessItemsOptional = optionalItems[1].split('|').filter(function (e) {return e});
        }

        returnValue += getCompletenessItems(completenessItems, completenessItemsOptional, currentPage, pageCount);

        returnValue += '</div>';

        var combinedLength = completenessItems.length + completenessItemsOptional.length;
        if (combinedLength > pageCount) {
            var disabledString = '';
            if (currentPage === 1) {
                disabledString = ' disabled';
            }
            returnValue += '<div class="text-center">' +
                '<ul class="pagination pagination-alt">' +
                '<li>' +
                '<a class="tt-completeness-pagination" data-pagination="previous"' + disabledString + '><i class="fad fa-angle-left"></i></a>' +
                '</li>';

            var countPages = (combinedLength - (combinedLength % pageCount)) / pageCount;
            if (combinedLength % pageCount > 0) {
                countPages++;
            }
            for (var i = paginationStart; i <= countPages; i++) {
                if (i === currentPage) {
                    returnValue += '<li class="active">';
                } else {
                    returnValue += '<li>';
                }
                returnValue +=
                    '<a class="tt-completeness-pagination" data-pagination="' + i + '">' + i + '</a>' +
                    '</li>';
                if (i - paginationStart + 1 === 5) {
                    break;
                }
            }

            disabledString = '';
            if (currentPage === countPages) {
                disabledString = ' disabled';
            }
            returnValue +=
                '<li>' +
                '<a class="tt-completeness-pagination" data-pagination="next"' + disabledString + '><i class="fad fa-angle-right"></i></a>' +
                '</li>' +
                '</div>' +
                '</ul>';
        }
    }

    returnValue += '</form>';

    return returnValue;
}

function getCompletenessItems(completenessItems, completenessItemsOptional, currentPage, pageCount) {

    returnValue = '';

    jQuery.each($.merge( $.merge( [], completenessItems), completenessItemsOptional), function (i, val) {

        if (i <= pageCount * currentPage - pageCount - 1) {
            return;
        }
        var splittedValue = val.split('=');

        if (i === completenessItems.length) {
            returnValue +=
                '<div class="row">' +
                '<section class="col col-12">' +
                '<label class="label label-tripletrax tt-optional-field-label">' + trans('tripletrax.optional_fields') +
                '</label>' +
                '</section>' +
                '</div>';
        }

        returnValue +=
            '<div class="row">' +
            '<section class="col col-12">' +
            '<label class="label label-tripletrax">' + splittedValue[1] +
            '<a class="tt-btn-completeness" data-completeness-field-name="' + splittedValue[0] + '" data-completeness-table-name="' + splittedValue[3] + '" data-completeness-table-type="' + splittedValue[4] + '">' +
            '<i class="fad fa-arrow-alt-circle-right fa-lg"></i>' +
            '</a>' +
            '</label>' +
            '<div class="note note-error"> (' + splittedValue[2] + ')</div>' +
            '</section>' +
            '</div>';

        if (i === pageCount * currentPage - 1) {
            return false;
        }
    });

    return returnValue;
}

function setCompletenessList(data) {

	if ($('[name="show_patients_incomplete_course_data"]').is(':checked')) {

		$('#count_missing_fields').text('');
		$('.tt-export-completeness-list-doc').attr('disabled', 'disabled');

	    if (!$('#dd_completeness').data('data-date-range-set')) {

			utils.GLOBALS.runningCompletenessListRequest = setCompletenessListAjaxCall(data);
		}
		else
        {
            if (!utils.isUndefined(utils.GLOBALS.runningCompletenessListRequest)) {
				utils.GLOBALS.runningCompletenessListRequest.done(function () {
					setCompletenessListDetail(data, true, getExaminationDate());
					$('#count_missing_fields').text(trans('tripletrax.count_missing_fields') + ' ' + $('.dd-btn-completeness[data-optional="false"]').length);
					$('.tt-export-completeness-list-doc').removeAttr('disabled');
				});
			} else {
				setCompletenessListDetail(data, true, getExaminationDate());
				$('#count_missing_fields').text(trans('tripletrax.count_missing_fields') + ' ' + $('.dd-btn-completeness[data-optional="false"]').length);
				$('.tt-export-completeness-list-doc').removeAttr('disabled');
            }
        }
	}

}

function setCompletenessListAjaxCall(data) {

	return $.Deferred(function (defer) {

		$('#dd_completeness').data('data-date-range-set', true);

		var currentExaminationDate = '';
		if ($('#table_patient_examination').find('.selected-row').length) {
			var aData = $('#table_patient_examination').DataTable().row($('#table_patient_examination').find('.selected-row')).data();
			currentExaminationDate = utils.dateToTimeString(aData.examinationdate);
		}

		$('.dd').addClass('hide');
		$('.tt-wait-for-completeness').removeClass('hide');

		ajax.ajaxCall('doc/patient/patient/completeness/facility/' + getFacilityId() + '/model/' + getModelId() + '/patient/' + getPatientId() + '/date_range/' + $('[name="show_patients_incomplete_course_data_year"]').select2('val'), 'POST', null, false, function (completenessData) {

			if (currentExaminationDate === '') {
				setCompletenessListDetail(data, true);
			}
			$.each(completenessData, function (examDate, examData) {
				var examinationDate = examDate.split('|')[0];
				var examinationId = examDate.split('|')[1];
				if (examinationDate !== currentExaminationDate) {
					setCompletenessListDetail(examData, false, examinationDate, examinationId);
				} else {
					setCompletenessListDetail(data, true, getExaminationDate(), getExaminationId());
				}
			});
			$('#count_missing_fields').text(trans('tripletrax.count_missing_fields') + ' ' + $('.dd-btn-completeness[data-optional="false"]').length);
			$('.tt-export-completeness-list-doc').removeAttr('disabled');

			$('.dd').removeClass('hide');
			$('.tt-wait-for-completeness').addClass('hide');

			defer.resolve();
		});
	}).promise();
}

function setCompletenessListDetail(data, isCurrentData, examinationDate, examinationId) {

    if (isCurrentData) {
		$('.tt-completeness-master-list').empty();
		$('.tt-completeness-current-course-list').empty();
	}

	if (data === '') {
		if (isCurrentData) {
			$('.tt-completeness-current-course-list').parents('.tt-completeness-course').remove();
		}
	} else {
		var optionalItems = data.split('$');
		var completenessItems = optionalItems[0].split('|').map(function (e) {
			return e + '=false'
		});
		var completenessItemsOptional = [];
		if (optionalItems.length > 1) {
			completenessItemsOptional = optionalItems[1].split('|').map(function (e) {
				return e + '=true'
			});
		}

		var course = utils.getCourse();
		var master = utils.getMaster();
		jQuery.each($.merge([], completenessItems), function (i, val) {

			var splittedValue = val.split('=');

			var valueType = '';
			if (master.find('[name="' + splittedValue[0] + '"]').length || (!utils.isUndefined(splittedValue[3]) && master.find('[data-database-table-name="' + splittedValue[3] + '"]').length)) {
				valueType = 'master';
			} else if (course.find('[name="' + splittedValue[0] + '"]').length || (!utils.isUndefined(splittedValue[3]) && course.find('[data-database-table-name="' + splittedValue[3] + '"]').length)) {
				valueType = 'course';
			}

			var parentNode = null;
			var additionalClassString = ''
			if (valueType === 'master' && isCurrentData) {
				parentNode = $('.tt-completeness-master-list');
				if (parentNode.length <= 0) {
					$('.dd-completeness-list').prepend(
						'<li class="dd-item dd-item-not-dragable tt-not-dragable tt-completeness-master">' +
						'<button class="tt-completeness-button" data-action="collapse" type="button">Collapse</button>' +
						'<button class="tt-completeness-button" data-action="expand" type="button" style="display: none;">Expand</button>' +
						'<div class="dd-handle dd-completeness-parent">' +
						'<strong>' + trans('tripletrax.master_data') + '</strong>' +
						'</div>' +
						'<ol class="dd-list tt-completeness-master-list">' +
						'</ol>' +
						'</li>'
					);
					parentNode = $('.tt-completeness-master-list');
				}
			} else if (valueType === 'course') {
			    var className = 'tt-completeness-course-list';
			    var searchString = '[data-exam-date="' + examinationDate + '"]';
				if (isCurrentData) {
					className = 'tt-completeness-current-course-list';
					searchString = '';
					additionalClassString = ' dd-handle-current-course-completeness';
				}

				parentNode = $('.' + className + searchString);
				if (parentNode.length <= 0) {
					var aData = $('#table_patient_examination').DataTable().row(0).data();
					var label = '';
					if (aData.examinationdate_format == 'year' || aData.examinationdate_format == 'month_year' || aData.examinationdate_format == 'quarter_year') {
						label = trans('tripletrax.label_exam_year', {'examination': utils.getExaminationDateString(examinationDate, aData.examinationdate_format)})
					} else {
						label = trans('tripletrax.label_exam', {'examination': utils.getExaminationDateString(examinationDate, aData.examinationdate_format)});
					}

					$('.dd-completeness-list').append(
						'<li class="dd-item dd-item-not-dragable tt-not-dragable tt-completeness-course">' +
						'<button class="tt-completeness-button" data-action="collapse" type="button">Collapse</button>' +
						'<button class="tt-completeness-button" data-action="expand" type="button" style="display: none;">Expand</button>' +
						'<div class="dd-handle dd-completeness-parent dd-completeness-course-parent">' +
						'<strong>' + label + '</strong>' +
						'</div>' +
						'<ol class="dd-list ' + className + '" data-exam-date="' + examinationDate + '" data-examination-id="' + examinationId + '">' +
						'</ol>' +
						'</li>'
					);
					parentNode = $('.' + className + searchString);
					if (!isCurrentData) {
					    parentNode.parents('li').find('[data-action="collapse"]')[0].click();
                    }
				}
			}
			if (!utils.isUndefined(parentNode)) {
				parentNode.append(
					'<li class="dd-item dd-btn-completeness" data-completeness-field-name="' + splittedValue[0] + '" data-completeness-table-name="' + splittedValue[3] + '" data-completeness-table-type="' + splittedValue[4] + '" data-optional="' + splittedValue[5] + '">' +
					'<div class="dd-handle dd-handle-completeness tt-not-dragable' + additionalClassString + '">' +
					splittedValue[1] +
					'<br><div class="note note-error"> (' + splittedValue[2] + ')</div>' +
					'</div>' +
					'</li>'
				);
			}
		});
		if (isCurrentData) {
			if ($('.tt-completeness-current-course-list').find('.dd-btn-completeness').length === 0) {
				$('.tt-completeness-current-course-list').parents('.tt-completeness-course').addClass('hide');
			} else {
				$('.tt-completeness-current-course-list').parents('.tt-completeness-course').removeClass('hide');
            }
		}

		return completenessItems.length;
	}
}

function getPreviousExaminationDataForm(button, data, currentPage, pageCount, paginationStart) {

    var returnValue = '';

    if (data === 'not_existing') {

        returnValue +=
            '<form action="" class="tt-previous-examinationdata-popover" style="min-width:220px">' +
            '<div class="row">' +
            '<section class="col col-12">' +
            '<label class="label label-tripletrax">' + trans('tripletrax.no_previous_examinationdata') +
            '</label>' +
            '</section>' +
            '</div>' +
            '</form>';
    } else {
        var previousExaminationDataItems = {};
        jQuery.each($(button.parents('.row')[0]).parent().find('[data-assume-previous-data="true"]'), function (i, element) {

            if (($(element).attr('name') in data)) {
                previousExaminationDataItems[$(element).attr('name')] = data[$(element).attr('name')];
            }
            if (($(element).attr('name') + '_format' in data) && !($(element).attr('name') in data)) {
                previousExaminationDataItems[$(element).attr('name') + '_format'] = data[$(element).attr('name') + '_format'];
            }
        });

        var dataLength = Object.keys(previousExaminationDataItems).length;

        if (dataLength === 0) {
            return '<form action="" class="tt-previous-examinationdata-popover" style="min-width:220px">' +
                '<div class="row">' +
                '<section class="col col-12">' +
                '<label class="label label-tripletrax">' + trans('tripletrax.no_previous_examinationdata') +
                '</label>' +
                '</section>' +
                '</div>' +
                '</form>';
        }

        returnValue = '<form action="" class="tt-previous-examinationdata-popover" style="min-width:420px">' +
            '<div class="tt-previous-examinationdata-items" data-previous-examinationdata-items="' + utils.htmlSpecialChars(JSON.stringify(previousExaminationDataItems)) + '">';

        returnValue += getPreviousExaminationDataItems(previousExaminationDataItems, data, currentPage, pageCount);

        returnValue += '</div>';

        if (dataLength > pageCount) {
            var disabledString = '';
            if (currentPage === 1) {
                disabledString = ' disabled';
            }
            returnValue += '<div class="text-center">' +
                '<ul class="pagination pagination-alt">' +
                '<li>' +
                '<a class="tt-previous-examination-pagination" data-pagination="previous"' + disabledString + '><i class="fad fa-angle-left"></i></a>' +
                '</li>';

            var countPages = (dataLength - (dataLength % pageCount)) / pageCount;
            if (dataLength % pageCount > 0) {
                countPages++;
            }
            for (var i = paginationStart; i <= countPages; i++) {
                if (i === currentPage) {
                    returnValue += '<li class="active">';
                } else {
                    returnValue += '<li>';
                }
                returnValue +=
                    '<a class="tt-previous-examination-pagination" data-pagination="' + i + '">' + i + '</a>' +
                    '</li>';
                if (i - paginationStart + 1 === 5) {
                    break;
                }
            }

            disabledString = '';
            if (currentPage === countPages) {
                disabledString = ' disabled';
            }
            returnValue +=
                '<li>' +
                '<a class="tt-previous-examination-pagination" data-pagination="next"' + disabledString + '><i class="fad fa-angle-right"></i></a>' +
                '</li>' +
                '</div>' +
                '</ul>';
        }

        returnValue += '</form>' +
            '<div class="form-actions">' +
            '<div class="row">' +
            '<div class="col col-12">' +
            '<div class="btn-toolbar btn-toolbar-tripletrax pull-right">' +
            '<div class="btn-group">' +
            '<a class="btn btn-success tt-save-previous-examination" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.save_tooltip') + '">' +
            '<i class="fad fa-check"></i>' +
            '</a>' +
            '<a class="btn btn-danger tt-cancel-previous-examination" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.cancel_tooltip') + '">' +
            '<i class="fad fa-times"></i>' +
            '</a>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</div>';
    }

    return returnValue;
}

function getPreviousExaminationDataItems(previousExaminationDataItems, data, currentPage, pageCount) {

    var returnValue = '';

    var i = 0;
    jQuery.each(previousExaminationDataItems, function (key, val) {

        if (i <= pageCount * currentPage - pageCount - 1) {
            i = i + 1;
            return;
        }
        var splittedValue = val.split('#');
        var checked = '';
        if (splittedValue[2] === '1') {
            checked = ' checked="checked"';
        }
        var previousValue = splittedValue[3];
        if (splittedValue[4] === 'd') {
            previousValue = utils.dateToLocaleString(previousValue);
        } else if (splittedValue[4] === 'n') {
            previousValue = utils.numberToString(parseFloat(previousValue));
        }
        if (key + '_format' in data) {
            if (splittedValue[4] === 'd') {
                previousValue = utils.dateToLocaleFormatString(splittedValue[3], data[key + '_format'].split('#')[3].replace('yy', 'yyyy').toUpperCase());
            } else {
                previousValue = previousValue + ' ' + data[key + '_format'].split('#')[3];
            }
        }

        returnValue +=
            '<div class="row">' +
            '<section class="col col-12">' +
            '<label class="checkbox checkbox-inline tt-checkbox-control">' +
            '<input type="checkbox" class="tt-previous-examinationdata-field" data-name="' + key + '" ' + checked + '>' +
            '<i></i>' + splittedValue[1] + '<span class="tt-previous-examinationdata-text"> (' + previousValue.trim() + ')</span>' +
            '</label>' +
            '</section>' +
            '</div>';

        if (i === pageCount * currentPage - 1) {
            return false;
        }
        i = i + 1;
    });

    return returnValue;
}

function setPreviousExaminationData(button, data) {

    var allPreviousExaminationData = $('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-examination-id').data('previous_examination_data');
    utils.GLOBALS.subControlsList.length = 0;
    jQuery.each($(button.parents('.row')[0]).parent().find('[data-assume-previous-data="true"]'), function (i, element) {

        if (($(element).attr('name') in data) || ($(element).attr('name') + '_format' in data)) {
            var value = '';
            if ($(element).attr('name') in data) {
                value = data[$(element).attr('name')];
            }
            var format = '';
            if ($(element).attr('name') + '_format' in allPreviousExaminationData) {
                format = allPreviousExaminationData[$(element).attr('name') + '_format'].split('#')[0];
            }
            if (((access.getRight($(element), 'write') > 0 && !utils.isUndefined($(element)[0].dataset) && (utils.isUndefined($(element)[0].dataset.initValue) || $(element)[0].dataset.initValue === ''))
                    || (access.getRight($(element), 'update') > 0 && !utils.isUndefined($(element)[0].dataset) && !utils.isUndefined($(element)[0].dataset.initValue) && $(element)[0].dataset.initValue !== ''))
                && hasParentControlActivationOptionChecked($(element))) {
                setControlValue($(element), value, format, '', false, true);
            }
        }
    });
    $(button.parents('form')[0]).trigger('checkform.areYouSure');
    doIntegrityCheckCalculationAndCompletenessForSubControlList(true);
}

function setTransferData(tab, data) {

	utils.GLOBALS.subControlsList.length = 0;
	jQuery.each($(tab).find('[name]'), function (i, element) {

		if (($(element).attr('name') in data) || ($(element).attr('name') + '_format' in data)) {
			var value = '';
			if ($(element).attr('name') in data) {
				value = data[$(element).attr('name')];
			}
			var format = '';
			if ($(element).attr('name') + '_format' in data) {
				format = data[$(element).attr('name') + '_format'].split('#')[0];
			}
			if (((access.getRight($(element), 'write') > 0 && !utils.isUndefined($(element)[0].dataset) && (utils.isUndefined($(element)[0].dataset.initValue) || $(element)[0].dataset.initValue === ''))
					|| (access.getRight($(element), 'update') > 0 && !utils.isUndefined($(element)[0].dataset) && !utils.isUndefined($(element)[0].dataset.initValue) && $(element)[0].dataset.initValue !== ''))
				&& hasParentControlActivationOptionChecked($(element))) {
				setControlValue($(element), value, format, '', false, true);
			}
		}
	});
	$(tab).trigger('checkform.areYouSure');
	doIntegrityCheckCalculationAndCompletenessForSubControlList(true);
}

function setImportData(data, currentFormData) {

    utils.GLOBALS.subControlsList.length = 0;
    jQuery.each(data, function (key, value) {

        var splittedValue = value.split('§§');

        if (splittedValue.length === 3) {

            currentFormData[key] = splittedValue[1].substr(0, splittedValue[1].indexOf('#'));
            currentFormData[key + '_format'] = splittedValue[2];

            // Befindet sich der Wert auf einem bereits geladenen Tab, so muss hier der Wert ersetzt werden
            jQuery.each($('[name="' + key + '"]'), function (k, element) {
                if ($($(element).parents('.tt-doc-pane')[0]).hasClass('data-loaded')) {

                    setControlValue($(element), splittedValue[1].substr(0, splittedValue[1].indexOf('#')), splittedValue[2], '', false, true);
                    $($(element).parents('form')[0]).trigger('checkform.areYouSure');
                }
            });
        }
    });

    // Berechnungen durchführen
    doIntegrityCheckCalculationAndCompletenessForSubControlList(true);

    // Array mit den aktuellen Daten neu setzen
    if (isExaminationSelected()) {
        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', currentFormData);
    } else {
        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data', currentFormData);
    }
}

function getImportConflictForm(data, dataToAssume) {

    var returnValue = '<form action="" class="tt-import-conflict-popover" style="min-width:420px">' +
        '<div class="row tt-import-conflicts" data-import-conflict-items="' + utils.htmlSpecialChars(JSON.stringify(dataToAssume)) + '">' +
        '<section class="col col-12">';

    var conflictString = trans('tripletrax.import_conflict_description');
    for (var i = 0; i < Object.keys(data).length; i++) {

        var key = Object.keys(data)[i];
        var value = data[key];
        var splittedValue = value.split('||');
        if (splittedValue.length === 2) {

            var splittedOldValue = splittedValue[0].split('§§');
            var splittedNewValue = splittedValue[1].split('§§');
            if (splittedOldValue.length === 2 && splittedNewValue.length === 2) {

                var splittedNewValueFormat = splittedNewValue[0].split('#');
                if (splittedNewValueFormat.length === 2) {

                    var oldValue = '';
                    var newValue = '';

                    if (splittedNewValueFormat[1] === 'd' && splittedOldValue[0] !== '') {
                        oldValue = utils.dateToLocaleString(splittedOldValue[0]);
                    } else if (splittedNewValueFormat[1] === 'n' && splittedOldValue[0] !== '') {
                        oldValue = utils.numberToString(parseFloat(splittedOldValue[0]));
                    }
                    if (splittedOldValue[1] !== '') {
                        if (utils.isFormatValue(splittedOldValue[1])) {
                            oldValue = trans('tripletrax.' + splittedOldValue[1]);
                        } else {
                            if (splittedNewValueFormat[1] === 'd') {
                                oldValue = utils.dateToLocaleFormatString(splittedOldValue[0], splittedOldValue[1].replace('yy', 'yyyy').toUpperCase());
                            } else {
                                oldValue = oldValue + ' ' + splittedOldValue[1];
                            }
                        }
                    }

                    if (splittedNewValueFormat[1] === 'd' && splittedNewValueFormat[0] !== '') {
                        newValue = utils.dateToLocaleString(splittedNewValueFormat[0]);
                    } else if (splittedNewValueFormat[1] === 'n' && splittedNewValueFormat[0] !== '') {
                        newValue = utils.numberToString(parseFloat(splittedNewValueFormat[0]));
                    }
                    if (splittedNewValue[1] !== '') {
                        if (utils.isFormatValue(splittedNewValue[1])) {
                            newValue = trans('tripletrax.' + splittedOldValue[1]);
                        } else {
                            if (splittedNewValueFormat[1] === 'd') {
                                newValue = utils.dateToLocaleFormatString(splittedNewValueFormat[0], splittedNewValue[1].replace('yy', 'yyyy').toUpperCase());
                            } else {
                                newValue = newValue + ' ' + splittedNewValue[1];
                            }
                        }
                    }

                    conflictString += '<br>- ' + key + ': ' + oldValue + ' -> ' + newValue;
                }
            }
        }
    }

    conflictString += '<br><br>' + trans('tripletrax.import_conflict_question');

    returnValue += '<label class="label label-tripletrax">' + conflictString +
        '</label>' +
        '</section></div></form>' +
        '<div class="form-actions">' +
        '<div class="row">' +
        '<div class="col col-12">' +
        '<div class="btn-toolbar btn-toolbar-tripletrax pull-right">' +
        '<div class="btn-group">' +
        '<a class="btn btn-success tt-save-import-conflicts" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.save_tooltip') + '">' +
        '<i class="fad fa-check"></i>' +
        '</a>' +
        '<a class="btn btn-danger tt-cancel-import-conflicts" rel="tooltip" data-placement="bottom" data-original-title="' + trans('tripletrax.cancel_tooltip') + '">' +
        '<i class="fad fa-times"></i>' +
        '</a>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>' +
        '</div>';

    return returnValue;
}

function addListEntry(table, dataId, data, isOwnFacility, isNewElement, isLocked) {

    var newListEntry = jQuery.parseHTML(table.parents('.tt-content-datatable').find('.tt-hidden-list-entry').val());
    var newId = parseInt(table.parents('.tt-content-datatable').find('.tt-hidden-list-entry-counter').val());
    table.parents('.tt-content-datatable').find('.tt-hidden-list-entry-counter').val(newId + 1);
    $(newListEntry).data('rowId', newId);
    $(newListEntry).data('dataId', dataId);
    $(newListEntry).find('.tt-list-id').text(newId);

    jQuery.each($(newListEntry).find('[name]'), function(i, val) {

        var newName = $(val).prop('name').substr(0, $(val).prop('name').lastIndexOf('__') + 2) + newId;
        $(val).attr('name', newName);
    });
    jQuery.each($(newListEntry).find('a[data-control]'), function(i, val) {

        var newName = $(val).data().control.substr(0, $(val).data().control.lastIndexOf('__') + 2) + newId;
        $(val).attr('data-control', newName);
    });

    initialize.initializeElements($(newListEntry), isOwnFacility, isLocked);

    jQuery.each($(newListEntry).find(".tt-unlock-for-editing"), function (i, subelement) {
        setControlEnabled($(subelement), false, false, false, true, false);
    });

    if (!utils.isUndefined(data)) {
        setValues($(newListEntry), data, false);
    }

    table.dataTable().fnAddData($(newListEntry));

    var calculationArray = [];
    jQuery.each($(newListEntry).find(".tt-check-calculation"), function (i, subelement) {
        if ($(subelement).is(':radio') || $(subelement).is(':checkbox')) {
            if ($(subelement).is(':checked')) {
                calculationArray.push($(subelement));
            }
        } else {
            calculationArray.push($(subelement));
        }
    });

    if (calculationArray.length) {
        calculateValues(calculationArray, true, null, false);
    }
    if (isNewElement) {
        jQuery.each($(newListEntry).find('[name]'), function (i, val) {
            setQueryValue($(val), '', null, '', null, '',false, true, true);
        });
        setFormDataForAjaxCall($(table.parents('.tab-pane')[0]), true, true);
        setCompleteness(null);
    }
    $(table.parents('form')[0]).trigger('rescan.areYouSure');
    if (!isNewElement) {
        $(table.parents('form')[0]).trigger('reinitialize.areYouSure');
        $(table.parents('form')[0]).removeClass('dirty');
    }
}

function addAccordionGroup(accordion, dataId, openPanel, isOwnFacility, isNewElement, isLocked) {

    var newAccordionPanel = accordion.find('.tt-accordion-hidden-panel-string').val();
    var newId = parseInt(accordion.find('.tt-accordion-hidden-panel-counter').val());
    accordion.find('.tt-accordion-hidden-panel-counter').val(newId + 1);

    accordion.find('.panel-group').prepend(newAccordionPanel);

    newAccordionPanel = accordion.find('.tt-accordion-panel:first');
    initialize.initializeElements(newAccordionPanel, isOwnFacility, isLocked);
    $(newAccordionPanel).data('rowId', newId);
    $(newAccordionPanel).data('dataId', dataId);

    if ($('#accordions_always_expanded').val() === '1') {
        newAccordionPanel.parents('.tt-accordion').find('.tt-accordion-panel-body').collapse('show');
        newAccordionPanel.parents('.tt-accordion').find('.tt-accordion-header').attr('disabled', 'disabled');
        newAccordionPanel.parents('.tt-accordion').find('.tt-accordion-header').find('.tt-icon-accordion').addClass('hide');
    } else {
        if (openPanel) {
            newAccordionPanel.parents('.tt-accordion').find('.tt-accordion-panel-body.in').collapse('toggle');
            newAccordionPanel.parents('.tt-accordion').find('.tt-accordion-header').addClass('collapsed');
            newAccordionPanel.find('.tt-accordion-panel-body').collapse('toggle');
            newAccordionPanel.find('.tt-accordion-header').removeClass('collapsed');
        }
    }

    var a = newAccordionPanel.find('.tt-accordion-header');
    var span = a.find('span');
    var id = a.attr('href');
    var newIdName = id.substr(0, id.lastIndexOf('__') + 2) + newId;

    jQuery.each(newAccordionPanel.find('[name]'), function(i, val) {

        var newName = $(val).prop('name').substr(0, $(val).prop('name').lastIndexOf('__') + 2) + newId;
        $(val).attr('name', newName);
    });
    jQuery.each(newAccordionPanel.find('a[data-control]'), function(i, val) {

        var newName = $(val).data().control.substr(0, $(val).data().control.lastIndexOf('__') + 2) + newId;
        $(val).attr('data-control', newName);
    });


    span.text(span.text().substr(0, span.text().lastIndexOf('(') + 1) + (newId + 1) + ')');

    newAccordionPanel.find(id).attr('id', newIdName.substr(1));
    newAccordionPanel.find('.tt-accordion-header').attr('href', newIdName);

    var calculationArray = [];
    jQuery.each(newAccordionPanel.find(".tt-check-calculation"), function (i, subelement) {
        if ($(subelement).is(':radio') || $(subelement).is(':checkbox')) {
            if ($(subelement).is(':checked')) {
                calculationArray.push($(subelement));
            }
        } else {
            calculationArray.push($(subelement));
        }
    });
    jQuery.each(newAccordionPanel.find(".tt-unlock-for-editing"), function (i, subelement) {
        setControlEnabled($(subelement), false, false, false, true, false);
    });

    if (isDevice() || ($('.tab-content').data().isPreview !== 'true' && !$('.tab-content').data().isPreview)) {
        newAccordionPanel.find('ul.fa-ul').fadeOut();
        newAccordionPanel.find('.tt-column-panel').fadeOut();
        newAccordionPanel.find('.tt-repetition-panel').fadeOut();
    }

    if (calculationArray.length) {
        calculateValues(calculationArray, true, null, false);
    }

    if (isNewElement) {
        jQuery.each(newAccordionPanel.find('[name]'), function (i, val) {
            setQueryValue($(val), '', null, '', null, '',false, true, true);
        });
        jQuery.each(newAccordionPanel.find('.tt-radio-column'), function (i, val) {
            setColumnControlsEnabled($($(val).find('.tt-view-radio')[0]), false, false, false);
        });
        setFormDataForAjaxCall($(accordion.parents('.tab-pane')[0]), true, true);
        setCompleteness(null);
    }
    $(accordion.parents('form')[0]).trigger('rescan.areYouSure');
    if (!isNewElement) {
        $(accordion.parents('form')[0]).trigger('reinitialize.areYouSure');
        $(accordion.parents('form')[0]).removeClass('dirty');
    }
}

// Werte abgleichen, falls Element mehrfach vorkommt
function equalizeControls(control, doIntegrityCheckAndCalculation, formData) {

    if (!utils.isUndefined(control.attr('name')) && $('[name="' + control.attr('name') + '"]').length > 1 && (!control.is(':radio') || (control.is(':radio') && (control.is(':checked') || control.parent().parent().find('[name="' + control.attr('name') + '"]:checked').length === 0)))) {

        if (control.hasClass('tt-view-combo-multiselect')) {
            var currentValue = control.select2('data');
            jQuery.each($('[name="' + control.attr('name') + '"]'), function (i, element) {
                if ($(element).parents('#content-detail-master').length > 0 || $(element).parents('#content-detail-course').length > 0) {
                    if (element !== control[0]) {
                        $(element).select2('data', currentValue);
                        if (!$(element).hasClass('tt-sub-control')) {
                            var foundActivation = false;
                            jQuery.each(currentValue, function (i, val) {
                                if (!utils.isUndefined($(val.element).data().activation) && ($(val.element).data().activation === 1)) {
                                    foundActivation = true;
                                    return;
                                }
                            });
                            if (foundActivation) {
                                setSubControlsEnabled($(element), true);
                            } else {
                                setSubControlsEnabled($(element), false);
                            }
                        }
                        if (doIntegrityCheckAndCalculation) {
                            if (checkRights($(element)) && checkPrimaryKey($(element))) {
                                addToIntegrityList([$(element)], false, false);
                            }
                            calculateValues([$(element)], true, formData, false);
                            setCompleteness($(element), formData);
                        }
                    }
                }
            });
        } else if (control.hasClass('tt-view-combo')) {
            var currentValue = control.select2('data');
            jQuery.each($('[name="' + control.attr('name') + '"]'), function (i, element) {
                if ($(element).parents('#content-detail-master').length > 0 || $(element).parents('#content-detail-course').length > 0) {
                    if (element !== control[0]) {
                        $(element).select2('data', currentValue);
                        if (!$(element).hasClass('tt-sub-control') && !utils.isUndefined(currentValue)) {
                            if (!utils.isUndefined($(currentValue[0].element).data().activation) && ($(currentValue[0].element).data().activation === 1)) {
                                setSubControlsEnabled($(element), true);
                            } else {
                                setSubControlsEnabled($(element), false);
                            }
                        }
                        if (doIntegrityCheckAndCalculation) {
                            if (checkRights($(element)) && checkPrimaryKey($(element))) {
								addToIntegrityList([$(element)], false, false);
                            }
                            calculateValues([$(element)], true, formData, false);
                            setCompleteness($(element), formData);
                        }
                    }
                }
            });
        } else if (control.is(':checkbox')) {
            var currentValue = control.is(':checked');
            jQuery.each($('[name="' + control.attr('name') + '"]'), function (i, element) {
                if ($(element).parents('#content-detail-master').length > 0 || $(element).parents('#content-detail-course').length > 0) {
                    if (element !== control[0]) {
                        $(element).prop('checked', currentValue);
                        if (!$(element).hasClass('tt-sub-control')) {
                            if (currentValue) {
                                setSubControlsEnabled($(element), true);
                            } else {
                                setSubControlsEnabled($(element), false);
                            }
                        }
                        if (doIntegrityCheckAndCalculation) {
                            if (checkRights($(element)) && checkPrimaryKey($(element))) {
								addToIntegrityList([$(element)], false, false);
                            }
                            calculateValues([$(element)], true, formData, false);
                            setCompleteness($(element), formData);
                        }
                    }
                }
            });
        } else if (control.is(':radio')) {
            var currentValue = control.attr('value');
            jQuery.each($('[name="' + control.attr('name') + '"][value="' + currentValue +'"]'), function (i, element) {
                if ($(element).parents('#content-detail-master').length > 0 || $(element).parents('#content-detail-course').length > 0) {
                    if (element !== control[0]) {
                        $(element).prop('checked', control.is(':checked'));
                        if ($(element).data().activation === 1 && !$(element).hasClass('tt-sub-control')) {
                            setSubControlsEnabledForRadioButton($(element), false, true, false);
                        }
                        if (doIntegrityCheckAndCalculation) {
                            if (checkRights($(element)) && checkPrimaryKey($(element))) {
								addToIntegrityList([$(element)], false, false);
                            }
                            calculateValues([$(element)], true, formData, false);
                            setCompleteness($(element), formData);
                        }
                    }
                }
            });
        } else {
            var currentValue = control.val();
            var currentFormatValue = '';
            if (control.parent().parent().find('.tt-input-dropdown').length) {
                if (control.parent().parent().find('li.active').length) {
                    currentFormatValue = control.parent().parent().find('li.active').find('a').data().formatValue;
                }
            }
            jQuery.each($('[name="' + control.attr('name') + '"]'), function (i, element) {
                if ($(element).parents('#content-detail-master').length > 0 || $(element).parents('#content-detail-course').length > 0) {
                    if (element !== control[0]) {
                        if (currentFormatValue !== '') {
                            utils.setValueForInputWithDropDownField($(element).parent(), currentFormatValue, true);
                        }
                        $(element).val(currentValue);
                        if (doIntegrityCheckAndCalculation) {
                            if (checkRights($(element)) && checkPrimaryKey($(element))) {
								addToIntegrityList([$(element)], false, false);
                            }
                            calculateValues([$(element)], true, formData, false);
                            setCompleteness($(element), formData);
                        }
                    }
                }
            });
        }
    }
}

// Werte auf Stammdatenübersicht setzen
function setMasterOverviewValues(control) {
    if ($('[data-control-name="' + control.attr('name') + '"]').length) {

        if (control.hasClass('tt-view-combo-multiselect')) {
            var value = '';
            if (!utils.isUndefined(control.select2('data')) && control.select2('data') !== '') {
                jQuery.each(control.select2('data'), function (i, val) {
                    if (value !== '') {
                        value += ', ';
                    }
                    value += val.text;
                });
            }
            $('[data-control-name="' + control.attr('name') + '"]').text(value);
        } else if (control.hasClass('tt-view-combo')) {
            if (!utils.isUndefined(control.select2('val')) && control.select2('val') !== '') {
                $('[data-control-name="' + control.attr('name') + '"]').text(control.select2('data')[0].text);
            } else {
                $('[data-control-name="' + control.attr('name') + '"]').text('');
            }
        } else if (control.is(':checkbox')) {
            if (control.is(':checked')) {
                $('[data-control-name="' + control.attr('name') + '"]').text(trans('tripletrax.yes'));
            } else {
                $('[data-control-name="' + control.attr('name') + '"]').text('');
            }
        } else if (control.is(':radio')) {
            if (control.is(':checked')) {
                $('[data-control-name="' + control.attr('name') + '"]').text(control.parent().text());
            }
        } else {
            $('[data-control-name="' + control.attr('name') + '"]').text(control.val());
        }
    }

    if (!utils.isUndefined( control[0].dataset) && !utils.isUndefined(control[0].dataset.matchField)
        && (control[0].dataset.matchField === 'patientname' || control[0].dataset.matchField === 'prename' || control[0].dataset.matchField === 'birth_date' || control[0].dataset.matchField === 'gender'  || control[0].dataset.matchField === 'deceased' || control[0].dataset.matchField === 'deceased_date')) {
		var master = utils.getMaster();
        var name = getControlValue(master.find('[data-match-field="patientname"]'));
        var prename = getControlValue(master.find('[data-match-field="prename"]'));
        var birthDate = null;
        if (master.find('[data-match-field="birth_date"]').length) {
            birthDate = master.find('[data-match-field="birth_date"]').data('picker').getDate();
        }
        var gender = getControlValue(master.find('[data-match-field="gender"]'));
        var deceased = null;
        var deceasedIndex = -1;
        if (master.find('[data-match-field="deceased"]').length) {
            jQuery.each(master.find('[data-match-field="deceased"]'), function (i, element) {
                deceased = getControlValue($(element)) === 'true';
                if (deceased) {
                    deceasedIndex = i;
                    return false;
                }
            });

        }
        var deceasedDate = null;
        var deceasedDateFormat = null;
        if (deceased && master.find('[data-match-field="deceased_date"]').length > deceasedIndex) {
            deceasedDate = $(master.find('[data-match-field="deceased_date"]')[deceasedIndex]).data('picker').getDate();
            deceasedDateFormat = utils.getValueFromInputWithDropDownField($(master.find('[data-match-field="deceased_date"]')));
        }
        setMasterOverviewHeader(name.split('=')[0], prename.split('=')[0], birthDate, gender.split('=')[0], deceased, deceasedDate, deceasedDateFormat);
    }
}

function setMasterOverviewHeader(name, prename, birthDate, gender, deceased, deceasedDate, deceasedDateFormat) {
    var headerString = '';
	var patientData = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_data');

	headerString = getPatientDisplayName(patientData['pseudonym'], name, prename, birthDate, gender,  deceased, deceasedDate, deceasedDateFormat);

    jQuery.each($('.header-master-overview'), function(i, element) {
        $(element).text(headerString);
    });
}

function setPatientDisplayName() {

    var displayName = '';
    var aPos = $('#table_patientlist').dataTable().fnGetPosition($('#table_patientlist').find('.selected-row')[0]);
    var aData = $('#table_patientlist').dataTable().fnGetData(aPos);

    displayName = getPatientDisplayName(aData['pseudonym'], aData['patientname'], aData['prename'], aData['birth_date'], aData['gender'], aData['patient_deceased'], aData['patient_deceased_date'], aData['patient_deceased_date_format']);

    return displayName;
}

function getPatientDisplayName(pseudonym, name, prename, birthDate, gender, deceased, deceasedDate, deceasedDateFormat) {

    var displayName = '';

    // Name oder Pseudonym
	if (access.showPatientsAnonymized() === 1 || utils.GLOBALS.idatPatients === null) {
		displayName = '[' + pseudonym + ']';
	} else {
		displayName = (name + ', ' + prename).trim();
	}

	// Geburtsdatum
	if (birthDate !== null) {
		if (access.showPatientsAnonymized() === 1 || utils.GLOBALS.idatPatients === null) {
			displayName += ' * ' + moment(birthDate).format('MM/YYYY');
		} else {
			displayName += ' * ' + utils.dateToLocaleString(birthDate);
		}
	}

	// Todestag
	if (deceased !== null && (deceased === 1 || deceased === '1' || deceased === true || deceased === 'true')) {
		if (deceasedDate !== null) {
			if (access.showPatientsAnonymized() === 1 || utils.GLOBALS.idatPatients === null) {
			    if (deceasedDateFormat === 'yy') {
					displayName += ' - † ' + utils.dateToLocaleFormatString(deceasedDate, deceasedDateFormat.replace('yy', 'yyyy').toUpperCase());
                } else {
					displayName += ' - † ' + moment(deceasedDate).format('MM/YYYY');
				}
			} else {
				if (deceasedDateFormat === 'yy' || deceasedDateFormat === 'mm/yy') {
					displayName += ' - † ' + utils.dateToLocaleFormatString(deceasedDate, deceasedDateFormat.replace('yy', 'yyyy').toUpperCase());
				} else {
					displayName += ' - † ' + utils.dateToLocaleString(deceasedDate);
				}
			}
		} else {
			if (deceasedDateFormat !== null) {
				if (deceasedDateFormat === 'unknown') {
					displayName += ' - † ' + trans('tripletrax.unknown');
				} else if (deceasedDateFormat === 'not_collected') {
					displayName += ' - † ' + trans('tripletrax.not_collected');
				} else if (deceasedDateFormat === 'continuing') {
					displayName += ' - † ' + trans('tripletrax.continuing');
				}
			} else {
				displayName += ' - † ' + trans('tripletrax.unknown');
			}
		}
	}

	// berechnetes Alter in Jahren
	if (birthDate !== null) {
		displayName += ' (' + utils.calculateAge(birthDate, deceasedDate) + ' ' + trans('tripletrax.years_age') + ')';
	}

	// Geschlecht
	if (gender !== null && gender !== '') {
		var gender_values = $('#gender_values').data().values;
		displayName += ' - ' + gender_values[gender];
	}

	return displayName;
}

function getFacilityId() {

	if (isDevice() && $('#facility').length) {
		return $('#facility').val();
	}
    if ($('.facility-dropdown').parent().find('li.active').length) {
        return $('.facility-dropdown').parent().find('li.active').find('a').data().facilityid;
    }
    if (!utils.isUndefined($('.facility-dropdown').data())) {
        return $('.facility-dropdown').data().facilityid;
    }
    return 0;
}

function getFacilityDisplayName() {

    if ($('.facility-dropdown').parent().find('li.active').length) {
        return $('.facility-dropdown').parent().find('li.active').find('a').text().trim();
    }
    if (!utils.isUndefined($('.facility-dropdown').data())) {
        return $('.facility-dropdown').text().trim();
    }
    return 0;
}

function getModelId() {

	if (isDevice() && $('#model').length) {
		return $('#model').val();
	}
	if ($('.tt-data-collection-type').length <= 0) {
		return 0;
	}
	var dataCollectionTypeSelectControl = $($('.tt-data-collection-type')[0]);
	if (utils.isUndefined(dataCollectionTypeSelectControl.select2('val')) || dataCollectionTypeSelectControl.select2('val') === '') {
		return 0;
	}
    return dataCollectionTypeSelectControl.select2('val');
}

function getQuestionnaires() {

	if ($('.tt-data-collection-type').length <= 0) {
		return {};
	}
	var dataCollectionTypeSelectControl = $($('.tt-data-collection-type')[0]);
	if (utils.isUndefined(dataCollectionTypeSelectControl.select2('val')) || dataCollectionTypeSelectControl.select2('val') === '') {
		return {};
	}
	return dataCollectionTypeSelectControl.select2('data')[0].questionnaires;
}

function getCompletenessNotification() {

    if ($('.tt-data-collection-type').length <= 0) {
        return 0;
    }
    var dataCollectionTypeSelectControl = $($('.tt-data-collection-type'));
	if (utils.isUndefined(dataCollectionTypeSelectControl.select2('val')) || dataCollectionTypeSelectControl.select2('val') === '') {
		return 0;
	}
    return $(dataCollectionTypeSelectControl.select2('data')[0].element).data().completenessNotification;
}

function getPatientId() {

	if (isDevice() && $('#patient').length) {
		return $('#patient').val();
	}
    var patientId = 0;
    if ($('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-id').val() !== '') {
        patientId = $('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-id').val();
    }
    return patientId;
}

function getPatientIsActive() {

    var patientIsActive = 0;
    if ($('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-patient-is-active').val() !== '') {
        var data = $('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-patient-is-active').val();

        if (!utils.isUndefined(data) && data !== '') {
            jQuery.each(data.split('|'), function (i, val) {
                var states = val.split(',');
                if (states[1] === $('#state_values').data().matchValues['patient_active']) {
                    patientIsActive = 1;
                    return false;
                } else if (states[0] === '1' && (utils.isUndefined(states[1]) || states[1] === '')) {
                    patientIsActive = 1;
                } else if (states[1] !== '' && patientIsActive !== 1) {
                    patientIsActive = 0;
                }
            });
        }
    }
    return patientIsActive;
}

function getPatientIsLocked() {

	var patientIsLocked = 0;
	if ($('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-patient-is-locked').val() !== '') {
		var data = $('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-patient-is-locked').val();
		if (!utils.isUndefined(data)) {
			patientIsLocked = 1;
		}
	}
	return patientIsLocked;
}

function getExaminationDate() {

	if (isDevice() && $('#examination').length) {
		return $('#examination').val();
	}
    var examinationDate = $('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-examination-date').val();
    if (examinationDate === '') {
        examinationDate = '0000-00-00';
    }
    return examinationDate;
}

function getExaminationId() {

    var examinationId = $('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-examination-id').val();
    if (examinationId === '') {
        return '0';
    }
    return examinationId;
}

function isExaminationSelected() {
    if ($('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-examination-id').val() !== '') {
        return true;
    }
    return false;
}

function getExaminationFacilityId() {

    var examinationFacilityId = $('#content-detail-patientlist').find('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_facility_id');
    if (utils.isUndefined(examinationFacilityId) || examinationFacilityId === '') {
        return '0';
    }
    return examinationFacilityId;
}

function isDevice() {
	return $('#is_device').length && $('#is_device').val() === 'true';
}

function getFormDataForAjaxCall(addIDATFieldsForCompleteness, addEmptyValues, addTableNames) {

	// console.time('getFormDataForAjaxCall');
    var course = utils.getCourse();
    var master = utils.getMaster();

    var data = [];
	if (isDevice()) {
		data = $('#is_device').data('questionnaireFormData');
	} else if (isExaminationSelected()) {
        data = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data');
    } else {
        data = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data');
    }

    if (utils.isUndefined(data)) {
        return '';
    }

    if (addTableNames) {
        data = addTableNamesToData(course, addTableNamesToData(master, data));
    }

    if (!isDevice()) {
		var birthDate = data[master.find('[data-match-field="birth_date"]').attr('name')];
		var gender = data[master.find('[data-match-field="gender"]').attr('name')];
		var patientname = data[master.find('[data-match-field="patientname"]').attr('name')];
		var prename = data[master.find('[data-match-field="prename"]').attr('name')];
		var street = data[master.find('[data-match-field="street"]').attr('name')];
		var postalCode = data[master.find('[data-match-field="postal_code"]').attr('name')];
		var city = data[master.find('[data-match-field="city"]').attr('name')];
		var birthName = data[master.find('[data-match-field="birth_name"]').attr('name')];
		var birthCity = data[master.find('[data-match-field="birth_city"]').attr('name')];
	}

    var ajaxData = '';
    for (var key in data) {
        if (utils.getIgnoreFieldsNameArray().indexOf(key) < 0 && !utils.isUndefined(data[key]) && (data[key] !== '' || addEmptyValues)) {
            if (ajaxData !== '') {
                ajaxData += '&';
            }
            ajaxData += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
        }
    }

	if (!isDevice()) {
		// Geburtsdatum und Geschlecht hinzufügen
		if (!utils.isUndefined(birthDate) && birthDate !== '') {
			if (ajaxData !== '') {
				ajaxData += '&';
			}
			ajaxData += master.find('[data-match-field="birth_date"]').attr('name') + '=' + birthDate.substr(0, 8) + '15';
			ajaxData += '&' + master.find('[data-match-field="birth_date"]').attr('name') + '_format=mm/yy';
		}
		if (!utils.isUndefined(gender)) {
			if (ajaxData !== '') {
				ajaxData += '&';
			}
			ajaxData += master.find('[data-match-field="gender"]').attr('name') + '=' + encodeURIComponent(gender);
		}

		if (addIDATFieldsForCompleteness) {

			if (patientname !== '') {
				if (ajaxData !== '') {
					ajaxData += '&';
				}
				ajaxData += master.find('[data-match-field="patientname"]').attr('name') + '=*';
			}
			if (prename !== '') {
				if (ajaxData !== '') {
					ajaxData += '&';
				}
				ajaxData += master.find('[data-match-field="prename"]').attr('name') + '=*';
			}
			if (street !== '') {
				if (ajaxData !== '') {
					ajaxData += '&';
				}
				ajaxData += master.find('[data-match-field="street"]').attr('name') + '=*';
			}
			if (postalCode !== '') {
				if (ajaxData !== '') {
					ajaxData += '&';
				}
				ajaxData += master.find('[data-match-field="postal_code"]').attr('name') + '=*';
			}
			if (city !== '') {
				if (ajaxData !== '') {
					ajaxData += '&';
				}
				ajaxData += master.find('[data-match-field="city"]').attr('name') + '=*';
			}
			if (birthName !== '') {
				if (ajaxData !== '') {
					ajaxData += '&';
				}
				ajaxData += master.find('[data-match-field="birth_name"]').attr('name') + '=*';
			}
			if (birthCity !== '') {
				if (ajaxData !== '') {
					ajaxData += '&';
				}
				ajaxData += master.find('[data-match-field="birth_city"]').attr('name') + '=*';
			}
		}
	}

    // console.log(ajaxData);
	// console.timeEnd('getFormDataForAjaxCall');
	// console.timeEnd('getFormDataForAjaxCall');
    return ajaxData;
}

function setFormDataForAjaxCall(control, addEmptyValues, addIntegrityValues, addQueryValues) {

    // console.time('setFormDataForAjaxCall');
    // console.trace();
    var formData = [];
    if (isDevice()) {
		formData = $('#is_device').data('questionnaireFormData');
	} else if (isExaminationSelected()) {
        formData = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data');
    } else {
        formData = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data');
    }

    if (utils.isUndefined(formData)) {
        return;
    }

    var rCRLF = /\r?\n/g;
    var data = [];

    if (control !== null) {
        jQuery.each(utils.getSerializedFormDataWithoutIgnore(control, '', addEmptyValues).split('&'), function (i, val) {
            var value = val.split('=');
            data[value[0]] = value[1];
        });

        if (!isDevice()) {
			if (addIntegrityValues) {
				jQuery.each(control.find('[data-integrity-rule]'), function (i, val) {
					var integrityRule = val.dataset.integrityRule.split('#');
					var integrityOriginFlag = val.dataset.integrityOriginFlag;
					var confirmed = '0';
					if (integrityRule[0] !== 'primary_key' && !utils.isUndefined(val.dataset.confirmed) && val.dataset.confirmed === 'true') {
						confirmed = '1';
					}
					data[$(val).attr('name') + '_confirmed'] = encodeURIComponent(integrityRule[0] + '§' + confirmed + '§' + integrityRule[1] + '§' + integrityOriginFlag);
				});
			}

			addQueryValues = utils.isUndefined(addQueryValues) ? true : addQueryValues;
			if (addQueryValues) {
				jQuery.each(control.find('[data-query-question]'), function (i, val) {
					var queryQuestion = val.dataset.queryQuestion;
					var queryAnswer = val.dataset.queryAnswer;

					var name = $(val).attr('name');
					var prefix = name;
					var postfix = '';
					if (/__/.test(name)) {
						prefix = name.substr(0, name.indexOf('__'));
						postfix = name.substr(name.indexOf('__'));
					}

					if (queryQuestion.length > 0 || queryAnswer.length > 0) {
						var queryClosed = '0';
						if (!utils.isUndefined(val.dataset.queryClosed)) {
							queryClosed = val.dataset.queryClosed;
						}

						data[prefix + '_query_question' + postfix] = encodeURIComponent(queryQuestion);
						data[prefix + '_query_question_date' + postfix] = null;
						data[prefix + '_query_answer' + postfix] = encodeURIComponent(queryAnswer);
						data[prefix + '_query_answer_date' + postfix] = null;
						data[prefix + '_query_closed' + postfix] = encodeURIComponent(queryClosed);
					} else {
						if (prefix + '_query_question' + postfix in formData) {
							delete formData[prefix + '_query_question' + postfix];
						}
						if (prefix + '_query_question_date' + postfix in formData) {
							delete formData[prefix + '_query_question_date' + postfix];
						}
						if (prefix + '_query_answer' + postfix in formData) {
							delete formData[prefix + '_query_answer' + postfix];
						}
						if (prefix + '_query_answer_date' + postfix in formData) {
							delete formData[prefix + '_query_answer_date' + postfix];
						}
						if (prefix + '_query_closed' + postfix in formData) {
							delete formData[prefix + '_query_closed' + postfix];
						}
					}
				});
			}

			jQuery.each(control.find('[calculate-other-examinations]'), function (i, val) {
				data[$(val).attr('name') + '_calculate_other_examinations'] = true;
			});

			jQuery.each(control.find('[check-completeness-all-patient]'), function (i, val) {
				data[$(val).attr('name') + '_check_completeness_all_patient'] = true;
			});

			jQuery.each(control.find('[check-completeness-all-examination]'), function (i, val) {
				data[$(val).attr('name') + '_check_completeness_all_examination'] = true;
			});

			control.find('[data-database-table-name]').each(function (i, table) {
				var listItemNames = $(table).data().listItemNames.split('|');
				var regExp = new RegExp('^' + $(table).data().databaseTableName + '_rowid__');
				var tableRowsPrevious = [];
				for (var key in formData) {
					if (regExp.test(key)) {
						tableRowsPrevious.push(key);
					}
				}
				var tableRowsNew = [];
				for (var key in data) {
					if (regExp.test(key)) {
						tableRowsNew.push(key);
					}
				}

				for (var i = 0; i < tableRowsPrevious.length; i++) {
					if (jQuery.inArray(tableRowsPrevious[i], tableRowsNew) < 0) {
						var index = tableRowsPrevious[i].substr(tableRowsPrevious[i].indexOf('__'));
						for (var k = 0; k < listItemNames.length; k++) {
							if (listItemNames[k] + index in formData) {
								delete formData[listItemNames[k] + index];
							}
							if (listItemNames[k] + '_format' + index in formData) {
								delete formData[listItemNames[k] + '_format' + index];
							}
							if (listItemNames[k] + '_confirmed' + index in formData) {
								delete formData[listItemNames[k] + '_confirmed' + index];
							}
						}
						delete formData[tableRowsPrevious[i]];
					}
				}
			});
		}
    }

    for (var key in data) {
        formData[key] = decodeURIComponent(data[key]);
        if (!(key + '_confirmed' in data) && (key + '_confirmed' in formData)) {
            delete formData[key + '_confirmed'];
        }
    }

	if (isDevice()) {
		$('#is_device').data('questionnaireFormData', formData);
	} else if (isExaminationSelected()) {
        $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', formData);
    } else {
        $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data', formData);
    }
	// console.log(formData);
	// console.timeEnd('setFormDataForAjaxCall');
}

function setColoredCompletenessDataForAjaxCall() {

	var formData = [];
	if (isExaminationSelected()) {
		formData = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data');
	} else {
		formData = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data');
	}

	if (utils.isUndefined(formData)) {
		return;
	}

	jQuery.each($('.tt-doc-tab'), function (i, tab) {
		if (!utils.isUndefined($(tab).data().coloredCompleteness)) {
			formData[(tab.hash).replace('#', '') + '_colored_completeness'] = decodeURIComponent($(tab).data().coloredCompleteness);
			formData[(tab.hash).replace('#', '') + '_colored_completeness_count'] = decodeURIComponent($(tab).data().coloredCompletenessCount);
			formData[(tab.hash).replace('#', '') + '_colored_completeness_missing'] = decodeURIComponent($(tab).data().coloredCompletenessMissing);
		}
	});


	if (isExaminationSelected()) {
		$('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data', formData);
	} else {
		$('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data', formData);
	}
}

function addTableNamesToData(control, data) {
    jQuery.each(control.find('form'), function (i, form) {
        jQuery.each($(form).find('[data-database-table-name]'), function (i, control) {
            if (!($(control).attr('data-database-table-name') + '_table' in data)) {
                data[$(control).attr('data-database-table-name') + '_table'] = '';
            }
        });
    });

    return data;
}

function setValues(element, data, doEqualizeControls, doJustQueries, resetControls, setAllColumns, setColumnCaption) {

	resetControls = !utils.isUndefined(resetControls) ? resetControls : true;
	setAllColumns = !utils.isUndefined(setAllColumns) ? setAllColumns : true;
	setColumnCaption = !utils.isUndefined(setColumnCaption) ? setColumnCaption : false;
    var resetRadioButtons = [];
    var questionnaires = [];

    var nameElements = element.find("[name]:not('.tt-tab-button-control')");
	for (var k = 0; k < nameElements.length; k++) {
        var subcontrol = $(nameElements[k]);

        if (setColumnCaption && !$(subcontrol).hasClass('tt-repetition-caption')) {
        	continue;
		}

        var subControlName = subcontrol.attr('name');
        if (!utils.isUndefined(subControlName)) {
        	var columnRepetition = 1;
			if (setAllColumns && !utils.isUndefined($(subcontrol).data().columnRepetition) && parseInt($(subcontrol).data().columnRepetition) > 1) {
				columnRepetition = parseInt($(subcontrol).data().columnRepetition);
			}

			for (var r = 1; r <= columnRepetition; r++) {

				var name = subControlName;
				if (r > 1) {
					name = subControlName + '_spalte_' + r;
				}

				if (!doJustQueries) {
					//console.time('setValue - ' + subcontrol.attr('name'));
					var formatName = '';
					var implausibleIntegrityName = '';
					if (/__/.test(name)) {
						formatName = name.substr(0, name.indexOf('__')) + '_format' + name.substr(name.indexOf('__'));
						implausibleIntegrityName = name.substr(0, name.indexOf('__')) + '_confirmed' + name.substr(name.indexOf('__'));
					} else {
						formatName = name + '_format';
						implausibleIntegrityName = name + '_confirmed';
					}

					if (r > 1 && !((name in data && !utils.isUndefined(data[name]) && data[name] !== '') || (formatName in data && !utils.isUndefined(data[formatName]) && data[formatName] !== ''))) {
						continue;
					}
					if (r > 1) {
						var tabButtonGroup = $($(subcontrol).parents('.tt-column')[0]).find('.tt-tab-button-group');
						if (parseInt($(tabButtonGroup).find('input:checked').val()) < r) {
							setValues($($(subcontrol).parents('.tt-column-panel,.tt-panel')[0]), data, doEqualizeControls, doJustQueries, resetControls, false, true);

							$(tabButtonGroup).find('input:checked').prop('checked', false);
							$(tabButtonGroup).find('input[value="' + r + '"]').prop('checked', true);
							$(tabButtonGroup).find('.tt-tab-button').removeClass('active');
							$(tabButtonGroup).find('input[value="' + r + '"]').parent().addClass('active');
							showColumn($($(subcontrol).parents('.tt-column-panel,.tt-panel')[0]), r, false);
							patients.resetForms($($(subcontrol).parents('.tt-column-panel,.tt-panel')[0]), true, true);
						}
					}

					//console.time("resetControl");
					if (!subcontrol.is(':radio') || (subcontrol.is(':radio') && resetRadioButtons.indexOf(name) < 0)) {
						resetControl(subcontrol, true);
						if (!utils.isUndefined(subcontrol[0].dataset.calculatedValue)) {
							subcontrol[0].dataset.calculatedValue = '';
						}
						if (subcontrol.is(':radio')) {
							resetRadioButtons.push(name);
						}
					}
					//console.timeEnd("resetControl");
					if (((name in data && !utils.isUndefined(data[name]) && data[name] !== '') || (formatName in data && !utils.isUndefined(data[formatName]) && data[formatName] !== '')) && subcontrol.parents('table').length <= 0) {
						var value = '';
						if (name in data) {
							value = data[name];
						}
						var format = '';
						if (formatName in data) {
							format = data[formatName];
						}
						var implausibleIntegrity = '';
						if (implausibleIntegrityName in data) {
							implausibleIntegrity = data[implausibleIntegrityName];
						}

						// InitValue muss vor setControlValue gesetzt werden
						if (utils.isFormatValue(format)) {
							subcontrol[0].dataset.initValue = format;
						} else {
							subcontrol[0].dataset.initValue = value;
						}

						// console.time("setControlValue true " + subcontrol.attr('name'));
						setControlValue(subcontrol, value, format, implausibleIntegrity, true, false, true);
						// console.timeEnd("setControlValue true " + subcontrol.attr('name'));
						if ((setAllColumns && columnRepetition > 1) || setColumnCaption) {
							setRepetitionCaption(subcontrol);
						}

					} else {
						if (access.getRight(subcontrol, 'write') === 0) {
							//console.time("setControlEnabled " + subcontrol.attr('name'));
							setControlEnabled(subcontrol, false, false, false, true, false);
							//console.timeEnd("setControlEnabled " + subcontrol.attr('name'));

							if (subcontrol.hasClass('tt-view-input') || subcontrol.hasClass('tt-view-datepanel')) {
								if (subcontrol.parents('.tt-view-input-label').find('button.btn-dropdown').length) {
									setControlEnabled(subcontrol.parents('.tt-view-input-label').find('button.btn-dropdown'), false, false, false, true, false);
								}
							}

							$.each(subcontrol.parents('[class^="tt-rightclass-"]').find('.tt-btn-unlock-for-editing,.tt-btn-assume-examination-date'), function (i, button_control) {
								$(button_control).addClass('hide');
							});
						}
						// console.time("setControlValue false " + subcontrol.attr('name'));
						setMasterOverviewValues(subcontrol);
						if (resetControls) {
							if (subcontrol.hasClass('tt-view-radio') && subcontrol.parent().is(':first-child') && subcontrol.parents('.tt-radio-accordion').length) {
								setAccordionControlsEnabled(subcontrol, false, false, false, false);
							}
							if (subcontrol.hasClass('tt-view-radio') && subcontrol.parent().is(':first-child') && subcontrol.parents('.tt-radio-column').length) {
								setColumnControlsEnabled(subcontrol, false, false, false);
							}
						}
						// console.timeEnd("setControlValue false " + subcontrol.attr('name'));
					}
				}

				if (!subcontrol.hasClass('tt-calculated-value')) {
					var prefix = name;
					var postfix = '';
					if (/__/.test(name)) {
						prefix = name.substr(0, name.indexOf('__'));
						postfix = name.substr(name.indexOf('__'));
					}

					// Offener Query
					var queryQuestion = '';
					if (prefix + '_query_question' + postfix in data) {
						queryQuestion = data[prefix + '_query_question' + postfix];
					}
					var queryQuestionDate = null;
					if (prefix + '_query_question_date' + postfix in data) {
						queryQuestionDate = data[prefix + '_query_question_date' + postfix];
					}
					var queryAnswer = '';
					if (prefix + '_query_answer' + postfix in data) {
						queryAnswer = data[prefix + '_query_answer' + postfix];
					}
					var queryAnswerDate = null;
					if (prefix + '_query_answer_date' + postfix in data) {
						queryAnswerDate = data[prefix + '_query_answer_date' + postfix];
					}
					var queryId = '';
					if (prefix + '_query_id' + postfix in data) {
						queryId = data[prefix + '_query_id' + postfix];
					}
					var queryClosed = '';
					if (prefix + '_query_closed' + postfix in data) {
						queryClosed = (data[prefix + '_query_closed' + postfix] === '1' || data[prefix + '_query_closed' + postfix] === 1);
					}

					// Alle geschlossenen Queries werden in einer Objektliste gespeichert und übergeben
					var queryHistoryObjectList = [];
					if (prefix + '_query_history_list' + postfix in data) {
						queryList = data[prefix + '_query_history_list' + postfix];


						for (var i = 0; i < queryList.length; i++) {
							var query = queryList[i];

							var queryHistoryObject = new Object();

							queryHistoryObject.queryQuestion = '';
							if (prefix + '_query_question' + postfix in query) {
								queryHistoryObject.queryQuestion = query[prefix + '_query_question' + postfix];
							}
							queryHistoryObject.queryQuestionDate = null;
							if (prefix + '_query_question_date' + postfix in query) {
								queryHistoryObject.queryQuestionDate = query[prefix + '_query_question_date' + postfix];
							}
							queryHistoryObject.queryAnswer = '';
							if (prefix + '_query_answer' + postfix in query) {
								queryHistoryObject.queryAnswer = query[prefix + '_query_answer' + postfix];
							}
							queryHistoryObject.queryAnswerDate = null;
							if (prefix + '_query_answer_date' + postfix in query) {
								queryHistoryObject.queryAnswerDate = query[prefix + '_query_answer_date' + postfix];
							}
							queryHistoryObject.queryId = '';
							if (prefix + '_query_id' + postfix in query) {
								queryHistoryObject.queryId = query[prefix + '_query_id' + postfix];
							}
							queryHistoryObject.queryClosed = '';
							if (prefix + '_query_closed' + postfix in query) {
								queryHistoryObject.queryClosed = (query[prefix + '_query_closed' + postfix] === '1' || query[prefix + '_query_closed' + postfix] === 1);
							}
							queryHistoryObjectList.push(queryHistoryObject);
						}
					}

					setQueryValue(subcontrol, queryQuestion, queryQuestionDate, queryAnswer, queryAnswerDate, queryId, queryClosed, true, true, queryHistoryObjectList);
				}

				if (doEqualizeControls) {
					equalizeControls(subcontrol, false);
				}
				//console.timeEnd('setValue - ' + subcontrol.attr('name'));
			}
        }
    }
}

function doIntegrityCheckCalculationAndCompletenessForSubControlList(checkIntegrityFlag, element) {

    if (utils.GLOBALS.subControlsList.length > 0) {
        var integrityArray = [];
        var doCompletenessCheck = false;

        for (var i = 0; i < utils.GLOBALS.subControlsList.length; i++) {

            var control = utils.GLOBALS.subControlsList[i];

            if (!checkIntegrityFlag || !((!utils.isUndefined(control.data().confirmed) && control.data().confirmed === "true") ||
                    (!utils.isUndefined(control.data().integrityOriginFlag) && utils.isIgnoreFlagForIntegrityCheck(control.data().integrityOriginFlag)))) {
                if (checkRights(control) && checkPrimaryKey(control)) {
                    if (control.is(':radio')) {
                        if (control.parent().is(':first-child')) {
                            integrityArray.push(control);
                        }
                    } else {
                        integrityArray.push(control);
                    }
                } else {
                    if (!utils.isUndefined(control)) {
                        if (element.parents('section.tt-column').length) {
                            $(element.parents('section.tt-column')[0]).find('.tt-column-panel').fadeIn(300);
                            if ($(element.parents('section.tt-column')[0]).find('.tt-repetition-panel').length) {
								$(element.parents('section.tt-column')[0]).find('.tt-repetition-panel').fadeIn(300);
							}
                        }
                        if (element.parents('section,td').length) {
                            $(element.parents('section,td')[0]).find('ul.fa-ul').fadeIn(300);
                        }
                    }
                }
            }
            if (control.hasClass('tt-check-completeness') && !control.hasClass('tt-hide')) {
                doCompletenessCheck = true;
            }
        }

        setFormDataForAjaxCall($(utils.GLOBALS.subControlsList[0].parents('.tab-pane')[0]), true, true);
        var formData = getFormDataForAjaxCall(true, true, false);
        if (integrityArray.length) {
			addToIntegrityList(integrityArray, true, false);
        }
        calculateValues(utils.GLOBALS.subControlsList, true, formData, true);
        if (doCompletenessCheck) {
            setCompleteness(null, formData);
        }
    }
}

function hasParentControlActivationOptionChecked(control) {

    if (control.parents('.tt-column-panel').length) {

        if (control.parents('.tt-column').find('.tt-radio-column').find('input[data-activation="1"]').is(':checked')) {
            return true;
        }
        return false;
    } else if (control.parents('.panel-heading').length && control.parents('.tt-accordion-with-radio').length) {

        if (control.parents('.tt-accordion-with-radio').find('.tt-radio-accordion-activation').find('input[data-activation="1"]').is(':checked')) {
            return true;
        }
        return false;
    } else if (control.parents('.tt-accordion-panel-body').length && control.parents('.tt-accordion-panel').find('.tt-radio-accordion').length) {

        if (control.parents('.tt-accordion-panel').find('.tt-radio-accordion').find('input[data-activation="1"]').is(':checked')) {
            return true;
        }
        return false;
    }

    return true;
}

function showQuery() {
    if (!utils.isUndefined(utils.GLOBALS.queryToShow) && utils.GLOBALS.queryToShow !== '') {
        var controlName = utils.GLOBALS.queryToShow;
        var tableType = utils.GLOBALS.queryToShowTableType;
        var tableId = utils.GLOBALS.queryToShowTableId;
        var tableName = utils.GLOBALS.queryToShowTableName;

        if ((tableType === 'period_table' || tableType === 'period_facility_table') && $('[data-database-table-name="' + tableName + '"]').length) {
            var rowId = '';
            if ($('[data-database-table-name="' + tableName + '"]').hasClass('tt-accordion')) {
                var table = $('[data-database-table-name="' + tableName + '"]');
                $(table).find('.tt-accordion-panel').each(function (j, row) {
                    if ($(row).data().dataId === tableId) {
                        rowId = $(row).data().rowId;
                    }
                });
                controlName += '__' + rowId;
                if (!$('[name="' + controlName + '"]').parents('.tt-accordion-panel').find('.tt-accordion-panel-body').hasClass('in')) {
                    openOrCloseAccordionHeader($('[name="' + controlName + '"]'));
                    return;
                }
            } else {
                var dataTable = $('[data-database-table-name="' + tableName + '"]').DataTable();
                for (var l = 0; l < dataTable.data().length; l++) {
                    var row = $(dataTable.row(l).node());
                    if (row.data().dataId === tableId) {
                        rowId = row.data().rowId;
                    }
                }
                dataTable.page.jumpToData(rowId.toString(), 0);
                controlName += '__' + rowId;
            }
        }

        var parentControl = null;
		var course = utils.getCourse();
		var master = utils.getMaster();
        if (master.find('[name="' + controlName + '"],[data-database-table-name="' + tableName + '"]').length) {
            parentControl = master;
        } else {
            parentControl = course;
        }

        setTimeout(function () {
            var queryButton = $(parentControl.find('.tt-btn-query[data-control="' + controlName + '"]')[0]);
            if (utils.isUndefined(queryButton.attr('aria-describedby'))) {
                queryButton.click();
            }
            $('#query_answer_' + controlName).focus();
        }, 700);

        utils.updateGlobals('queryToShow', null);
        utils.updateGlobals('queryToShowTableType', null);
        utils.updateGlobals('queryToShowTableId', null);
        utils.updateGlobals('queryToShowTableName', null);
    }
}

function showTab(tabControl, controlName, parentControl, tableName) {
    var tab = $(tabControl.attr('href'));
    // $.each(tab.parent().find('.tt-doc-pane'), function (i, tabPane) {
    //     if (tabPane.id !== tab[0].id) {
    //         utils.detachTab(tabPane.id);
    //     } else {
		// 	utils.appendTab(tabPane.id);
    //     }
    // });

	if (!tab.hasClass('data-loaded')) {
		var data = [];
		if (isExaminationSelected()) {
			data = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data');
		} else {
			data = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data');
		}

		if (utils.isUndefined(data)) {
			return;
		}

		var isCourseTab = false;
		var isQuestionnaireTab = false;
		var isOwnFacility = true;
		var isLocked = getPatientIsLocked() === 1 ? true : false;
		if (tabControl.parents('#content-detail-course').length || tabControl.parents('#content-detail-questionnaires').length) {
			isOwnFacility = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_facility_id').toString() === getFacilityId().toString();
			isCourseTab = tabControl.parents('#content-detail-course').length > 0;
			isQuestionnaireTab = tabControl.parents('#content-detail-questionnaires').length > 0;
			if (!isLocked) {
				isLocked = !utils.isUndefined($('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_locked'));
			}
		}

		var tab = $(tabControl.attr('href'));
		if (isCourseTab) {
			utils.detachCourse();
		} else if (isQuestionnaireTab) {
            utils.detachQuestionnaire();
		} else {
			utils.detachMaster();
		}
		patients.setData(tab, data, true, false, true, isOwnFacility, false, true, false, true, isLocked)
			.done(function () {
				if (isCourseTab) {
					utils.appendCourse();
				} else if (isQuestionnaireTab) {
					utils.appendQuestionnaire();
				} else {
					utils.appendMaster();
				}
				if (!utils.isUndefined(controlName)) {
					var accordionPanel = $(parentControl.find('[name="' + controlName + '"]')[0]).parents('.tt-accordion-panel-body');
					if (accordionPanel.length && !accordionPanel.hasClass('in')) {
						openOrCloseAccordionHeader($('[href="#' + accordionPanel[0].id + '"]'));
					} else {
						showQuery();
					}
					$(parentControl.find('[name="' + controlName + '"]')[0]).focus();
				}
			});
	} else {
		if (!utils.isUndefined(controlName)) {
			var accordionPanel = $(parentControl.find('[name="' + controlName + '"]')[0]).parents('.tt-accordion-panel-body');
			if (accordionPanel.length && !accordionPanel.hasClass('in')) {
				openOrCloseAccordionHeader($('[href="#' + accordionPanel[0].id + '"]'));
			} else {
				// Nur für Aufruf aus Vollständigkeitsliste
				if (controlName.indexOf('__') >= 0 && !$('[data-database-table-name="' + tableName + '"]').hasClass('tt-accordion')) {
					var dataTable = $('[data-database-table-name="' + tableName + '"]').DataTable();
					dataTable.page.jumpToData(controlName.substr(controlName.indexOf('__') + 2), 0);
				}
				showQuery();
			}
			$(parentControl.find('[name="' + controlName + '"]')[0]).focus();
		}
	}
}

function showColumn(columnPanel, column, setData) {

	var elementsWithIntegrity = [];
	jQuery.each(columnPanel.find('[name]'), function(i, control) {
		var currentName = control.name;
		var newName = currentName;
		if (/_spalte_[0-9]$/.test(newName)) {
			if (column == 1) {
				newName = newName.substr(0, newName.lastIndexOf('_spalte_'));
			} else {
				newName = newName.substr(0, newName.lastIndexOf('_spalte_')) + '_spalte_' + column;
			}
		} else {
			if (column == 1) {
				newName = currentName;
			} else {
				newName += '_spalte_' + column;
			}
		}
		if (newName !== currentName) {
			$(control).attr('name', newName);
			jQuery.each(columnPanel.find('[data-control="' + currentName + '"]'), function (i, additionalControl) {
				$(additionalControl).attr('data-control', newName);
			});
		}
		if ($(columnPanel).find('[name="' + newName + '"]').length && $(columnPanel).find('[name="' + newName + '"]').hasClass('tt-check-integrity')) {
			elementsWithIntegrity.push($(columnPanel).find('[name="' + newName + '"]'));
		}
	});

	if (!setData) {
		return;
	}

	var data = [];
	if (isExaminationSelected()) {
		data = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_form_data');
	} else {
		data = $('.tt-nav-content-article').find('.tt-selected-id').data('patient_form_data');
	}

	if (utils.isUndefined(data)) {
		return;
	}

	var isLocked = getPatientIsLocked() === 1 ? true : false;
	var isOwnFacility = true;
	if (columnPanel.parents('#content-detail-course').length || columnPanel.parents('#content-detail-questionnaires').length) {
		isOwnFacility = $('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_facility_id').toString() === getFacilityId().toString();
		if (!isLocked) {
			isLocked = !utils.isUndefined($('.tt-nav-content-article').find('.tt-selected-examination-id').data('examination_locked'));
		}
	}

	patients.setData(columnPanel, data, true, false, true, isOwnFacility, false, true, true, false, isLocked);
	// Integritätsprüfung hier separat aufrufen, da diese über setData nicht ausgeführt wird
	addToIntegrityList(elementsWithIntegrity, true, false);
}

function openOrCloseAccordionHeader(control) {
    if (!control.parents('.tt-accordion-panel').find('.tt-accordion-panel-body').hasClass('in')) {
        control.parents('.tt-accordion').find('.tt-accordion-panel-body.in').collapse('toggle');
        control.parents('.tt-accordion').find('.tt-accordion-header').addClass('collapsed');
        control.parents('.tt-accordion-panel').find('.tt-accordion-header').removeClass('collapsed');
    } else {
        control.parents('.tt-accordion-panel').find('.tt-accordion-header').addClass('collapsed');
    }
    control.parents('.tt-accordion-panel').find('.tt-accordion-panel-body').collapse('toggle');
}

function setCaveLabel(element, data) {
    var caveLabel = element.parents('[class^="tt-rightclass-"]').find('[data-control-name-cave-text="' + element.attr('name') + '"]');
    caveLabel.removeClass('tt-bold').removeClass('tt-underline').removeClass('tt-italic').addClass('hide');
    caveLabel.text('');
    if (!utils.isUndefined(data.caveText) && data.caveText !== '') {
        var text = $('<div>').text(data.caveText).html().replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
        caveLabel.html(text);
        caveLabel.css('color', data.caveTextColor);
        var formatting = data.caveTextFormatting.split('|');
        jQuery.each(formatting, function (i, format) {
            if (format.length) {
                caveLabel.addClass('tt-' + format);
            }
        });
        caveLabel.removeClass('hide');
    }
}

function resetCaveLabel(element) {

    var caveLabel = element.parents('[class^="tt-rightclass-"]').find('[data-control-name-cave-text="' + element.attr('name') + '"]');
    caveLabel.removeClass('tt-bold').removeClass('tt-underline').removeClass('tt-italic').addClass('hide');
    caveLabel.text('');
}

module.exports.registerViewEvents = registerViewEvents;
module.exports.setSubControlsEnabled = setSubControlsEnabled;
module.exports.setSubControlsEnabledForCheckBox = setSubControlsEnabledForCheckBox;
module.exports.setSubControlsEnabledForRadioButton = setSubControlsEnabledForRadioButton;
module.exports.setControlValue = setControlValue;
module.exports.getControlValue = getControlValue;
module.exports.resetControl = resetControl;
module.exports.checkIntegrity = checkIntegrity;
module.exports.calculateValues = calculateValues;
module.exports.setCompleteness = setCompleteness;
module.exports.addListEntry = addListEntry;
module.exports.addAccordionGroup = addAccordionGroup;
module.exports.getFacilityId = getFacilityId;
module.exports.getFacilityDisplayName = getFacilityDisplayName;
module.exports.getModelId = getModelId;
module.exports.getQuestionnaires = getQuestionnaires;
module.exports.getCompletenessNotification = getCompletenessNotification;
module.exports.getPatientId = getPatientId;
module.exports.getPatientIsActive = getPatientIsActive;
module.exports.getPatientIsLocked = getPatientIsLocked;
module.exports.getExaminationDate = getExaminationDate;
module.exports.getExaminationId = getExaminationId;
module.exports.setControlEnabled = setControlEnabled;
module.exports.setAccordionControlsEnabled = setAccordionControlsEnabled;
module.exports.setValues = setValues;
module.exports.setColumnControlsEnabled = setColumnControlsEnabled;
module.exports.setPatientDisplayName = setPatientDisplayName;
module.exports.getIntegrityText = getIntegrityText;
module.exports.addTableNamesToData = addTableNamesToData;
module.exports.getFormDataForAjaxCall = getFormDataForAjaxCall;
module.exports.setFormDataForAjaxCall = setFormDataForAjaxCall;
module.exports.isExaminationSelected = isExaminationSelected;
module.exports.isDevice = isDevice;
module.exports.blurDatepicker = blurDatepicker;
module.exports.showQuery = showQuery;
module.exports.showTab = showTab;
module.exports.setTransferData = setTransferData;
module.exports.getPatientDisplayName = getPatientDisplayName;
module.exports.showColumn = showColumn;
